/* eslint-disable quotes */
/* eslint-disable max-len */

export default {
  embark: 'Embark',
  'csmWidget.header1.p1': 'Top schools',
  'csmWidget.header1.p2': 'for every',
  'csmWidget.header1.p3': 'dream career',
  'csmWidget.header1.p4': ' - search now!',
  'csmWidget.text': 'Find schools and careers today!',
  'careerSearchbar.placeholder': 'Search for careers...',
  'searchbar.nothingHere':
    'Hmm... aucune correspondance trouvée. Essayer une autre carrière?',
  embarkStudentCorp: 'Embark étudiant corp.',
  'home.footerCopyrightSymbol': '©',
  'home.footerAllRightsReserved': 'Tous droits réservés.',
  'home.footerTrademarkText':
    "Embark est une marque de commerce d'Embark Student Corp.",
  'outage.title': 'Nous serons bientôt de retour en ligne.',
  'outage.message':
    'Notre site est actuellement fermé pour cause de maintenance. Des mises à niveau passionnantes arrivent !',
  register: "S'inscrire",
  continue: 'Continuer',
  next: 'Suivante',
  send: 'Envoyer',
  retry: 'Refaire',
  done: 'Terminé',
  copy: 'Copie',
  copied: 'Copié !',
  cancel: 'Annuler',
  update: 'Mise à jour',
  skip: 'Sauter',
  and: 'et',
  note: 'Noter:',
  his: 'son',
  her: 'son',
  their: 'leur',
  on: 'sur',
  is: 'est',
  disagree: 'être en désaccord',
  decline: 'Refuser',
  name: 'Nom',
  change: 'Modifier',
  remove: 'Supprimer',
  noKeep: 'Non, conserver',
  yesRemove: 'Oui, supprimer',
  share: 'Partager',
  getStarted: 'Commencer',
  confirmRemove: 'Êtes-vous certain de vouloir supprimer ce document ?',
  'giftDetails.title': 'Montant du don',
  'giftDetails.banner.title': 'Combien voulez-vous offrir ?',
  'giftDetails.banner.description':
    'Choisissez le montant que vous souhaitez envoyer. Vous pouvez faire un don d’aussi peu que 25 $, jusqu’à concurrence de 2 500 $.',
  'giftDetails.amount.input.label': 'Quel est le montant de votre don ?',
  'giftDetails.amount.input.textFieldLabel': 'Sur mesure',
  'giftDetails.message.input.label': 'Ajouter un message (facultatif)',
  'giftDetails.message.input.placeholder':
    'Un petit quelque chose pour vous. Bonne chance et succès!',
  'giftDetails.about.label': 'Envoyez-lui une note-cadeau',
  'giftDetails.about.description':
    'Lisez-la en sachant que vous pensez à lui avec un message personnalisé.',
  'giftDetails.options.custom': 'Sur mesure',
  'giftDetails.error.amountEmpty':
    'Veuillez choisir une option pour continuer.',
  'giftDetails.error.amountUnderMin': 'Inscrivez un minimum de 25 $.',
  'giftDetails.error.amountOverMax': 'Inscrivez un minimum de 2 500 $.',
  'giftDetails.error.exceededMaximumCharacter':
    'La note-cadeau doit être de 1 000 caractères ou moins.',
  'giftDetails.error.allFieldsRequired':
    'Veuillez fournir plus de détails pour continuer.',
  'giftCompliance.title': 'Nous avons besoin de quelques détails',
  'giftCompliance.banner.title': 'Votre relation',
  'giftCompliance.banner.description':
    'Nous vous demandons ces renseignements afin de nous assurer que nous respectons les lignes directrices gouvernementales relatives aux régimes enregistrés d’épargne-études (REEE).',
  'giftCompliance.relationship.heading':
    'Quelle est votre relation avec l’enfant',
  'giftCompliance.relationship.dropdown.label': 'Relation',
  'giftCompliance.relationship.dropdown.grandparent': 'Grand-parent',
  'giftCompliance.relationship.dropdown.aunt': 'Tante',
  'giftCompliance.relationship.dropdown.uncle': 'Oncle',
  'giftCompliance.relationship.dropdown.sibling': 'Frère ou sœur',
  'giftCompliance.relationship.dropdown.parent': 'Parent',
  'giftCompliance.relationship.dropdown.notRelated': 'Aucun lien de parenté',
  'giftCompliance.relationship.dropdown.other': 'Autre',
  'giftCompliance.error.noRelationship': 'Veuillez sélectionner la relation.',
  'giftOccasion.title': 'Sélectionnez une occasion',
  'giftOccasion.header': 'S’agit-il d’un événement spécial?',
  'giftOccasion.header.imgAlt': 'fête popper',
  'giftOccasion.body':
    'Les cadeaux ajoutent à l’excitation de toute occasion! Choisissez un événement que vous célébrez.',
  'giftOccasion.listHeader': 'Occasions de cadeaux',
  'giftOccasion.lunarNewYear.label': 'Nouvelle année lunaire',
  'giftOccasion.congratulations.label': 'Félicitations',
  'giftOccasion.birthday.label': 'Anniversaire',
  'giftOccasion.gift.label': 'Embarquer un cadeau',
  'giftOccasion.lunarNewYear.imgAlt': 'Enveloppe rouge',
  'giftOccasion.congratulations.imgAlt': 'Trophée',
  'giftOccasion.birthday.imgAlt': "Gâteau d'anniversaire",
  'giftOccasion.gift.imgAlt': 'Coffret cadeau',
  'giftOccasion.brithdaygGiftCard.label': 'Joyeux anniversaire',
  'giftOccasion.congratsGiftCard.label': 'Félicitations',
  'giftOccasion.lunarNewYearGiftCard.label': 'Nouvelle année lunaire',
  'giftOccasion.brithdaygGiftCard.imgAlt': "gâteau d'anniversaire",
  'giftOccasion.congratsGiftCard.imgAlt': 'Trophée',
  'giftOccasion.lunarNewYearGiftCard.imgAlt': 'Enveloppe rouge',
  'giftError.title.expired': 'Quelque chose ne va pas',
  'giftError.description.expired':
    'Il semble que ce lien avec Embark soit expiré. Demandez au client de créer un nouveau lien.',
  facebook: 'Facebook',
  x: 'X',
  whatsApp: 'WhatsApp',
  reddit: 'Reddit',
  linkedIn: 'LinkedIn',
  'img.alt.annulus': "Une forme d'anneau coupée en deux",
  'img.alt.schoolPin': "Icône d'un capuchon de graduation",
  'img.alt.clippedSquarePattern': 'Petit carré',
  'img.alt.smallCirclePattern': 'Petit cercle',
  'img.alt.extraLargeCirclePattern': 'cercle très grand',
  'img.alt.professionsSearchRocketTelescope':
    "Illustration d'une personne bleue regardant à travers un télescope portant un jetpack",
  'img.alt.largeCirclePattern': 'Grand cercle',
  'img.alt.halfCirclePattern': 'Demi cercle',
  'img.alt.diamondPattern': 'Diamant',
  'img.alt.noSearchOptionsIllustration':
    "Illustration d'une antenne ne recevant aucun signal",
  'img.alt.professionsSearchIllustration':
    "Illustration d'une personne bleue naviguant sur Internet",
  'img.alt.emailIcon': 'Email',
  'img.alt.searchIcon': 'Recherche',
  'img.alt.closeIcon': 'Fermer',
  'img.alt.arrowBackIcon': 'Flèche arrière',
  'img.alt.programScholarIcon':
    'Icône de la loupe de fouille à travers du papier',
  'img.alt.sinDrivingLicense': 'Permis de conduire NAS',
  'img.alt.successIcon': 'Icône de réussite',
  'img.alt.apolloIcon': "Icône de l'entreprise Apollo",
  'img.alt.youthfullyIcon': "Icône de l'entreprise Youthfully",
  'img.alt.willfulIcon': "Icône de l'entreprise Willful",
  'img.alt.borrowellIcon': "Icône de l'entreprise de Borrowell",
  'img.alt.neoFinancialIcon': "Icône de l'entreprise de NeoFinancial",
  'img.alt.policyMe': "Icône de l'entreprise de Assure Moi",
  'img.alt.facebookIcon': "Icône de l'entreprise de Facebook",
  'img.alt.xIcon': "Icône de l'entreprise de X",
  'img.alt.whatsAppIcon': "Icône de l'entreprise de WhatsApp",
  'img.alt.redditIcon': "Icône de l'entreprise de Reddit",
  'img.alt.linkedInIcon': "Icône de l'entreprise de LinkedIn",
  'img.alt.specialization': 'Notifier',
  'img.alt.btnPlusIcon': 'Icône Plus',
  'img.alt.btnTransferIcon': 'Icône de transfert',
  'img.alt.trendingUpIcon': 'Tendance à la hausse',
  'img.alt.iq.yellowArrow': 'flèche jaune sans queue',
  'img.alt.iq.thumbsUp': 'Bravo',
  'img.alt.iq.thumbsDown': 'Pouce vers le bas',
  'img.alt.giftLinkError': 'Erreur de liaison',
  'img.alt.giftCircle': 'Petite boîte actuelle',
  'gifting.about.headerOne': 'Vous avez été invité à faire un don au REEE de',
  'gifting.about.headerTwo': 'RESP',
  'gifting.about.bodyOne': 'Votre don au REEE de',
  'gifting.about.bodyTwo':
    'jouera un rôle crucial dans la construction de son avenir. Il soutiendra leurs aspirations en matière d’éducation et leur donnera les moyens de réaliser leurs rêves.',
  'gifting.about.button': 'Cadeau maintenant',
  'gifting.list.header': 'À propos d’Embark Gifting',
  'gifting.list.one.header': 'Embark Gifting est sûr et sécurisé.',
  'gifting.list.one.body':
    ' Vous pouvez faire des dons en toute sécurité et en toute commodité en utilisant des cartes de crédit, Apple Pay et Google Pay. Tout est crypté et sécuritaire.',
  'gifting.list.two.header': 'Un cadeau qui ne s’oublie pas',
  'gifting.list.two.body':
    'Vous pouvez faire un don d’un montant maximal de 2 500 $, qui peut donner droit à 20 % de subventions gouvernementales supplémentaires. Votre don est grandement apprécié; toutefois, veuillez noter qu’il ne s’agit pas d’un don et qu’il n’est pas admissible aux reçus aux fins de l’impôt.',
  'gifting.list.one.bodyTwo':
    'Pour l’instant, nous n’acceptons que les paiements canadiens.',
  'gifting.list.three.header': 'Votre relation',
  'gifting.list.three.body':
    'Nous devons vous poser quelques questions sur votre relation avec le bénéficiaire du cadeau afin de nous conformer aux réglementations gouvernementales.',
  'gifting.about.terms.body':
    'En envoyant un cadeau à un enfant d’Embark, vous acceptez les',
  'gifting.about.terms.link': 'conditions générales.',
  'gifting.about.terms.alt': 'redirect icon',
  'gifting.review.header': 'Passons rapidement en revue',
  'gifting.review.name': 'Récipiendaire du cadeau de Embark :',
  'gifting.review.amount': 'Montant du cadeau du REEE de Embark :',
  'gifting.review.processingFee': 'Frais de traitement :',
  'gifting.review.total': 'Total facturé :',
  'gifting.review.message': 'Message du cadeau:',
  'gifting.review.button': 'Payer et envoyer des cadeaux',
  'gifting.review.dialog.header': 'Frais de traitement',
  'gifting.review.dialog.body':
    "La banque qui émet la carte de paiement exige des frais pour le service de traitement de l'opération. Nous faisons de notre mieux pour qu'ils demeurent aussi bas que possible.",
  'footer.rightsReserved': 'Tous droits réservés.',
  'footer.trademarkLine2':
    "Embark est une marque commerciale d'Embark Student Corp.",
  'networkError.title':
    'Quelque chose ne va pas. Veuillez réessayer plus tard.',
  'gifting.success.header': 'Votre don REEE Embark a été envoyé!',
  'gifting.success.header.lunarNewYear.one': 'Votre ',
  'gifting.success.header.lunarNewYear.two':
    'enveloppe numérique porte-bonheur ',
  'gifting.success.header.lunarNewYear.three': 'du REEE Embark a été envoyée!',
  'gifting.success.body':
    'Vous recevrez un reçu dans votre boîte de réception et nous aviserons le client d’Embark que votre cadeau est en route!',
  'gifting.success.button': 'Fait',
  key: 'value',
  'home.footerCopyrightText': 'Embark étudiant corp.',
  'home.signIn': 'Se connecter',
  'home.signIn.embark': 'Se connecter à Embark',
  'home.signUp.note': "Vous n'avez pas de compte ? ",
  'home.signUp': "S'inscrire",
  'home.embarkSignin.title': "Que voudrais tu faire aujourd'hui?",
  'home.embarkSignin.title1': 'Se connecter aux Régimes\n  étudiants ',
  'home.embarkSignin.title2': ' Embark ',
  'home.embarkSignin.title3': '',
  'home.embarkSignin.label':
    'Accédez à votre tableau de bord, gérez les cotisations ou faites un retrait pour l’éducation de votre enfant.',
  'home.embarkSignin.note1': 'Régimes REEE Embark ouverts ',
  'home.embarkSignin.note2': 'à compter de mars 2023.',
  'home.flexFirstSignin.title1': 'Se connecter aux régimes',
  'home.flexFirstSignin.title2': 'gérés auparavant par',
  'home.flexFirstSignin.title3': 'La Première financière du savoir',
  'home.flexFirstSignin.note1': 'Régime de REEE ouverts de ',
  'home.flexFirstSignin.note2': '1995 à février 2023.',
  'home.footerHeader': 'Prix étudiants',
  'home.about': 'Sur',
  'home.privacy': 'Intimité',
  'home.terms': 'Conditions',
  'textfield.inputError': "Erreur d'entrée",
  'textfield.passwordVisibility': 'Visibilité du mot de passe',
  'textfield.showPassword': 'Montrer le mot de passe',
  'textfield.hidePassword': 'Masquer le mot de passe',
  'textfield.clearInput': 'Effacer le texte',
  'textfield.cancelInput': 'Bouton Retiré',
  allRequiredErrorMessage:
    'Veuillez indiquer tous les renseignements pour continuer.',
  login: 'Connexion',
  'login.title':
    'Connectez-vous avec vos connaissances First Financial Connexion pour commencer',
  'login.sessionTimedOut': 'session expirée',
  'login.resetPassword': 'Réinitialiser le mot de passe',
  'login.invalidAzureUrlParams':
    'Un problème est survenu lors de la vérification de votre compte Microsoft',
  signUp: 'Je m’inscris',
  projectedSavings: 'Projection de l’épargne',
  estimateGrowth: 'Croissance estimée',
  educationAverageCost: "Coût moyen de l'éducation",
  'educationAverageCost.description':
    "Cette valeur est fondée sur les données publiées par Emploi et Développement social Canada (EDSC) sur la base de données de la Collection d'établissements postsecondaires canadiens (CÉP). Ces informations, y compris celles concernant les droits de scolarité, sont mises à jour chaque année par EDSC et sont susceptibles d'être modifiées.",
  projectedRateReturn: 'Projection du taux de rendement',
  'projectedRateReturn.description':
    'Toutes les projections sont fournies à titre indicatif uniquement et ne représentent pas les résultats réels. Les taux de rendement indiquent le revenu que vous pourriez gagner dans votre REEE et ne constituent pas un indicateur ni une garantie de la performance future.',
  'onboarding.genderInfo':
    'Veuillez vous assurer que le sexe choisi correspond aux renseignements sur le NAS du bénéficiaire.',
  'onboarding.title': 'OUVRIR UN COMPTE REEE',
  'onboardingGateway.headline': 'Avant de commencer',
  'onboardingGateway.description':
    'Voici quelques critères importants pour se lancer :',
  'onboardingGateway.requirementsTitle1':
    'Assurez-vous d’avoir l’une des pièces d’identité valides suivantes à portée de main :',
  'onboardingGateway.requirementsTitle2': 'Vous devez :',
  'onboardingGateway.requirementItem1': 'Permis de conduire',
  'onboardingGateway.requirementItem2': 'Passeport',
  'onboardingGateway.requirementItem3': 'Carte de résident permanent',
  'onboardingGateway.requirementItem4': 'Être un parent ou un grand-parent',
  'onboardingGateway.requirementItem5': 'Avoir 18 ans ou plus',
  'onboardingGateway.checkboxLabel': 'Je confirme avoir les NAS requis',
  'onboardingGateway.estimatedTime': 'Temps estimé : 10 à 15 minutes',
  'onboardingGateway.moreInfo': 'Des informations supplémentaires?',
  'onboardingGateway.withOurTeam': 'sans équipe.',
  'onboardingGateway.dialogContent':
    'Vous rejoignez un plan étudiant Embark en tant que co-souscripteur.',
  'onboardingStart.headline': 'Bienvenue chez Embark!',
  'onboardingStart.welcomeText':
    'Nous sommes ravis de vous accueillir parmi nous. Nous sommes prêts à vous aider à faire vos premiers pas pour épargner en vue des études de votre enfant!',
  'onboardingStart.requirementsHeader1': 'Informations à garder sous la main',
  'onboardingStart.requirementsHeader2':
    'Aperçu rapide des informations importantes et des exigences.',
  'onboardingStart.description':
    "Voici ce que vous devrez postuler. Nous vous égalerons avec le bon plan pour l'avenir de votre enfant avec ces informations.",
  'onboardingStart.requirement1': 'Vous devez :',
  'onboardingStart.requirement2': 'Vous aurez besoin de ce qui suit :',
  'onboardingStart.requirement3':
    "Accès à la caméra de l'appareil et pièce d'identité valide émise par le gouvernement, pour une vérification d'identité en temps réel",
  'onboardingStart.requirementItem1': 'Être un parent ou un grand-parent',
  'onboardingStart.requirementItem2': 'Avoir 18 ans ou plus',
  'onboardingStart.requirementItem3': 'Être un résident canadien',
  'onboardingStart.requirementItem4': 'Un numéro d’assurance sociale (NAS)',
  'onboardingStart.requirementItem5':
    'valide pour vous et votre enfant, conformément aux exigences de l’ARC',
  'onboardingStart.requirementItem6':
    'Des renseignements personnels sur vous et l’enfant (ou les enfants)',
  'onboardingStart.requirementItem7':
    "S'il y a lieu, l’adresse électronique et le nom légal du cosouscripteur",
  'onboardingStart.estimatedTime': 'Temps estimé 10-15 minutes.',
  'onboardingStart.startNow': 'Ouvrir un REEE',
  'onboardingStart.hasSIN':
    "Je confirme que j'ai mon NAS et le NAS de mon enfant",
  subscriberProfileSetup: "Configuration du profil de l'abonné",
  'onboardingBeneficiaries.headline':
    'Combien d’enfants ajoutez-vous à votre forfait Embark?',
  'onboardingBeneficiaries.label': 'Configuration du profil du bénéficiaire',
  'onboardingBeneficiaries.description':
    "Vous pourrez ajouter des bénéficiaires supplémentaires plus tard, tant qu'ils sont tous des frères et sœurs.",
  'onboardingBeneficiaries.dropdownLabel': 'Nombre d’enfants',
  'onboardingBeneficiaries.dropdownError':
    'Veuillez sélectionner le nombre d’enfants à ajouter.',
  'onboardingBeneficiarySIN.label': 'Profil de l’enfant',
  'onboardingBeneficiarySIN.headlinePart1':
    'Quel est le numéro d’assurance sociale (NAS) de',
  'onboardingBeneficiarySIN.headlinePart2': '?',
  'onboardingBeneficiarySIN.descriptionPart1': 'Nous avons besoin du NAS de',
  'onboardingBeneficiarySIN.descriptionPart2':
    'pour demander toutes les subventions gouvernementales applicables en votre nom.',
  'onboardingBeneficiarySIN.info':
    'Nous recueillons ces renseignements conformément aux lignes directrices de l’ARC. Toutes vos données sont sécurisées et chiffrées.',
  'onboardingBeneficiarySIN.infoGuide1':
    'Vous n’avez pas de numéro d’assurance sociale?',
  'onboardingBeneficiarySIN.infoGuide2': 'Voici comment obtenir ce numéro.',
  'onboardingBeneficiarySIN.infoGuideLink':
    'https://www.canada.ca/fr/emploi-developpement-social/services/numero-assurance-sociale/demande.html',
  'onboardingBeneficiarySIN.grantsHeadline':
    'Vous pourriez avoir droit à des subventions gouvernementales!',
  'onboardingBeneficiarySIN.grantsDescription':
    'Selon les renseignements que vous nous avez fournis, vous pourriez être admissible aux subventions fédérales et provinciales suivantes.',
  'onboardingBeneficiarySIN.grantsListTitle':
    'Vous n’avez aucune démarche à faire. Nous nous occupons de demander ces subventions pour vous.',
  'onboardingBeneficiarySIN.grantNoteDescription':
    'Chaque enfant est admissible aux subventions gouvernementales applicables. Les subventions gouvernementales sont susceptibles de changer sans préavis.',
  'onboardingBeneficiarySIN.descriptionCESG':
    'Jusqu’à 500 $ par année par enfant',
  'onboardingBeneficiarySIN.descriptionACESG':
    'Jusqu’à 100 $ par année par enfant',
  'onboardingBeneficiarySIN.descriptionCLB': "Jusqu'à 2000 $ à vie par enfant",
  'onboardingBeneficiarySIN.descriptionBCTESG':
    'Un versement unique de 1200 $ par enfant',
  'onboardingBeneficiarySIN.SINRequiredError':
    'Veuillez indiquer le numéro d’assurance sociale de l’enfant.',
  'onboardingPersonalInfo.headline': 'Vos renseignements personnels',
  'onboardingPersonalInfo.governmentName':
    "Prénom figurant sur votre pièce d'identité délivrée par le gouvernement.",
  'onboardingSIN.alt': 'Icône de notification',
  'onboardingSIN.headline':
    "Aux fins de l'impôt et des subventions, nous avons besoin que votre NAS soit inclus dans le régime REEE.",
  'onboardingSIN.description':
    'Nous avons besoin de votre NAS afin d’enregistrer votre régime auprès de l’ARC pour des raisons fiscales et pour permettre à votre bénéficiaire de recevoir les subventions du gouvernement.',
  'onboardingSIN.note':
    'Les organismes de réglementation canadiens exigent que nous recueillions ces renseignements dans le cadre de nos obligations de connaissance du client. Vos données sont en sécurité et ne seront jamais partagées par Embark.',
  'onboardingSIN.noteHeader': 'Vous n’avez pas de numéro d’assurance sociale?',
  'onboardingSIN.link':
    'https://www.canada.ca/fr/emploi-developpement-social/services/numero-assurance-sociale/demande.html',
  'onboardingSIN.howToGetOne': 'Voici comment obtenir ce numéro.',
  'onboardingChildsDetails.headline': 'Pour qui épargnez-vous?',
  'onboardingChildsDetails.headlineFirst':
    'Renseignements sur le premier enfant',
  'onboardingChildsDetails.headlineSecond':
    'Renseignements sur le deuxième enfant',
  'onboardingChildsDetails.headlineThird':
    'Renseignements sur le troisième enfant',
  'onboardingChildsDetails.headlineFourth':
    'Renseignements sur le quatrième enfant',
  'onboardingChildsDetails.relationshipHeadline':
    'Quel est votre lien de parenté?',
  'onboardingChildRelationship.isCustodialParent': 'L’enfant vit-il avec vous?',
  'onboardingChildRelationship.custodialParentTrue':
    'Oui, je suis le responsable principal',
  'onboardingChildRelationship.custodialParentFalse':
    'Non, je ne suis pas le responsable principal',
  'onboardingChildsDetails.label': 'Profil de l’enfant',
  'onboardingChildsDetails.nameHelper':
    'Prénom qui figure sur son acte de naissance ou son numéro d’assurance sociale.',
  'onboardingChildsDetails.addressHelperText':
    'Adresse pour le bénéficiaire (sinon la même chose que celle des abonnés).',
  'onboardingChildsDetails.addressError':
    'Veuillez saisir une adresse valide pour le bénéficiaire (sinon la même que celle des abonnés).',
  'onboardingMaritalStatus.label': 'Statut matrimonial',
  'onboardingMaritalStatus.headline': 'Quel est votre état matrimonial?',
  'onboardingReviewRESPSection.headline': 'Qui ouvre ce REEE?',
  'onboardingReviewSINSection.SIN':
    "Quel est votre numéro d'assurance sociale ?",
  'onboardingReviewEmploymentStatus.headline':
    'Quelle est votre situation d’emploi?',
  'onboardingReviewRelationshipSection.title': 'Lien de parenté',
  'onboardingReviewRelationshipSection.relationship1':
    'Quelle est votre relation avec ',
  'onboardingReviewRelationshipSection.relationship2': '?',
  'onboardingReviewRelationshipSection.iconAlt': 'Relation',
  'maritalStatus.single': 'Célibataire',
  'maritalStatus.married': 'Marié',
  'maritalStatus.divorced': 'Divorcé',
  'maritalStatus.widowed': 'Veuf',
  'maritalStatus.separated': 'Séparé',
  'maritalStatus.domestic': 'Droit interne/common law',
  'onboardingEmploymentStatus.label': "Statut d'emploi",
  'onboardingEmploymentStatus.headline': 'Votre situation professionnelle',
  'onboardingEmploymentStatus.header':
    'Quelle est votre situation d’emploi actuelle?',
  'employmentStatus.self-employed': 'Travailleur autonome',
  'employmentStatus.employed': 'Employé (à temps plein ou à temps partiel)',
  'employmentStatus.unemployed': 'Sans emploi',
  'employmentStatus.retired': 'Retraité ou pensionné',
  'employmentStatus.student': 'Étudiant',
  'employmentStatus.other': "Gagner d'autres revenus",
  'onboardingEmploymentStatus.jobTitleLabel':
    'Quel est l’intitulé de votre emploi?',
  'onboardingInvestingExperience.label': "Expérience d'investissement",
  'onboardingInvestingExperience.headline':
    'Quelle est votre expérience en matière d’investissement dans des actions, des obligations et des fonds communs de placement?',
  'investingExperience.lowOption':
    'Moins d’un an d’expérience en investissement',
  'investingExperience.mediumOption':
    'Entre deux et cinq ans d’expérience en investissement',
  'investingExperience.highOption':
    'Plus de cinq ans d’expérience en investissement',
  'onboardingRiskTolerance.label': 'Tolérance au risque',
  'onboardingRiskTolerance.headline':
    'Comment évalueriez-vous votre tolérance au risque ?',
  'onboardingRiskTolerance.header': "Vous vous demandez ce que c'est ?",
  'onboardingRiskTolerance.description':
    "La tolérance au risque est votre volonté de prendre des décisions d'investissement en évaluant le risque de perte par rapport à la perspective de rendements reçus. Plus le risque est élevé, plus la probabilité de rendement à long terme est grande.",
  'riskTolerance.lowOption': 'Bas',
  'riskTolerance.lowMediumOption': 'Bas-Moyen',
  'riskTolerance.mediumOption': 'Moyen',
  'riskTolerance.mediumHighOption': 'Moyen-élevé',
  'riskTolerance.highOption': 'Haut',
  'riskTolerance.lowDescription':
    ' (Vous voulez éviter complètement les pertes.)',
  'riskTolerance.lowMediumDescription':
    " (Confortable d'accepter un niveau de volatilité faible à moyen pour rechercher un certain degré de croissance ou de revenu de mes investissements)",
  'riskTolerance.mediumDescription':
    " (Prêt à accepter un niveau modéré de volatilité pour m'assurer d'équilibrer mes pertes avec des rendements)",
  'riskTolerance.mediumHighDescription':
    " (À l'aise avec les fluctuations à court et moyen termes en échange d'une croissance des investissements à long terme)",
  'riskTolerance.highDescription':
    " (Prêt à risquer la probabilité d'une perte pour maximiser mes rendements)",
  'riskCapacity.lowOption': 'Bas',
  'riskCapacity.lowMediumOption': 'Bas-Moyen',
  'riskCapacity.mediumOption': 'Moyen',
  'riskCapacity.mediumHighOption': 'Moyen-élevé',
  'riskCapacity.highOption': 'Haut',
  'riskCapacity.lowDescription':
    ' (Capable de supporter un faible niveau de volatilité au sein de mes investissements et de rechercher des rendements inférieurs pour une plus grande sécurité de mon capital)',
  'riskCapacity.lowMediumDescription':
    " (Capable d'accepter un niveau de volatilité faible à moyen dans mes investissements et de rechercher des rendements inférieurs sur une plus longue période)",
  'riskCapacity.mediumDescription':
    " (Capable d'accepter un niveau modéré de volatilité au sein de mes investissements et de rechercher un niveau modéré de croissance sur une plus longue période)",
  'riskCapacity.mediumHighDescription':
    " (Capable d'accepter un niveau de volatilité moyen à élevé au sein de mes investissements et de rechercher un niveau de croissance plus élevé sur une plus longue période)",
  'riskCapacity.highDescription':
    " (Capable d'accepter un degré élevé de volatilité et d'importantes fluctuations à court terme de la valeur du portefeuille en échange de rendements à long terme potentiellement plus élevés)",
  'onboardingRiskCapacity.label': 'Capacité de risque',
  'onboardingRiskCapacity.headline': 'Quelle est votre capacité de risque ?',
  'onboardingRiskCapacity.header': "Vous vous demandez ce que c'est ?",
  'onboardingRiskCapacity.description':
    "La capacité de risque est votre capacité financière à prendre des risques, en fonction de facteurs tels que votre situation financière, votre revenu, votre âge et le temps dont vous disposez pour atteindre vos objectifs d'épargne.\n   Plus le risque est élevé, plus la probabilité de rendement à long terme est grande.",
  'onboardingHouseholdNetWorth.label1': "Total de l'actifs",
  'onboardingHouseholdNetWorth.label2': 'Total des passifs',
  'onboardingHouseholdNetWorth.headline1':
    'Quel est le montant total estimé de votre actif et de votre passif?',
  'onboardingHouseholdNetWorth.header1':
    'Quel est votre actif total estimatif?',
  'onboardingHouseholdNetWorth.description1':
    'Valeur totale des titres et fonds que vous possédez sur vos comptes (chèques, épargne, retraite, titres) et de vos biens immobiliers.',
  'onboardingAnnualIncome.error': 'Veuillez saisir votre revenu brut.',
  'onboardingHouseholdNetWorth.error1':
    'Veuillez indiquer le montant total de vos actifs.',
  'onboardingHouseholdNetWorth.header2':
    'Quel est votre passif total estimatif?',
  'onboardingHouseholdNetWorth.description2':
    'Valeur totale de vos dettes, y compris les prêts personnels, les cartes de crédit, les prêts étudiants, les impayés d’impôts et les hypothèques.',
  'onboardingHouseholdNetWorth.error2': 'Veuillez entrer votre passif total.',
  'onboardingHouseholdNetWorth.tooltip1': 'Lorem ipsum dolor sit amet',
  'onboardingHouseholdNetWorth.headline2':
    'Quelle part de la valeur nette ci-dessus peut être convertie en espèces?',
  'onboardingHouseholdNetWorth.tooltip2': 'Lorem ipsum dolor sit amet',
  'onboardingAnnualIncome.label': 'Revenu annuel',
  'onboardingAnnualIncome.headline': 'Quel est votre revenu brut estimé?',
  'onboardingAnnualIncome.tooltip': 'Lorem ipsum dolor sit amet',
  'onboardingAnnualIncome.description':
    'Votre revenu brut (avant impôt). Par exemple, votre salaire annuel.',
  'login.footNote':
    "Vous n'avez pas un compte numérique financier des connaissances?",
  'login.createAnAccount': 'Créer un compte.',
  confirmEmail: 'Confirmer l’adresse courriel',
  emailsDoNotMatch:
    'Veillez à ce que les deux adresses courriel soient identiques.',
  pleaseEnterEmail: "S'il vous plait entrez une adresse mail.",
  invalidEmail: 'Adresse e-mail invalide.',
  invalidEmail1: 'Veuillez saisir une adresse e-mail valide.',
  invalidEmailLength: 'Veuillez saisir 40 caractères au maximum.',
  pleaseEnterPassword: 'Veuillez entrer un mot de passe.',
  passwordStrengthError:
    'Le mot de passe doit compter entre 8 et 24 caractères contenant au moins deux caractères numériques.',
  emailAddress: 'Adresse e-mail',
  password: 'Mot de passe',
  address: 'Adresse',
  age: 'Âge',
  ageRequiredError: 'Veuillez entrer un âge.',
  enterTheAddress: 'Inscrivez votre adresse',
  legalName: 'Nom légal',
  legalFirstName: 'Prénom légal',
  legalMiddleName: 'Deuxième prénom légal',
  'legalMiddleName.placeholder': 'Facultatif',
  firstName: 'Prénom',
  firstNameRequiredError:
    "Le nom sur votre pièce d'identité émise par le gouvernement.",
  invalidFirstName: 'Prénom invalide.',
  invalidName: 'Nom incorrect.',
  legalLastName: 'Nom légal',
  middleName: 'Deuxième prénom',
  lastName: 'Nom de famille',
  lastNameRequiredError:
    "Le nom sur votre pièce d'identité émise par le gouvernement.",
  invalidLastName: 'Nom de famille invalide.',
  invalidNameLength: 'Veuillez saisir 20 caractères au maximum.',
  invalidMiddleNameLength: 'Veuillez saisir 15 caractères au maximum.',
  jobTitle: 'Titre de poste',
  jobTitleError: 'Veuillez indiquer le titre de votre poste.',
  gender: 'Sexe',
  male: 'Homme',
  female: 'Femme',
  notProvided: 'Non fourni',
  phone: 'Cellulaire',
  phoneNumberRequiredError: 'Veuillez saisir votre numéro de téléphone mobile.',
  phoneNumberFormatError: 'Veuillez entrer un numéro de portable valide.',
  SINRequiredError: 'Veuillez indiquer un numéro d’assurance sociale.',
  SINOwnerRequiredError: 'Veuillez indiquer votre numéro d’assurance sociale.',
  SINFormatError: 'Veuillez indiquer un NAS valide.',
  SINDuplicatedError:
    'Veuillez indiquer le numéro d’assurance sociale de l’enfant. Ce NAS existe déjà dans nos dossiers.',
  SIN: 'Numéro d’assurance sociale',
  'education.partTimeOption': 'À temps partiel',
  'education.fullTimeOption': 'À plein temps',
  phoneCall: 'Appel téléphonique',
  'onboardingPersonalInfo.MobileNumberHeader': 'Numéro de portable',
  mobileNumber: 'Numéro de téléphone mobile',
  'mobileNumber.message':
    'À des fins de sécurité, nous utiliserons ce numéro pour vérifier votre identité lors de l’inscription.',
  phoneNumber: 'Numéro de téléphone',
  dateOfBirth: 'Année de naissance',
  'dateOfBirth.dayLabel': 'Jour',
  'dateOfBirth.monthLabel': 'Mois',
  'dateOfBirth.yearLabel': 'Année',
  'dateOfBirth.dayError': 'Saisir un jour.',
  'dateOfBirth.monthError': 'Saisir un mois.',
  'dateOfBirth.yearError': 'Saisir une année.',
  'dateOfBirth.enteredBirthdatePrimary': 'Votre anniversaire est : ',
  'dateOfBirth.enteredBirthdateBene': 'Leur anniversaire est : ',
  dateOfBirthRequiredError: 'Veuillez indiquer votre date de naissance.',
  dateOfBeneBirthRequiredError: 'Veuillez entrer leur date de naissance.',
  dateFormatError: 'Date invalide.',
  invalidBirthDateError: 'Veuillez entrer une date de naissance valide.',
  ageUnderError:
    'Pour ouvrir un REEE, les souscripteurs doivent avoir au moins 18 ans.',
  invalidDate: 'Veuillez saisir une date de naissance valide.',
  beneficiaryAgeError:
    'Pour ouvrir un REEE pour un bénéficiaire, celui-ci doit être âgé de moins de 21 ans.',
  birthYearFormatError: 'Année de naissance invalide.',
  additionalInformation: 'Informations Complémentaires',
  okay: "D'accord",
  ok: 'Ok',
  confirm: 'Confirmer',
  confirmPassword: 'Confirmez le mot de passe',
  confirmPasswordMismatchError: 'Les mots de passe ne correspondent pas.',
  'signUp.title': 'Créer un compte numérique',
  'signUp.description':
    "Nous aurons besoin d'informations pour rechercher votre compte existant avec Knowledge First Financial.",
  'signUp.footnote1':
    'Vous avez déjà un compte numérique financier des connaissances?',
  'signUp.footnoteAction': "S'identifier",
  'signUp.footnote2': ' ici.',
  'unsavedChangesConfirmationDialog.title': 'Voulez-vous vraiment quitter?',
  'unsavedChangesConfirmationDialog.description':
    'Vous perdrez toutes les modifications non enregistrées.',
  'unsavedChangesConfirmationDialog.confirmLabel': 'Non, je veux continuer',
  'unsavedChangesConfirmationDialog.cancelLabel': 'Oui, je veux quitter',
  'leavingConfirmationDialog.title': 'Partir si tôt?',
  'leavingConfirmationDialog.description':
    'Si vous quittez maintenant, vos informations seront perdues.',
  'leavingConfirmationDialog.oneTimeContribution':
    'Vous perdrez tous les progrès avec votre contribution unique.',
  alberta: 'Alberta',
  britishColumbia: 'Colombie-Britannique',
  manitoba: 'Manitoba',
  novaScotia: 'Nouvelle-Écosse',
  newBrunswick: 'Nouveau-Brunswick',
  newfoundlandAndLabrador: 'Terre-Neuve-et-Labrador',
  ontario: 'Ontario',
  princeEdwardIsland: 'Île-du-Prince-Édouard',
  quebec: 'Québec',
  saskatchewan: 'Saskatchewan',
  northwestTerritories: 'Territoires du nord-ouest',
  yukon: 'Yukon',
  nunavut: 'Nunavut',
  grossIncomeRequiredError: 'Veuillez saisir votre revenu annuel brut.',
  step: 'Étape',
  of: 'sur',
  start: 'Commencer',
  back: 'Retour',
  low: 'Bas',
  lowMedium: 'Faible à moyen',
  medium: 'Moyen',
  mediumHigh: 'Moyen à élevé',
  high: 'Élevé',
  lessThan: 'Moins que',
  greaterThan: 'Plus grand que',
  liquidAssets: 'Actifs liquides',
  liquidAssetsError: "Veuillez saisir le montant de l'actif liquide.",
  annualIncome: 'Revenu annuel',
  annualIncomeError: 'Veuillez saisir le revenu annuel.',
  'personalInfo.numberOfDependents':
    'Combien de personnes soutenez-vous financièrement',
  dependentsRequiredError:
    'Veuillez sélectionner le nombre de personnes à charge.',
  streetNumberRequiredError: 'Veuillez indiquer un numéro de rue.',
  streetNameRequiredError: 'Veuillez indiquer un nom de rue.',
  cityRequiredError: 'Veuillez indiquer une ville.',
  provinceRequiredError: 'Veuillez sélectionner une province.',
  provinceNotAllowed:
    "Désolé, ce plan n'est actuellement pas disponible pour les résidents du Québec",
  hopeToPartner: "Nous espérons collaborer avec vous à l'avenir.",
  postalCodeRequiredError: 'Veuillez indiquer un code postal.',
  postalCodeFormatError: 'Code postal non valide.',
  postalCodeCorrespondError: 'Le code postal ne correspond pas à la province.',
  optional: 'Optionnel',
  streetNumberLabel: 'Numéro de rue',
  unitNumberLabel: 'Appartement',
  streetNameLabel: 'Nom de la rue',
  cityLabel: 'Ville',
  provinceLabel: 'Province',
  postalCodeLabel: 'Code Postal',
  schoolPostalCodeLabel: "Code postal de l'école",
  schoolName: "Nom de l'école",
  no: 'Non',
  yes: 'Oui',
  'home.logoLinkUnAuthenticatedAlt': 'Domicile',
  'home.logoLinkAuthenticatedAlt': 'Tableau de bord',
  'reset.title': 'Réinitialisation du mot de passe',
  'forgot.description':
    'Entrez votre e-mail et nous vous enverrons des instructions sur la façon de réinitialiser votre mot de passe.',
  'forgot.forgotEmail': 'Email oublié?',
  'forgot.sendMeInstructions': 'Envoyez-moi des instructions',
  'forgot.backToSignIn': 'Retour à la connexion',
  'reset.description':
    'Les mots de passe doivent compter entre 8 et 24 caractères et contenir au moins deux caractères numériques.',
  'reset.changeMyPassword': 'Changer mon mot de passe',
  'reset.PleaseEnterMatchingPasswords':
    'Veuillez saisir les mots de passe correspondants',
  profile: 'Profil',
  manageAccount: 'Gérer son compte',
  signOut: 'Se déconnecter',
  'dropdown.selectionError': 'Erreur de sélection déroulante',
  'select.placeholder': 'Sélectionner',
  'select.buttonAriaLabel': 'Ouvrir le menu',
  'inputStepper.decrementButtonAriaLabel': 'Diminuer',
  'inputStepper.incrementButtonAriaLabel': 'Augmenter',
  addressOptions1: 'Recherchez ou ',
  addressOptions2: 'inscrivez une adresse',
  termsOfUse: "Conditions d'utilisation",
  digitalTermsAndConditions: 'Termes et conditions numériques',
  'digitalTermsAndConditions.link': `${__STUDENT_SERVICES_URL__}/documents/Digital_Terms_and_Conditions_fr.pdf`,
  privacyNotice: 'Avis de confidentialité',
  privacyPolicy: 'Politique de confidentialité',
  'privacyPolicy.link': `${__STUDENT_SERVICES_URL__}/documents/Embark_Privacy_Policy_fr.pdf`,
  'bookAppointmentReason.thirdParty': 'Tiers cotisant au régime.',
  'bookAppointmentReason.notPCG':
    "Le souscripteur n'est pas le principal soignant ou le parent gardien.",
  'bookAppointmentReason.notParent':
    "L'abonné n'est pas un parent, un grand-parent ou un frère ou une sœur.",
  'bookAppointmentReason.timeHorizon': "Réponse à l'horizon temporel = Non",
  'bookAppointmentReason.investmentObjective':
    "Réponse à l'objectif d'investissement = Non",
  'bookAppointmentReason.riskProfile': "Score de risque de l'abonné = Faible",
  'bookAppointmentReason.duplicateSubscriber':
    "L'abonné a déjà un compte numérique et a essayé de créer un autre compte.",
  'bookAppointmentReason.noRESP':
    "L'abonné n'a pas terminé l'intégration après avoir créé un compte numérique. L'intégration doit être effectuée via le flux assisté.",
  'bookAppointmentReason.nonPSEWithdrawal':
    'Le client demande un retrait non PSE.',
  'bookAppointmentReason.cannotBeCoSub':
    'Le client ne remplit pas les conditions requises pour être co-abonné.',
  'bookAppointmentReason.quebecResident':
    'Le client est un résident du Québec.',
  'bookAppointmentReason.idvAttempts':
    "Le client a atteint le nombre maximal de tentatives de vérification d'identité.",
  'bookAppointmentReason.passwordReset':
    "Le client a besoin d'aide pour réinitialiser son mot de passe.",
  'bookAppointmentReason.duplicateAccounts':
    'Plusieurs enregistrements de personne en double trouvés.',
  'bookAppointmentReason.duplicateAccount':
    'Enregistrement de personne en double trouvé avec un compte numérique existant.',
  'bookAppointmentReason.duplicateRESP':
    'Enregistrement de personne en double trouvé dans un REEE existant.',
  reason: 'Raison',
  'selection.requiredError': 'Veuillez sélectionner une option.',
  'selection.requiredToContinueError':
    'Veuillez sélectionner une option pour continuer.',
  'services.infoMessage':
    'En raison de précautions coiffées, les rendez-vous ne sont disponibles que par appel téléphonique.',
  close: 'Fermer',
  information: 'Informations',
  'feedbackDialogForm.title': 'Embarquement immédiat',
  'feedbackDialogForm.description':
    'Dans quelle mesure pourriez-vous recommander Embark ?',
  'feedbackDialogForm.textFieldLabel': 'Commentaires supplémentaires',
  'feedbackDialogSuccess.title': 'Merci!',
  'feedbackDialogSuccess.description':
    'En faisant entendre votre voix, vous nous aidez à améliorer Embark.',
  date: 'Date',
  futureDate: 'Date ultérieure',
  futureDateError: 'Veuillez choisir une date future.',
  now: 'À présent',
  service: 'Service',
  meetingMethod: 'Méthode de rencontre',
  language: 'Langue',
  timeZone: 'Fuseau horaire',
  dateAndTime: "Date et l'heure",
  morning: 'Matin',
  afternoon: 'Après-midi',
  reschedule: 'Reporter',
  at: 'à',
  'navigation.homeLinkLabel': 'Accueil',
  'navigation.programMatcherLabel':
    "Correspondance entre la carrière et l'école",
  'navigation.contributeLinkLabel': 'Cotiser',
  'navigation.withdrawalLinkLabel': 'Retirer',
  'navigation.transactionsLinkLabel': 'Transactions',
  'navigation.messagesLinkLabel': 'Centre de messages',
  'navigation.inviteLinkLabel': 'Inviter',
  'navigation.bankInfoLinkLabel': 'Information bancaire',
  'navigation.documentsLinkLabel': 'Documents',
  'navigation.onboardingLabel': 'Intégration',
  'navigation.dashboardLabel': 'Accueil',
  'navigation.openPlanLabel': 'Régime ouvert',
  'navigation.rescheduleContributionLabel': 'Reprogrammer une contribution',
  'navigation.cancelContributionLabel': 'Annuler une contribution',
  'navigation.accountLabel': 'Compte',
  'navigation.helpCentreLabel': "Centre d'aide",
  'navigation.referLabel': 'Parrainer un ami',
  'navigation.signInLabel': "S'identifier",
  'navigation.signOutLabel': 'Déconnexion',
  'navigation.profileManagementLabel': 'Gestion de profils',
  'navigation.menu': 'Menu',
  'navigation.shareFeedback': 'Partagez vos commentaires',
  'navigation.educationServices': 'Services éducatifs',
  'navigation.costOfSchool': 'Coût des études',
  'navigation.scholarships': 'Bourses',
  'navigation.referAFriend': 'Référez un ami',
  'navigation.resps': 'REEE',
  'navigation.openAccount': 'Ouvrir un compte',
  'navigation.contact': 'Nous joindre',
  'navigation.contactPhoneLabel': '1-800-363-7377',
  'navigation.contactEmailLabel': 'contact@embark.ca',
  'navigation.gift': 'Cadeau REEE',
  'sendAGift.dialog.title': 'Créer un lien cadeau',
  'sendAGift.dialog.header':
    'Ouvre un compte REEE pour commencer à créer un lien cadeau.',
  'sendAGift.dialog.body':
    'Lorsque vous ouvrez un compte, vous pouvez créer votre propre lien-cadeau pour chaque enfant de votre REEE',
  'sendAGift.dialog.openButton': 'Ouvrir un REEE',
  'sendAGift.dialog.closeButton': 'Fermer',
  'makeContribution.contributionDetails': 'Détails de la contribution',
  'contributionCalendarIcon.alt': 'Calendrier des cotisations',
  'matchesLoading.text': 'Trouver des correspondances...',
  'alertDialog.confirmTitle': 'Voulez-vous vraiment quitter?',
  'alertDialog.confirmMessage':
    'Vous perdrez toutes les modifications non enregistrées.',
  'alertDialog.confirmMessageForOnboarding':
    'Votre candidature ne sera pas soumise.',
  'alertDialog.confirmBtnLabel': 'Oui, je veux quitter',
  'alertDialog.cancelBtnLabel': 'Non, je veux continuer',
  'noBankAccount.alert': 'Veuillez ajouter un compte bancaire.',
  frequency: 'Fréquence',
  oneTime: 'Unique',
  once: 'Une fois',
  monthly: 'Mensuelle',
  biweekly: 'Aux deux semaines',
  weekly: 'Hebdomadaire',
  yearly: 'Annuelle',
  recurring: 'récurrente',
  fromThisAccount: 'De ce compte',
  intoThisAccount: 'Dans ce récit',
  addBankAccount: 'Ajouter un compte bancaire',
  starting: 'Départ',
  from: 'De',
  into: 'Dans',
  to: 'Pour',
  account: 'Compte',
  withdraw: 'Retirer',
  transferDate: 'Date de transfert',
  confirmation: 'Confirmation',
  confirmationNumber: 'Numéro de confirmation',
  cancellation: 'Annulation',
  startDate: 'Date de début',
  nextDate: 'Prochaines cotisations',
  finishDate: 'Date de fin',
  endDate: 'Date de fin',
  agreeAndContinue: 'Convenir et continuer',
  agreeAndSubmit: 'Convenir et soumettre',
  monthlyContribution: 'Cotisation mensuelle',
  'verifyContribution.infoIcon': "Icône d'informations",
  'networkError.description':
    'Notre système est en panne, veuillez revenir un autre jour.',
  locationError: 'Quelque chose ne va pas. Veuillez réessayer plus tard.',
  'addBankAccountDialog.termsTextPreLink':
    'En choisissant de continuer, vous acceptez les',
  'addBankAccountDialog.termsTextLink': 'Termes et conditions',
  'addBankAccountDialog.termsTextPostLink':
    'et autoriser la communication de toute information financière requise avec Embark Student Corp.',
  'contribute.title': 'Verser une cotisation',
  'contribute.clickHere': 'Cliquez ici',
  amount: 'Montant',
  amountError: 'Veuillez inscrire le montant.',
  maxDigitError: 'Veuillez saisir 11 chiffres au maximum.',
  maxDigitError40: 'Veuillez saisir 40 chiffres ou moins.',
  'missingBankAccount.noBankHeader': "Vous n'avez aucun compte bancaire.",
  'missingBankAccount.noBankDescription':
    'Vous devrez ajouter facilement un compte bancaire pour contribuer les fonds.',
  'missingBankAccount.AddABankAccount': 'Ajouter un compte bancaire',
  'missingBankAccount.noBankAccount': 'Pas de compte bancaire',
  success: 'Succès',
  error: 'Erreur',
  submit: 'Soumettre',
  edit: 'Modifier',
  apply: "S'inscrire",
  save: 'Enregistrer',
  saved: 'Enregistré',
  customize: 'Personnaliser',
  reset: 'Réinitialiser',
  contribute: 'Ajouter des fonds',
  'choosePlan.label': 'Données sur le régime',
  'choosePlan.headline': 'Sélectionnez un régime',
  'choosePlan.plans': 'A quel régime souhaitez-vous cotiser?',
  'choosePlan.planError': 'Veuillez sélectionner un plan.',
  'dashboard.interceptDialog.headline': 'OUVERTURE DE COMPTE REEE',
  'dashboard.interceptDialog.title': 'Terminez votre demande de régime Embark',
  'dashboard.interceptDialog.subtitle':
    'Votre compte est presque prêt! Il ne reste que quelques petites questions.',
  'dashboard.interceptDialog.stage.personal': 'Renseignements personnels',
  'dashboard.interceptDialog.stage.idv': 'Confirmation de l’identité',
  'dashboard.interceptDialog.stage.profile': 'Profil d’investissement',
  'dashboard.savingsPlan': "Plans d'épargne",
  'dashboard.addChild': 'Ajouter un profil enfant',
  'dashboard.interceptDialog.stage.sin': 'Information sur le NAS',
  'dashboard.currentPlan': 'Régimes actuels',
  'dashboard.planTransferAlert':
    'Nous traitons actuellement le transfert de votre régime à la suite de la modification récemment apportée à votre profil de risque de placement. Cette procédure peut nécessiter de 45 à 60 jours ouvrables. Une fois que le transfert sera terminé, votre ancien régime sera supprimé de votre tableau de bord.',
  'dashboard.newRESP': 'Ouvrir un nouveau REEE',
  'dashboard.addBene': 'Épargner pour un autre enfant',
  'dashboard.externalTransfer': 'Transférer un REEE',
  'dashboard.financialPlanner': 'Financial Planner',
  'dashboard.addPlanCardTitle': 'Ajouter',
  'dashboard.addPlanCardBody':
    'Régime étudiant Embark familial ou un Régime étudiant Embark individuel',
  'dashboard.childProfile': 'Profil de l’enfant',
  'dashboard.applicationStatusCard.pending.title':
    'Votre demande de REEE est en suspens',
  'dashboard.applicationStatusCard.pending.description':
    'Reprenez votre candidature.',
  'dashboard.applicationStatusCard.underReview.title':
    'Votre demande est en attente',
  'dashboard.applicationStatusCard.underReview.description':
    'Cela peut prendre quelques jours ouvrables. Vous recevrez un courriel une fois qu’il aura été approuvé.',
  'dashboard.applicationStatusCardCosub.underReview.description':
    'Votre demande de compte conjoint est en attente',
  'dashboard.yearsOld': 'ans',
  'dashboard.aspiredToBe': 'Aspirait à être',
  'dashboard.noCareer': 'Pas de Carrière',
  'dashboard.accountSummaryCard.title':
    'Embarquez pour le plan familial étudiant',
  'dashboard.accountSummaryCard.newPlanLabel': 'Nouveau régime',
  'dashboard.accountSummaryCard.oldPlanLabel': 'Ce régime sera désactivé.',
  'dashboard.accountSummaryCard.buttonText': 'Voir les détails',
  'dashboard.accountSummaryCard.totalSavings': 'Épargne totale',
  'dashboard.remindCoSubDialog.title':
    'Invitez votre titulaire de compte conjoint à activer son compte numérique',
  'dashboard.remindCoSubDialog.whyThisMatters': 'Pourquoi c’est important :',
  'dashboard.remindCoSubDialog.whyThisMattersBody':
    'Pour que votre titulaire de compte conjoint puisse avoir un accès complet à Embark, il doit s’inscrire. Nous lui enverrons un courriel pour l’aider à s’inscrire à nos services.',
  'dashboard.remindCoSubDialog.whyThisMattersNote1': 'Remarque : ',
  'dashboard.remindCoSubDialog.whyThisMattersNote2':
    'Le titulaire de compte conjoint doit être un époux ou un conjoint de fait.',
  'dashboard.remindCoSubDialog.whatYouNeedToDo': 'Mesures à prendre :',
  'dashboard.remindCoSubDialog.whatYouNeedToDoStep1':
    'Saisissez son adresse courriel pour lui envoyer un rappel.',
  'dashboard.remindCoSubDialog.whatYouNeedToDoStep2':
    'Il recevra un courriel avec des instructions pour terminer la création de son compte.',
  sendReminder: 'Envoyer un rappel',
  maybeLater: 'Peut-être plus tard',
  'dashboard.addPlan': 'Ajouter un nouveau régime',
  'dashboard.featureCards.title': 'Explorez les services',
  'dashboard.featureCard.title.costOfSchool': 'Coût des études',
  'dashboard.featureCard.title.scholarship': 'Bourses d’études',
  'dashboard.featureCard.title.resp': 'REEE',
  'dashboard.featureCard.title.schoolMatcher':
    'Correspondance entre la carrière et l’école',
  'dashboard.featureCard.title.gift': 'Embark Dons',
  'dashboard.featureCard.content.costOfSchool':
    'Calculez et suivez les dépenses et l’épargne prévues pour les écoles.',
  'dashboard.featureCard.content.scholarship':
    'Trouvez des bourses d’études qui correspondent aux aspirations de votre enfant.',
  'dashboard.featureCard.content.resp':
    'Trouvez le bon régime pour votre enfant.',
  'dashboard.featureCard.content.schoolMatcher':
    'Explorez les parcours de carrière qui correspondent aux compétences, aux intérêts et aux valeurs de votre enfant.',
  'dashboard.featureCard.content.gift':
    'La famille et les amis peuvent maintenant verser de l’argent dans le REEE de votre enfant.',
  'dashboard.featureCard.button.gift': 'Essayer maintenant',
  'featureCard.newTag': 'Nouvelle!',
  'dashboard.articleCards.title': 'Choisi pour vous',
  'dashboard.articleCard.title.withdraw': 'Retirer de votre REEE',
  'dashboard.articleCard.title.career':
    'Comment aider votre enfant à choisir un métier?',
  'dashboard.articleCard.title.grants':
    'Maximiser votre épargne grâce aux subventions gouvernementales',
  'dashboard.articleCard.content.withdraw':
    'Comprendre les étapes à suivre pour retirer des fonds de votre REEE vous permettra de prendre des décisions financières éclairées.',
  'dashboard.articleCard.content.career':
    'Obtenez des informations et des stratégies utiles qui vous permettront, en tant que parent, d’orienter votre enfant sur la voie de la réussite professionnelle.',
  'dashboard.articleCard.content.grants':
    'Découvrez les subventions gouvernementales qui correspondent à vos cotisations à un REEE, ce qui vous permettra d’augmenter votre épargne future.',
  'dashboard.articleCard.imgAlt.withdraw':
    'A person wearing glass standing with arms crossed smiling',
  'dashboard.articleCard.imgAlt.career':
    'A person looking upward with a concerned expression',
  'dashboard.articleCard.imgAlt.grants': 'A teenage girl with a hopeful smile',
  'dashboard.exclusiveOfferCards.title': 'Exclusive offers for you',
  'dashboard.exclusiveOfferCards.title.apollo': 'Apollo',
  'dashboard.exclusiveOfferCards.description.apollo':
    'Exclusive offer for Embark customers.',
  'dashboard.exclusiveOfferCards.title.youthfully': 'Youthfully',
  'dashboard.exclusiveOfferCards.description.youthfully':
    'Recevez un rabais de 10 % sur les services d’encadrement individuel.',
  'dashboard.exclusiveOfferCards.title.willful': 'Willful',
  'dashboard.exclusiveOfferCards.description.willful':
    'Recevez un rabais de 20 % sur votre testament légal.',
  'dashboard.exclusiveOfferCards.title.borrowell': 'Borrowell',
  'dashboard.exclusiveOfferCards.description.borrowell':
    '3 exclusive offers for you',
  'dashboard.exclusiveOfferCards.title.neoFinancial': 'Neo Financial',
  'dashboard.exclusiveOfferCards.description.neoFinancial':
    'Recevez 25 $ en récompense en utilisant une carte de crédit approuvée par Neo.',
  'dashboard.exclusiveOfferCards.title.policyMe': 'AssureMoi',
  'dashboard.exclusiveOfferCards.description.policyMe':
    "Obtenez vos deux premiers mois d'assuranc e vie ou d'assuranc e maladie grave gratuitement.",
  'dashboard.exclusiveOfferDialog.cta': 'Continuer',
  'dashboard.exclusiveOfferDialog.referralDisclosure1':
    'En cliquant sur cette offre, vous acceptez ',
  'dashboard.exclusiveOfferDialog.referralDisclosure2':
    "l'accord de divulgation de référence",
  'dashboard.exclusiveOfferDialog.apollo.referralDisclosure':
    '/documents/Apollo_Referral_Disclosure_en.pdf',
  'dashboard.exclusiveOfferDialog.apollo.url':
    'https://info.apollocover.com/embark',
  'dashboard.exclusiveOfferDialog.apollo.bodyBoldOne':
    'Get your exclusive offer for tenant insurance in 5 minutes.',
  'dashboard.exclusiveOfferDialog.apollo.bodyOne':
    "Tenant insurance ⎯ also known as renters insurance, condo tenant insurance, or content insurance ⎯ is essential for anyone who rents their living space. Tenant insurance covers your personal property, liability, and additional living expenses if you're forced to temporarily relocate due to a covered event.",
  'dashboard.exclusiveOfferDialog.apollo.bodyTwo':
    'Guaranteed acceptance by property managers and landlords across Canada',
  'dashboard.exclusiveOfferDialog.apollo.bulletPointOne.headline':
    'Comprehensive and Affordable',
  'dashboard.exclusiveOfferDialog.apollo.bulletPointOne.description':
    'We provide the best value for your money, with more standard coverages built into one low price. Pay less for more coverage.',
  'dashboard.exclusiveOfferDialog.apollo.bulletPointTwo.headline':
    'Online Portal, Easy to Use',
  'dashboard.exclusiveOfferDialog.apollo.bulletPointTwo.description':
    'Our platform is designed to be the fastest and simplest way to buy insurance. Purchase and bind in less than a minute and we’ll send your documents right to your inbox.',
  'dashboard.exclusiveOfferDialog.apollo.bulletPointThree.headline':
    '5-Star Customer Rating ',
  'dashboard.exclusiveOfferDialog.apollo.bulletPointThree.description':
    'Customer service is our priority. We earn our clients’ trust by providing the best products backed by world class service and support.',
  'dashboard.exclusiveOfferDialog.youthfully.url':
    'https://www.youthfully.com/embark?via=embark',
  'dashboard.exclusiveOfferDialog.youthfully.bodyBoldOne':
    'Recevez un rabais de 10 % sur les services de Youthfully',
  'dashboard.exclusiveOfferDialog.youthfully.bodyOne':
    'Principal fournisseur de services d’encadrement individuel des élèves au Canada, Youthfully offre un soutien entièrement personnalisé par un mentor d’élite dans le but d’aider les élèves à :',
  'dashboard.exclusiveOfferDialog.youthfully.bodyTwo.one': 'Selon le magazine ',
  'dashboard.exclusiveOfferDialog.youthfully.bodyTwo.maclean': 'Maclean’s',
  'dashboard.exclusiveOfferDialog.youthfully.bodyTwo.two':
    ', Youthfully est « le meilleur service d’aide à l’admission sur le marché », et le Globe and Mail chante les louanges du programme pour son « accent sur les compétences générales ».”',
  'dashboard.exclusiveOfferDialog.youthfully.bulletPointOne.description':
    'rédiger des essais et passer des entretiens d’admission à l’université;',
  'dashboard.exclusiveOfferDialog.youthfully.bulletPointTwo.description':
    'effectuer la recherche d’emploi et se préparer aux entretiens de recrutement;',
  'dashboard.exclusiveOfferDialog.youthfully.bulletPointThree.description':
    'définir une trajectoire de formation et de carrière;',
  'dashboard.exclusiveOfferDialog.youthfully.bulletPointFour.description':
    'améliorer les compétences de base en matière d’apprentissage;',
  'dashboard.exclusiveOfferDialog.youthfully.bulletPointFive.description':
    'obtenir des bourses.',
  'dashboard.exclusiveOfferDialog.willful.referralDisclosure':
    '/documents/Willful_Referral_Disclosure_fr.pdf',
  'dashboard.exclusiveOfferDialog.willful.url': 'https://try.willful.co/embark',
  'dashboard.exclusiveOfferDialog.willful.bodyBoldOne':
    'Recevez un rabais de 20 % sur tous les forfaits de Willful. ',
  'dashboard.exclusiveOfferDialog.willful.bodyOne':
    'Plus de 150 000 personnes au Canada font confiance à Willful, la principale plateforme de planification successorale en ligne au Canada. Créée avec l’aide d’avocats de chaque province, elle offre une expérience conviviale et vous aide à créer un testament légal et des documents de procuration dans le confort de votre foyer.',
  'dashboard.exclusiveOfferDialog.borrowell.referralDisclosure':
    '/documents/Borrowell_Referral_Disclosure_en.pdf',
  'dashboard.exclusiveOfferDialog.borrowell.url':
    'https://borrowell.com/partner/embark/rent-advantage?utm_source=embark&utm_medium=referral&utm_campaign=fcs&utm_content=platform',
  'dashboard.exclusiveOfferDialog.borrowell.bodyBoldOne': 'Rent Advantage',
  'dashboard.exclusiveOfferDialog.borrowell.bodyOne':
    'Report your rent and build your credit history with Borrowell’s Rent Advantage program.',
  'dashboard.exclusiveOfferDialog.borrowell.bodyTwo':
    'Additionally, join over 3 million Canadians and get the tools you need to help understand, manage, and master your credit.',
  'dashboard.exclusiveOfferDialog.borrowell.bulletPointOne.description':
    'Build credit so you can access more credit products at better rates.',
  'dashboard.exclusiveOfferDialog.borrowell.bulletPointTwo.description':
    "Take on no additional debt. Use rent that you're already paying monthly.",
  'dashboard.exclusiveOfferDialog.borrowell.bulletPointThree.description':
    'Easy setup. No credit checks. No hidden fees. Cancel anytime.',
  'dashboard.exclusiveOfferDialog.borrowell.bulletPointFour.headline':
    'Free Credit Score',
  'dashboard.exclusiveOfferDialog.borrowell.bulletPointFour.description':
    'Your credit score can have a big impact on your financial future. Sign up for Borrowell to get your credit score and credit report for free!',
  'dashboard.exclusiveOfferDialog.borrowell.bulletPointFive.headline':
    'Credit Builder',
  'dashboard.exclusiveOfferDialog.borrowell.bulletPointFive.description':
    'Canadians who are aiming to build their credit history to access more credit products like loans, credit cards and mortgages, and at lower interest rates.  Build your credit with Borrowell and achieve your financial goals. No hard credit check when you apply.',
  'dashboard.exclusiveOfferDialog.neoFinancial.referralDisclosure':
    '/documents/Neofinancial_Referral_Disclosure_fr.pdf',
  'dashboard.exclusiveOfferDialog.neoFinancial.url':
    'https://myneo.financial/uy763',
  'dashboard.exclusiveOfferDialog.neoFinancial.bodyBoldOne':
    'Recevez une récompense de 25 $ exclusif à la clientèle d’Embark',
  'dashboard.exclusiveOfferDialog.neoFinancial.bodyOne':
    'Obtenez une carte de crédit Neo, utilisez-la pour effectuer une transaction, et recevez une récompense de 25 $!',
  'dashboard.exclusiveOfferDialog.neoFinancial.bodyTwo':
    'La carte de remises en argent préférée de la population canadienne',
  'dashboard.exclusiveOfferDialog.neoFinancial.bodyThree':
    'De plus, les clients d’Embark peuvent profiter d’une vaste gamme de comptes et d’outils de Neo, comme le compte Neo Épargne à intérêt élevé ou la carte Neo Argent.',
  'dashboard.exclusiveOfferDialog.neoFinancial.bulletPointOne.description':
    'Inscrivez-vous en trois minutes et commencez à utiliser votre carte virtuelle instantanément',
  'dashboard.exclusiveOfferDialog.neoFinancial.bulletPointTwo.description':
    'Gérez votre situation financière grâce au suivi des dépenses en temps réel',
  'dashboard.exclusiveOfferDialog.neoFinancial.bulletPointThree.description':
    'Bloquez ou débloquez votre carte en tout temps à partir de l’application Neo',
  'dashboard.exclusiveOfferDialog.policyMe.referralDisclosure':
    '/documents/PolicyMe_Referral_Disclosure_fr.pdf',
  'dashboard.exclusiveOfferDialog.policyMe.url':
    'https://policyme.pxf.io/c/5711270/2138596/15713',
  'dashboard.exclusiveOfferDialog.policyMe.bodyBoldOne':
    "Obtenez vos deux premiers mois d'assurance vie ou d'assurance maladie grave gratuitement.",
  'dashboard.exclusiveOfferDialog.policyMe.bodyOne':
    "Explorer l'assurance vie est essentiel pour sécuriser l'avenir financier de votre famille. Elle fournit un soutien crucial en couvrant les dettes et en maintenant le niveau de vie en cas de problème. Ce type d'assurance est particulièrement important pour les familles avec des personnes à charge, garantissant leur protection financière.",
  'dashboard.exclusiveOfferDialog.policyMe.bodyTwo':
    'Avec AssureMoi, les parents peuvent avoir confiance en étant bien accompagnés par des conseillers prêts à les aider tout au long du processus, par téléphone ou par courriel.',
  'dashboard.exclusiveOfferDialog.policyMe.bodyBoldTwo':
    "Avantages supplémentaires d'AssureMoi :",
  'dashboard.exclusiveOfferDialog.policyMe.bulletPointOne.description':
    'Obtenez votre soumission en ligne en 30 secondes',
  'dashboard.exclusiveOfferDialog.policyMe.bulletPointTwo.description':
    'Postulez pour une assurance en ligne en moins de 20 minutes',
  'dashboard.exclusiveOfferDialog.policyMe.bulletPointThree.description':
    "Les couples bénéficient de 10 % de réduction la première année lorsqu'ils postulent ensemble",
  'dashboard.exclusiveOfferDialog.policyMe.bulletPointFour.description':
    "Obtenez 10 000$ de couverture gratuite pour les enfants avec votre police d'assurance vie",
  'dashboard.cosubmReminder.title': ' needs to complete registration',
  'childSavingsCalculator.header1':
    'Prêt à explorer les possibilités qui s’offrent à vous?',
  'childSavingsCalculator.header2': ' Régime étudiant Embark',
  'childSavingsCalculator.subheader':
    'Calculez le montant que vous pouvez épargner grâce à votre régime étudiant Embark.',
  'childSavingsCalculator.childAgeSlider.label': 'Âge de l’enfant',
  'childSavingsCalculator.childAgeSlider.inputLabel': 'Âge',
  'childSavingsCalculator.graph.infoHeader': 'Épargne prévue d’ici ',
  'childSavingsCalculator.graph.infoIconAlt':
    "Icône d'information - Cliquez pour ouvrir la boîte de dialogue.",
  'childSavingsCalculator.graph.dialog.title': 'Épargnes prévues',
  'childSavingsCalculator.graph.dialog.description1':
    'Cette prévision est fondée sur des hypothèses et n’est présentée qu’à titre indicatif. Il s’agit de la valeur totale prévue de votre REEE au moment où votre enfant devrait commencer ses études postsecondaires.',
  'childSavingsCalculator.graph.dialog.description2':
    'Les épargnes prévues sont calculées en utilisant un taux de rendement de 4 %',
  'childSavingsCalculator.graph.dialog.description3':
    'La valeur prévue comprend les cotisations et les subventions gouvernementales qui devraient être accumulées, ainsi que les revenus découlant de ces cotisations et subventions. La valeur marchande totale de votre régime peut fluctuer quotidiennement en fonction de la valeur des placements. Le rendement des placements et la valeur future réelle de votre REEE ne peuvent être prévus ni garantis.',
  'childSavingsCalculatorV2.subtitle': "Let's get saving",
  'childSavingsCalculatorV2.headline': 'Estimate your savings',
  'footer.embark': 'Embark.',
  'childSavingsCalculator.graph.buttonLabel': 'Commencez à épargner',
  'childSavingsCalculator.provinceDropdown.helperText':
    'Les subventions gouvernementales peuvent varier selon votre lieu de résidence.',
  'childSavingsCalculator.contributionSlider.label': 'Cotisation mensuelle',
  'childSavingsCalculator.graph.contributions': 'Cotisations',
  'childSavingsCalculator.graph.grants': 'Subventions',
  'childSavingsCalculator.graph.income': 'Revenu',
  'childSavingsCalculator.graph.subheading.including': ' dont ',
  'childSavingsCalculator.graph.subheading.inGrants': ' en subventions',
  'contributionDetails.label': 'Cotiser',
  'contributionDetails.headline': 'Prêt à épargner?',
  'contributionDetails.cardHeadline1': 'Obtenez gratuitement jusqu’à',
  'contributionDetails.cardHeadline2': '500 $',
  'contributionDetails.cardHeadline3': 'de subventions gouvernementales',
  'contributionDetails.cardContent':
    'Le gouvernement verse un montant égal à 20 % de votre première tranche de 2 500 $ de cotisation annuelle. Vous pourriez obtenir jusqu’à 500 $ de subventions par bénéficiaire et par année, avec un plafond à vie de 7 200 $.',
  'contributionDetails.amount': 'Combien?',
  'contributionDetails.chooseAPlan':
    'À partir de quel compte souhaitez-vous verser votre contribution?',
  'contributionDetails.frequency': 'À quelle fréquence?',
  'contributionDetails.amountLabel':
    'Une cotisation minimale de 5,00 $ est requise.',
  'contributionDetails.startDate': 'A partir de quelle date ?',
  'contributionDetails.bankAccount': 'A partir de quel compte ?',
  'contributionDetails.frequencyError':
    'Sélectionnez la fréquence de la contribution.',
  'contributionDetails.beneficiariesAmountError':
    'Veuillez indiquer un montant pour au moins un de vos bénéficiaires.',
  'contributionDetails.noAmountError':
    'Veuillez indiquer un montant de cotisation.',
  'contributionDetails.minAmountError':
    'Une cotisation minimale de 5,00 $ est requise.',
  'contributionDetails.maxAmountError':
    'Veuillez inscrire un montant inférieur ou égal à 50 000 $.',
  'contributionDetails.bankAccountError':
    'Sélectionnez un compte pour la contribution.',
  'contributionDetails.startDateError': 'Veuillez indiquer une date de début.',
  'contributionDetails.planError': 'Sélectionnez un destinataire REEE.',
  'contributionDetails.fieldsEmptyError':
    'Veuillez indiquer tous les renseignements pour continuer.',
  'verifyContribution.label': 'Vérifier',
  'verifyContribution.headline': 'Récapitulatif',
  'verifyContribution.total': 'Total',
  'verifyContribution.to': 'À',
  'verifyContribution.noteHighlight':
    'Toutes les transactions sont effectuées pendant les jours ouvrables. Les cotisations versées lors d’un jour férié ou d’une fin de semaine seront traitées le jour ouvrable suivant.',
  'verifyContribution.submitBtn': 'Confirmer la contribution',
  'contributionSuccess.alt': 'Réussite de la contribution',
  'contributionSuccess.headline': 'Cotisation programmée !',
  'contributionSuccess.headlineOneTime': 'Cotisation effectuée !',
  'contributionSuccess.description1': 'Votre cotisation',
  'contributionSuccess.description2': 'de',
  'contributionSuccess.description3': 'a bien été programmée.',
  'contributionSuccess.description3OneTime': 'a bien été effectuée.',
  cancelDescription: 'Changement de plan?',
  cancelNextDayOrderDescription: 'Vous souhaitez annuler cette cotisation?',
  cancelContribution: 'Annuler une cotisation',
  'flinksConsent.title': 'Consentement requis',
  'flinksConsent.subTitle':
    'Nous avons besoin d’une autorisation pour nous connecter à votre :',
  'flinksConsent.description1': 'Historique des transactions du compte',
  'flinksConsent.description2': 'Numéro de compte et solde',
  'flinksConsent.description3a': 'Renseignements personnels',
  'flinksConsent.description3b':
    '(nom, courriel, adresse et numéro de téléphone)',
  'upcomingContributionsList.title': 'Contributions à venir',
  parent: 'Parent',
  grandparent: 'Grand-parent',
  auntUncle: 'Tante ou oncle',
  notRelated: 'Aucun lien de parenté',
  publicPrimaryCaregiver: 'Responsable public',
  spouse: 'Nous sommes mariés ou conjoints de fait',
  child: 'Enfant',
  stepchild: 'Passoyaux',
  grandchild: 'Petit-enfant',
  sibling: 'Frère ou sœur',
  coSubscriber: 'Co-abonné',
  'promoInput.label':
    'Veuillez saisir votre code de conseiller ou code promotionnel',
  'promoInput.button': 'Faites votre demande',
  'promoInput.success': 'Votre code promotionnel a bien été appliqué !',
  'promoInput.codeError': 'Veuillez saisir un code valide.',
  other: 'Autre',
  'onboardingRelationship.isCustodialParent': 'Êtes-vous le parent gardien?',
  'onboardingRelationship.headline': 'Quelle est votre relation avec',
  'onboardingDependents.fiveOrMore': '5 ou plus',
  'onboardingDependents.dropdownLabel': 'Nombre de personnes à charge',
  'onboardingDependents.description':
    'Une personne à charge peut être un enfant, un parent ou toute autre personne qui dépend de vous financièrement.',
  'onboardingDependents.label': 'Personnes à charge',
  'onboardingDependents.headline':
    'Combien de personnes dépendent de vous financièrement?',
  'onboardingDependents.dropdownDescription':
    'Veuillez sélectionner le nombre de personnes à charge.',
  'onboardingNonEducationExpenses.label': 'Frais de non-éducation',
  'onboardingNonEducationExpenses.headline':
    'Prévoyez-vous la nécessité de retirer les fonds de ce plan de frais de non-éducation?',
  'onboardingNonEducationExpenses.note':
    "Knowledge First Financial propose des plans d'épargne en éducation conçus pour des économies à long terme à apporter au coût de l'enseignement postsecondaire. Le livret d'informations sur la divulgation de la relation décrit les risques à considérer lors de la réalisation des retraits du REA.",
  'onboardingCoApplicant.label': 'Co-applicant',
  'onboardingCoApplicant.title1':
    'Configurons ensemble votre régime étudiant Embark',
  'onboardingCoApplicant.header': 'Qui ouvre ce REEE?',
  'onboardingCoApplicant.me': 'Compte individuel : moi',
  'onboardingCoApplicant.joint':
    'Compte conjoint : moi et ma conjointe/mon conjoint (étant mariés ou conjoints de fait), à titre de souscripteurs conjoints',
  'onboardingCoApplicant.meAndThirdParty':
    'C’est moi qui ouvre le compte, mais une autre personne (autre que mon cosouscripteur et moi) cotisera au REEE',
  'onboardingCoApplicant.coSubscriber1':
    'Nous inviterons votre co-souscripteur en lui envoyant un lien sécurisé par e-mail après avoir soumis votre demande de REEE.',
  'onboardingCoApplicant.coSubscriberMessage':
    'Pour que votre cosouscripteur réussisse la vérification d’identité, veuillez vous assurer que son nom complet correspond au nom figurant sur sa pièce d’identité émise par le gouvernement.',
  'onboardingCoApplicant.coSubscriber2':
    'Cette invitation expire dans 48 heures.',
  'onboardingCoApplicant.coSubscriberHeader': 'Inviter un co-abonné',
  'cannotContinue.header':
    'Désolé, vous ne pouvez pas continuer par voie numérique',
  'cannotContinue.description1':
    "Nous avons besoin d'informations et de vérifications supplémentaires pour autoriser un cotisant tiers.",
  'cannotContinue.description2':
    'Ne vous inquiétez pas, nos représentants sont là pour vous aider à répondre à vos besoins en matière de REEE. Veuillez communiquer avec nous au 1-800-363-7377 ou en ligne pour poursuivre.',
  'cannotContinue.additionalInfoDescription1':
    'Nous avons besoin d’informations et de vérifications supplémentaires.',
  'cannotContinue.additionalInfoDescription2':
    'Veuillez communiquer avec nous au 1-800-363-7377 ou en ligne pour poursuivre.',
  'cannotContinue.descriptionNoResp':
    'Votre demande de REEE est incomplète. Veuillez communiquer avec nous au 1-800-363-7377 ou en ligne pour poursuivre.',
  'cannotContinue.descriptionPreviousResponse':
    "Désolé, d'après votre réponse précédente, vous ne pouvez pas continuer par voie numérique.",
  'cannotContinue.descriptionRiskProfile':
    "Désolé, d'après votre profil de risque, vous ne pouvez pas continuer par voie numérique.",
  'onboardingGrants.label': 'Subventions gouvernementales',
  'onboardingGrants.headline': 'Nous demanderons ces subventions en votre nom',
  'onboardingGrants.weCanApplyFor':
    'Nous pouvons postuler pour les subventions du gouvernement fédéral et provincial suivantes, et nous ferons tout le travail des jambes. Donc, vous pouvez vous reposer facilement en sachant que vous ne manquez pas.',
  'onboardingGrants.grantsListTitle':
    'Subventions éligibles basées sur votre province',
  'onboardingGrants.CESG': 'Subvention canadienne pour l’épargne-études (SCEE)',
  'onboardingGrants.CESG.link':
    'https://www.canada.ca/fr/services/prestations/education/epargne-etudes/epargne-etudes.html',
  'onboardingGrants.ACESG':
    'Subvention canadienne pour l’épargne-études supplémentaire (SCEES)',
  'onboardingGrants.ACESG.link':
    'https://www.canada.ca/fr/services/prestations/education/epargne-etudes/epargne-etudes/montant.html',
  'onboardingGrants.CLB': "Bon d'études canadien (BEC)",
  'onboardingGrants.CLB.link':
    'https://www.canada.ca/fr/agence-revenu/services/impot/particuliers/sujets/regime-enregistre-epargne-etudes-reee/programmes-canadiens-epargne-etudes-pcee/etudes-canadien.html',
  'onboardingGrants.BCTESG':
    "Subvention pour l'épargne-études et l'épargne-formation de la Colombie-Britannique (SEEEFCB)",
  'onboardingGrants.BCTESG.link':
    'https://www2.gov.bc.ca/gov/content/education-training/k-12/support/scholarships/bc-training-and-education-savings-grant',
  'onboardingGrants.QESI': "Incitatif québécois à l'épargne-études (IQEE)",
  'onboardingGrants.QESI.link':
    'https://www.revenuquebec.ca/fr/citoyens/credits-dimpot/incitatif-quebecois-a-lepargne-etudes/',
  'onboardingGrants.descriptionCESG1': 'Chaque année, le gouvernement fédéral',
  'onboardingGrants.descriptionCESG2':
    "correspond à 10% de vos contributions, jusqu'à 2 500 $",
  'onboardingGrants.descriptionCESG3':
    "et déposera l'argent directement sur le compte REA de l'enfant.",
  'onboardingGrants.descriptionACESG1':
    'Un enfant est admissible au montant supplémentaire du CESG si le niveau de revenu familial ajusté est de 93 208 $ ou moins,',
  'onboardingGrants.descriptionACESG2':
    "10% à 20% supplémentaires sur les 500 premiers $ qu'ils contribuent en un an.",
  'onboardingGrants.descriptionBCTESG':
    'Le BCTESG ne nécessite aucune contribution supplémentaire ou supplémentaire: la Colombie-Britannique. Le gouvernement contribuera 1 200 $ à des enfants éligibles afin que les parents et les familles qui ne puissent pas se permettre de mettre de côté les économies à ce moment peuvent toujours démarrer un REEE.',
  'onboardingGrants.noteDescription':
    'Les subventions sont sujettes à changement sans préavis.',
  'onboardingBeneficiarySIN.descriptionQESI':
    "Jusqu'à 250 $ par année par enfant",
  'onboardingGrants.grantAmount1':
    'Une contribution de 2500 $ / an pendant environ 15 ans =',
  'onboardingGrants.grantAmount2': '500 $ x 14,4 ans =',
  'onboardingGrants.governmentGrants': 'dans les subventions gouvernementales',
  'onboardingRiskProfile.alt': 'Profil de risque',
  'onboardingRiskProfile.descriptionHeader':
    'D’après vos préférences, votre profil global en matière de risque est ',
  'onboardingRiskProfile.reviewTitle': 'Profil de risque global',
  'onboardingRiskProfile.notAvailable': 'Indisponible',
  'onboardingRiskProfile.accountSettings':
    'Vous pouvez mettre à jour votre profil à tout moment dans les paramètres de votre compte.',
  'onboardingRiskProfile.ProfileCalculationError':
    "Une erreur s'est produite lors du calcul de la tolérance au risque.",
  'educationSavings.title':
    'Sélectionnez un régime pour afficher votre tableau de bord',
  'plan.title': 'Plan individuel étudiant',
  'plan.accountDescription': 'Régime familial',
  'plan.type.individual': 'Régime individuel',
  'plan.type.family': 'Régime familial',
  'plan.type.unknown': 'Compte de plan',
  'plan.error.notFound': 'Compte de plan introuvable.',
  'accountSummary.message':
    "Définissez votre objectif d'éducation, planifiez les contributions et maximisez vos subventions.",
  'accountSummary.groupIcon': 'Icône de groupe',
  resp: 'REEE',
  hi: 'Bonjour',
  welcomeBack: 'Bon retour, ',
  'profileImage.ariaLabel': 'Téléverser une photo',
  'imageDrop.title': 'Définir une photo de profil',
  'imageDrop.dragAndDrop': 'Glisser-déposer ou ',
  'imageDrop.browse': 'suivre le lien',
  'imageDrop.avatarFormat': 'Format JPEG, PNG ou GIF',
  'imageDrop.avatarSize1': 'Taille maximale du fichier : ',
  'imageDrop.avatarSize2': '2,5 Mo',
  'imageDrop.dropImage': "déposer l'icône de tête d'image",
  'imageDrop.dropAreaIcon': 'icône de la zone de dépôt',
  'imagePreview.headline': 'Aperçu',
  'imagePreview.dragToReposition': 'Glisser pour repositionner',
  'imagePreview.rotate': 'Tourner',
  'imagePreview.zoomOutPreview': 'Zoom arrière Aperçu',
  'imagePreview.zoomInPreview': "Agrandir l'aperçu",
  'imagePreview.description':
    "J'accepte de téléverser la photo de mon enfant selon les",
  'imagePreview.termsAndConditions': ' conditions générales ci-après.',
  'imagePreview.termsAndConditions.link': `${__STUDENT_SERVICES_URL__}/documents/Upload_Student_Picture_Disclaimer-FR.pdf`,
  'imageUploading.text': 'Téléversement...',
  accountBeneProfile: 'Mon futur étudiant',
  'studentCard.empty.description':
    'Choisissez la photo du profil qui reflète sa personnalité unique et l’objectif d’épargne qui correspond à ses rêves.',
  'imageError.fileTooLarge': 'Veuillez téléverser une photo de taille valide.',
  'imageError.invalidFileType':
    'Veuillez télécharger un type de fichier valide.',
  'imageError.otherImageError': 'Quelque chose ne va pas. Veuillez réessayer.',
  'imageChangeConfirm.edit': 'Modifier la photo de profil',
  'imageChangeConfirm.confirmDescription1': 'La photo de profil du ',
  'imageChangeConfirm.confirmDescription2': ' va être supprimée.',
  'imageChangeConfirm.deletingLoading': 'Suppression',
  'imageChangeConfirm.successUpdate': 'Photo de profil mise à jour',
  'imageChangeConfirm.successDeleteDescription': 'Photo supprimée avec succès.',
  'refer.piggy.alt': 'Parrainez cochon',
  'refer.error.alt': "Reportez-vous à l'erreur",
  'refer.error': 'Quelque chose ne va pas. Veuillez réessayer plus tard.',
  'refer.title': 'Parrainer un ami',
  'refer.retry': 'Réessayer',
  'refer.future': 'Parrainez plus, gagnez plus!',
  'refer.content':
    "Aidez vos amis à planifier l'éducation de leurs enfants. Présentez-les à Embark et vous pourriez tous gagner",
  'refer.terms': '* Des conditions ',
  'refer.apply': "s'appliquent.",
  'refer.copyLink': 'Copier le lien',
  'refer.steps.title': '3 étapes simples ',
  'refer.step1':
    'Invitez vos amis à rejoindre Embark. Copiez votre lien ou code de parrainage unique ci-dessus et envoyez-le leur.',
  'refer.step2':
    'Demandez à vos amis d’utiliser votre lien ou code unique pour ouvrir un REEE Embark.',
  'refer.step3':
    'Nous créditerons 100 $ chacun sur votre compte de REEE et celui de vos amis.',
  'refer.termsLink': `${__STUDENT_SERVICES_URL__}/documents/Refer_a_friend_Terms_fr.pdf`,
  'accountSummary.grantsCard.description1': '',
  'accountSummary.grantsCard.description3':
    ' en subventions gouvernementales !',
  'accountSummary.grantsCard.description4': 'Depuis le ',
  'accountSummary.grantsCard.alt': 'subventions',
  'accountSummary.referCard.alt': 'porcin',
  'accountSummary.referCard.referTitle': 'Parrainez un ami et gagnez ',
  'accountSummary.referCard.referAmount': '100,00 $',
  'accountSummary.referCard.referMessage1':
    'Partagez ce code unique avec vos amis et votre famille : ',
  'accountSummary.referCard.referMessage2':
    '. Vous pouvez aussi copier et partager le lien ci-dessous.',
  'accountSummary.referCard.referButton': 'En savoir plus',
  'accountSummary.programMatcherCard.headline.text1': 'Trouvez ',
  'accountSummary.programMatcherCard.headline.text2': 'le meilleur programme',
  'accountSummary.programMatcherCard.headline.text3':
    ' pour la carrière de votre enfant',
  'accountSummary.totalSavings': 'Épargne totale',
  'accountSummary.savings': 'des économies',
  'accountSummary.net': 'Rapporter',
  'accountSummary.earnings': 'Gains',
  'accountSummary.grants': 'Subventions',
  'accountSummary.savingsGrowth': "Croissance de l'épargne",
  'accountSummary.recentTransactions': 'Transactions récentes',
  'accountSummary.viewHistory': "Afficher l'historique des comptes",
  'accountSummary.embarkGlidePath.alt': 'Trajectoire de descente',
  'accountSummary.embarkGlidePath.Image':
    "Embarquer l'image de l'avantage de l'investissement Glide Path",
  'accountSummary.embarkGlidePath.header':
    "Quel est l'avantage du placement Embark à parcours ajusté ?",
  'accountSummary.embarkGlidePath.description.paraOne':
    'Votre REEE réunit les cotisations que vous avez faites au fil des ans, les subventions du gouvernement et les gains que vous avez réalisés grâce à la croissance composée du placement de vos cotisations et des subventions.',
  'accountSummary.embarkGlidePath.description.paraTwo':
    "Avec le mécanisme de parcours ajusté, la répartition de l'actif évolue selon l'âge de votre enfant. Lorsque votre enfant est plus jeune on met l'emphase sur la croissance en investissant dans des actions. À mesure que les études postsecondaires de votre enfant approchent, nous investissons de manière plus prudente, en mettant l'emphase sur des titres à revenu fixe afin de préserver votre épargne.",
  'schoolType.universityOption': 'Université',
  'schoolType.collegeOption': 'Collège',
  'schoolType.tradeOption': 'Une école de commerce',
  'schoolType.apprenticeOption': 'Apprentissage',
  'programType.universityOption': 'Université',
  'programType.collegeOption': 'Collège communautaire',
  'programType.tradeOption':
    "École privée de métiers, de formation professionnelle ou d'enseignement professionnel",
  'programType.otherOption': 'Autre',
  'accountHistory.title': 'Historique des comptes',
  'accountHistoryList.datePickerLabel': 'Activité pour',
  'accountHistoryList.accountTransactionsListLabel': 'Transactions de compte',
  'accountHistoryList.loadMoreButtonLabel': 'En voir plus',
  'accountHistoryList.scrollToTopButtonLabel': 'Retour au sommet',
  'accountHistoryList.dateRangeOptions.last-6-months': '6 derniers mois',
  'accountHistoryList.dateRangeOptions.ytd': "Depuis le début de l'année",
  'accountHistoryList.noTransactions.last-6-months':
    "Il n'y a pas de transactions pour les 6 derniers mois",
  'accountHistoryList.noTransactions.ytd':
    "Il n'y a pas de transactions pour l'année en cours",
  'accountHistoryList.noTransactions.part1':
    "Il n'y a pas de transactions pour",
  'accountPlanActivity.title': 'Activité du régime',
  'accountPlanActivity.recentLabel': 'Récente',
  'accountPlanActivity.viewLink': 'Voir tout',
  'programMatcherNotice.headline':
    " urrait fréquenter l'université en septembre prochain !",
  'programMatcherNotice.text':
    'Explorez les meilleures écoles et programmes pour soutenir la carrière de leurs rêves.',
  'accountBeneficiaryProfile.headline': 'Mon futur étudiant',
  'accountBeneficiaryProfile.totalCostHeadline': 'Coût total',
  'accountBeneficiaryProfile.totalCostText': 'Projection pour',
  'educationGoal.title': "Coûts de d'études",
  'educationGoal.schoolType': "Type d'école",
  'educationGoal.yearsOfTuition': 'Années de scolarité',
  'educationGoal.schoolLocation': "Emplacement de l'école",
  'educationGoal.schoolLocationError':
    "Veuillez choisir l’emplacement de l'école.",
  'educationGoal.tuitionFees': 'Droits de scolarité',
  'educationGoal.residenceAndMeals': 'Résidence et repas',
  'educationGoal.residenceAndMealsDescription':
    'Hébergement, loyers, services, internet, nourriture',
  'educationGoal.booksAndSupplies': 'Livres et fournitures',
  'educationGoal.booksAndSuppliesDescription':
    'Livres, portable, matériel, fournitures artistiques, logiciels',
  'educationGoal.personalExpenses': 'Dépenses personnelles',
  'educationGoal.personalExpensesDescription': 'Loisirs, cellulaire, vêtements',
  'educationGoal.liveAwayOption': 'Habiter sur place',
  'educationGoal.liveHomeOption': 'Habiter à la maison',
  'educationGoal.alertText1': 'Nota',
  'educationGoal.alertText2':
    "la projection des coûts est ajustée selon l'inflation et elle n'est qu'à titre d'illustration. D'après les données de « Statistique Canada ».",
  'educationGoalSetup.description1': "Établissons un objectif d'études pour",
  'educationGoalSetup.description2': "et estimons le coût d'une école en",
  'educationGoalCustomize.headline': 'Personnaliser ce qui est inclu',
  'educationGoalCustomize.optionsTitle': 'Autres coûts à prévoir',
  'educationGoalChart.description1': 'Ces coûts sont des projections pour',
  'educationGoalChart.description2': 'quand',
  'educationGoalChart.description3': 'devrait être aux études',
  'educationGoalChart.year': 'année',
  'educationGoalChart.years': 'ans',
  'educationGoalChart.universityInnerLabel': "d'université",
  'educationGoalChart.collegeInnerLabel': 'du collège',
  'noPlanActivity.description':
    'Aucune activité sur le régime pour l’instant. Vos cotisations, retraits et subventions s’afficheront ici.',
  'noTransactionsMessage.heading':
    "Il n'y a actuellement aucune transaction existante pour ce plan",
  'noTransactionsMessage.descriptionPart1':
    'Si vous avez des transactions passées et croyez que vous avez reçu ce message par erreur, veuillez',
  'noTransactionsMessage.descriptionLinkLabel': 'Nous contacter',
  'noTransactionsMessage.descriptionPart2': 'directement pour le soutien.',
  'bankAccountSelect.legend': 'Choisissez un compte',
  'onboardingReview.promoTitle':
    'Avez-vous un code fourni par un conseiller ou un code promotionnel?',
  'onboardingReview.label': 'Vérification de votre demande',
  'onboardingReview.headline': 'Passons rapidement en revue votre demande',
  'onboardingReview.SINPartOne': 'Quel est le numéro d’assurance sociale de',
  'onboardingReview.SINPartTwo': '?',
  'onboardingReview.cancelBtn': 'Annuler',
  'onboardingReviewRESPSection.title': 'Régime étudiant Embark',
  'onboardingReviewRESPSection.iconAlt': 'Parent',
  'onboardingReviewSubscriberSection.title': 'Profil',
  'onboardingReviewSubscriberSection.iconAlt': 'Licence',
  'onboardingReviewAccountDetailsSection.title': 'Profil d’investissement',
  'onboardingReviewAccountDetailsSection.iconAlt': 'Document',
  'onboardingReviewBeneficiarySection.title': 'Profil de l’enfant',
  'onboardingReviewBeneficiarySection.question':
    'Combien d’enfants souhaitez-vous ajouter à votre REEE?',
  'onboardingReviewBeneficiarySection.relationshipLabel': 'Relation',
  'onboardingReviewBeneficiarySection.primaryCaregiverLabel':
    "Êtes-vous l'aidant principal?",
  'onboardingReviewBeneficiarySINSection.title': "Numéro d'assurance sociale",
  'onboardingTandC.description':
    'Veuillez examiner ces conditions. Une copie de toutes les conventions sera disponible pour votre référence sous les paramètres du compte.',
  'onboardingTandC.submitLabel': 'Soumettre votre demande',
  'onboardingSuccess.heading': 'Épargnons pour leurs études',
  'onboardingSuccess.message1':
    'Découvrez votre tableau de bord, définissez vos objectifs et commencez à épargner pour les études de ',
  'onboardingSuccess.message2': '!',
  'onboardingSuccess.contribute': 'Cotiser',
  'onboardingSuccess.dashboard': 'Tableau de bord',
  beneficiary: 'Bénéficiaire',
  'tandC.dialogTitle': 'Voulez-vous vraiment quitter?',
  'tandC.dialogContent': 'Votre demande ne sera pas envoyée.',
  'tandC.continueBtnLabel': 'Oui, je veux quitter',
  'tandC.cancelBtnLabel': 'Non, je veux continuer',
  email: 'Courriel',
  'remindCoSubDialog.email': 'Adresse courriel',
  'manageAccount.personalInformation': 'Renseignements personnels',
  'manageAccount.noLinkedBankAccounts':
    'Vous n’avez pas de comptes bancaires liés',
  'manageAccount.linkedBankAccountsError':
    'Quelque chose ne va pas. Veuillez réessayer plus tard.',
  'manageAccount.noLinkedBankAccountsImg': 'Pas de comptes bancaires',
  'manageAccount.linkedBankAccountsErrorImg': 'Erreur de comptes bancaires',
  'manageAccount.title': 'Compte',
  'manageAccount.accountCircle.alt': 'Icône de cercle de compte',
  'manageAccount.profile': 'Profil',
  'manageAccount.profile.comment':
    'Examiner et mettre à jour les renseignements personnels',
  'manageAccount.creditCard.alt': 'Icône de carte de crédit',
  'manageAccount.linkedBankAccounts': 'Comptes bancaires liés',
  'manageAccount.linkedBankAccounts.comment':
    'Consulter et gérer des comptes bancaires',
  'manageAccount.document.alt': 'Icône Documents',
  'manageAccount.addPerson.alt': 'Ajouter une icône de personne',
  'manageAccount.Documents': 'Documents',
  'manageAccount.Documents.comment': 'Relevés d’accès et relevés d’impôt',
  'manageAccount.co-sub': 'Ajouter un titulaire de compte conjoint',
  'manageAccount.co-sub.alt': 'Ajouter un titulaire de compte conjoint Icon',
  'manageAccount.co-sub.comment': 'Inviter un cosouscripteur à votre régime',
  'manageAccount.bene': 'Épargner pour un autre enfant',
  'manageAccount.bene.alt': 'Épargner pour un autre enfant Icon',
  'manageAccount.bene.comment': 'Ajouter un nouveau bénéficiaire à un REEE.',
  'manageAccount.addPlanMembers': 'Ajouter des participants au régime',
  'manageAccount.addAPlan': 'Ouvrir un nouveau REEE',
  'manageAccount.addAPlanComment': 'Ouvrir un nouveau REEE',
  'manageAccount.addAPlan.alt': 'Ouvrir un nouveau REEE',
  'manageAccount.addPlanMembersComment': 'Ajouter un enfant ou un co-abonné',
  'addPlanMembers.label': 'Ajouter des participants au régime',
  'addPlanMembers.memberType.headline':
    'Qui aimeriez-vous ajouter à votre forfait ?',
  'addPlanMembers.addChildIndividualPlanError':
    "Il ne peut y avoir qu'un seul enfant dans le cadre d'un régime individuel. Pour ajouter un enfant, sélectionnez un forfait familial ou prenez rendez-vous pour ouvrir un nouveau forfait.",
  'addPlanMembers.cosub.label': 'Ajouter un co-abonné',
  'addPlanMembers.cosub.headline': 'Envoyer une invitation',
  'addPlanMembers.cosub.description1':
    "Invitez un époux ou un conjoint de fait à contribuer à l'éducation de",
  'addPlanMembers.cosub.description2': '.',
  'addPlanMembers.cosub.description3':
    'Nous les inviterons en leur envoyant un lien sécurisé par e-mail.',
  'addPlanMembers.cosub.description4': 'Cette invitation',
  'addPlanMembers.cosub.description5': 'expire dans 48 heures.',
  'addPlanMembers.child.label': 'AJOUTER UN BÉNÉFICIAIRE',
  'addPlanMembers.childReview.headline':
    'Faisons un examen rapide des informations de votre enfant',
  'addPlanMembers.childSuccess.headline': 'ajouté à votre forfait',
  'coApplicant.coSubscriberEmail': 'Email du co-abonné',
  'coApplicant.coSubscriberFirstName': 'Prénom légal du co-abonné',
  'coApplicant.coSubscriberLastName': 'Nom de famille légal du co-abonné',
  'coApplicant.coSubLegalFirstName': 'Prénom légal',
  'coApplicant.coSubLegalLastName': 'Nom légal',
  'coApplicant.coSubscriberNameInfo':
    "Le nom sur leur pièce d'identité émise par le gouvernement.",
  'coApplicant.coSubscriberFirstNameError': 'Veuillez entrer leur prénom.',
  'coApplicant.coSubscriberLastNameError':
    'Veuillez entrer leur nom de famille.',
  'coApplicant.existingCoSubError':
    "Un co-abonné est déjà fiché. Vous ne pouvez ajouter qu'un seul co-abonné à votre forfait.",
  'coApplicantDialog.title': 'Vous invitez',
  'coApplicantDialog.description':
    'recevra une invitation pour cotiser à votre régime étudiant Embark.',
  'language.en-US': 'English',
  'language.fr-CA': 'Français',
  'language.en': 'Anglais',
  'language.fr': 'Français',
  'language.cn': 'Cantonais',
  'addressFields.title': 'Adresse de résidence',
  'withdrawal.title': 'FAIRE UN RETRAIT',
  'withdrawal.selectBankAccountLegend': 'Dans quel compte ?',
  'withdrawal.amountPopupHeader':
    'Ne vous inquiétez pas, votre argent est en sécurité.',
  'withdrawal.amountPopupDescription':
    "aura accès au reste du montant après avoir terminé 13 semaines d'école.\n  Conformément aux lignes directrices de l'ARC, au cours des 13 premières semaines d'école, le retrait des subventions et des gains est limité à 5 000 $ pour le programme à temps plein et à 2 500 $ pour le programme à temps partiel.",
  'withdrawal.amountQuestion': 'Quel montant souhaitez-vous retirer ?',
  'withdrawal.netContributionsAmountPart1': 'disponibles pour le ',
  'withdrawal.netContributionsAmountPart2': 'retrait',
  'withdrawal.noRespAccountFound': "Je n'ai pas trouvé le compte RESP.",
  'withdrawal.maxNetAmountErrorPart1':
    'Vous ne pouvez retirer que vos cotisations nettes.',
  'withdrawal.maxNetAmountErrorPart2':
    'Pour le retrait des revenus et des subventions, veuillez soumettre une demande de PAE.',
  'withdrawal.confirmationDialogTitle': 'Vous êtes sûr de vouloir continuer ?',
  'withdrawal.confirmationDialogDescriptionPart1': 'pourraient perdre',
  'withdrawal.confirmationDialogDescriptionPart2':
    'en subventions gouvernementales.',
  'withdrawal.confirmationDialogContinue': 'Oui, continuez.',
  'withdrawal.beneficiarySelectionQuestion': "Qui fréquentera l'école ?",
  'withdrawal.beneficiarySelectionDropdownLabel': 'Étudiant',
  'withdrawalEntry.title': "C'est l'heure de l'école!",
  'withdrawalEntry.body':
    "Félicitations pour l'inscription de votre enfant aux études postsecondaires. Retirons vos économies pour les frais de scolarité, l'internat, les livres, les fournitures, le transport et d'autres éléments essentiels.",
  'withdrawalEntry.footerText':
    'Retrait pour dépenses non scolaires ou personnelles ?',
  'withdrawalEntry.appointment': 'Prenez rendez-vous',
  'withdrawalType.label': 'Type de retrait',
  'withdrawalType.headline':
    "Vous vous retirez pour l'éducation de votre enfant ?",
  'withdrawalType.pseAlertMessage':
    "La vérification de l'inscription (VoE) est nécessaire pour effectuer ce retrait.",
  'withdrawalType.nonpseAlertMessage':
    'Les retraits hors éducation entraîneront la perte des subventions gouvernementales.',
  getMoreInformation: "Plus d'informations",
  'withdrawalSelect.label': 'Données sur le régime',
  'nonPSEWithdrawal.headline': 'Combien souhaitez-vous retirer ?',
  'nonPSEWithdrawal.note':
    "Vous ne pouvez retirer vos cotisations qu'à des fins non éducatives.",
  'nonPSEWithdrawal.amountRequiredError':
    'Veuillez entrer un montant de retrait valide.',
  'withdrawalDetails.label': 'Vérifier',
  'withdrawalDetails.headline': 'Récapitulatif',
  'withdrawalDetails.years': 'années',
  'withdrawalDetails.year': 'an',
  'withdrawalDetails.1': 'Première',
  'withdrawalDetails.2': 'Seconde',
  'withdrawalDetails.3': 'Troisième',
  'withdrawalDetails.4': 'Quatrième',
  'withdrawalDetails.5': 'Cinquième',
  'withdrawalDetails.6': 'Sixième',
  'withdrawalDetails.7': 'Septième',
  'withdrawalDetails.8': 'Huitième',
  'withdrawalDetails.9': 'Neuvième',
  'withdrawalDetails.note':
    'Veuillez prévoir un délai de 5 à 7 jours pour que le retrait s’affiche à votre compte bancaire. Tout retrait effectué un jour férié ou de fin de semaine sera traité le jour ouvrable suivant.',
  'withdrawalSuccess.headline': 'Retrait terminé !',
  'withdrawalSuccess.message1': 'Vous avez demandé avec succès le retrait de',
  'withdrawalSuccess.needToApplyEAP': 'Neet demander un PAE? ',
  'withdrawalSuccess.applyNow': 'Appliquer maintenant',
  'withdrawalSuccess.congratulations': 'Félicitations.',
  'withdrawalSuccess.wayToSchool': "le chemin vers l'école",
  'PSEWithdrawal.label': 'Retrait du ESP',
  'PSEEnrolmentVerification.label': "Vérification de l'inscription",
  'PSEEnrolmentVerification.headline': "Qui va à l'école",
  'PSEEnrolmentVerification.schoolLegend1': "Détails de l'école",
  'PSEEnrolmentVerification.schoolLegend2': 'fréquentera-t-il ?',
  'PSEEnrolmentVerification.schoolLegend3': 'le bénéficiaire',
  'PSEEnrolmentVerification.weeksEnrolledLegend1':
    'Pendant combien de semaines consécutives, au cours des 12 derniers mois,',
  'PSEEnrolmentVerification.weeksEnrolledLegend2': "a-t-il fréquenté l'école ?",
  'PSEEnrolmentVerification.weeksEnrolledLegend3': 'le bénéficiaire',
  'PSEEnrolmentVerification.beneficiaryRequiredError':
    'Veuillez sélectionner un étudiant.',
  'PSEEnrolmentVerification.weeksEnrolledTitle1':
    'Au cours des 12 derniers mois, combien de semaines consécutives',
  'PSEEnrolmentVerification.weeksEnrolledTitle2':
    "a-t-elle fréquenté l'école ?",
  'PSEEnrolmentVerification.weeksEnrolledLabel': 'Semaines inscrites',
  'PSEEnrolmentVerification.schoolWeeksEnrolledRequiredError':
    "Veuillez saisir le nombre de semaines d'inscription.",
  'PSEEnrolmentVerification.schoolNameError':
    "Veuillez entrer le nom de l'école sur le VoE.",
  'PSEEnrolmentVerification.schoolPostalHelper': 'Le code postal sur leur VoE.',
  'PSEEnrolmentVerification.schoolPostalRequiredError':
    'Veuillez saisir un code postal valide sur la CDA',
  'PSEEnrolmentVerification.programTypeLabel': 'Type de programme',
  'PSEEnrolmentVerification.programTypeRequiredError':
    'Veuillez entrer le type de programme.',
  'PSEEnrolmentVerification.durationLabel': 'Durée (en années)',
  'PSEEnrolmentVerification.durationError': 'Veuillez sélectionner la durée.',
  'PSEEnrolmentVerification.programYearLabel': 'Année du programme',
  'PSEEnrolmentVerification.programYearError':
    "Veuillez sélectionner l'année du programme.",
  'PSEEnrolmentVerification.startDateLabel': 'Date de début',
  'PSEEnrolmentVerification.startDateError':
    'Veuillez sélectionner la date de début.',
  'PSEEnrolmentVerification.alertError':
    'Veuillez indiquer tous les renseignements pour continuer.',
  'PSEEnrolmentVerification.verificationOfEnrolment':
    "Vérification de l'inscription (VoE)",
  'PSEEnrolmentVerification.fileUploadDescription':
    'Fournir au format PDF, PNG, JPG.',
  'PSEEnrolmentVerification.fileUploadError':
    'Veuillez télécharger une copie numérique de votre VoE.',
  'PSEEnrolmentVerification.enrolmentVerificationInfo':
    "L'ARC exige une vérification de l'inscription",
  'PSEEnrolmentVerification.enrolmentVerificationHeading':
    'Tout savoir sur la VoE.',
  'PSEEnrolmentVerification.enrolmentVerification1':
    "L'ARC exige un document de vérification de l'inscription (VoE) pour ce retrait. Celui-ci peut être obtenu auprès du bureau du registraire ou sur le site Web de l'école.",
  'PSEEnrolmentVerification.enrolmentVerification2':
    "Nous n'acceptons pas les offres d'admission, les lettres d'acceptation, les confirmations par e-mail ou les fichiers protégés par mot de passe.",
  'PSEEnrolmentVerification.viewSampleVoE': 'Voir un exemple de VoE',
  enrolmentType: "Type d'inscription",
  'enrolmentInfo.title': "Informations d'inscription",
  student: 'Étudiante',
  educationalInstitution: "Établissement d'enseignement",
  programType: 'Type de programme',
  programYear: 'Année du programme',
  programLength: 'Durée du programme',
  weeksEnrolled: 'Semaines inscrites',
  voeFile: 'Fichier VOE',
  upcoming: 'A venir',
  'scheduledContributionsList.calendar.alt': 'Icône de calendrier',
  'scheduledContributions.title': 'Calendrier des cotisations',
  'noScheduledContributions.viewAll': 'Voir tout',
  'noScheduledContributions.description1':
    'Aucune cotisation prévue pour le moment. ',
  'noScheduledContributions.description2':
    'Programmez votre première cotisation maintenant.',
  'scheduledContributionsDetails.title': 'Vos cotisations prévues',
  'scheduledContributionsDetailsList.dateLabel': 'Paiement à venir',
  'scheduledContributionsDetailsList.cancelDescriptionPart1':
    'Veuillez annuler avant 21h00 EST, le',
  'scheduledContributionsDetailsList.cancelDescriptionPart2':
    ', afin de vous assurer que votre paiement ne sera pas traité.',
  'scheduledContributionsDetailsList.cancelButton': 'Annuler une cotisation',
  'scheduledContributionsDetailsList.cancelButtonLabel': 'Oui, annuler',
  'scheduledContributionsDetailsList.confirmationDialogTitle':
    'Voulez-vous vraiment l’annuler?',
  'scheduledContributionsDetailsList.confirmationDialogContent1':
    'L’annulation de votre',
  'scheduledContributionsDetailsList.confirmationDialogContent2':
    'cotisation prévue de',
  'scheduledContributionsDetailsList.confirmationDialogContent3':
    'sera définitive.',
  'scheduledContributionsDetailsList.confirmationDialogCancel': 'Non, gardez',
  'scheduledContributionsDetailsListError.title': 'Une erreur est survenue.',
  'scheduledContributionsDetailsListError.message':
    'Veuillez réessayer plus tard.',
  'cancelContributionSuccess.alt': 'Annuler le succès de la contribution',
  'cancelContributionSuccess.headline':
    'Nous avons annulé votre cotisation prévue',
  'cancelContributionSuccess.message':
    'Un email de confirmation vous a été envoyé.',
  'coSubOnboardingCannotBeCoSub.cantContinue':
    'Désolé, vous ne pouvez pas être cosouscripteur',
  'coSubOnboardingCannotBeCoSub.header':
    'Désolé, vous ne pouvez pas être cosouscripteur',
  'coSubOnboardingCannotBeCoSub.description1':
    'Les cosouscripteurs doivent être mariés ou conjoints de fait.',
  'coSubOnboardingCannotBeCoSub.description2':
    'Découvrez nos régimes étudiants Embark et ouvrez votre propre compte REEE.',
  'coSubOnboardingCannotBeCoSub.openResp': 'Ouvrir un REEE',
  'coSubOnboardingPopup.alertDialogPopupMessage':
    'Votre candidature ne sera pas soumise.',
  'withdrawal.PSE.label': "Retrait de l'enseignement",
  'withdrawal.NONPSE.label': 'Retrait non éducatif',
  'withdrawalAmount.label': 'Montante',
  'withdrawalAmount.headline': 'Quel montant souhaitez-vous retirer ?',
  'withdrawalAmount.error': 'Veuillez saisir un montant de retrait valide.',
  'withdrawalAmount.grantsNote.title': 'Subventions et revenus',
  'withdrawalAmount.grantsNote.body':
    'Par défaut, nous retirons de vos subventions et de vos gains avant les cotisations.',
  'withdrawalAmount.grantsNote.actionLabel': 'Réaffecter',
  'withdrawalAmount.grantsNote.resetLabel': 'Utilisation par défaut',
  'withdrawalAmount.breakdown.grantsLabel': 'Subventions et revenus',
  'withdrawalAmount.breakdown.contributionsLabel': 'Cotisations',
  'reAllocationDialog.title': 'Répartir votre retrait',
  'reAllocationDialog.totalLabel': 'Retrait total',
  'vouchedIDV.progressIndicatorLoading': 'Chargement',
  'vouchedIDV.crossDeviceTitle': 'Vérification de votre pièce d’identité',
  'vouchedIDV.crossDeviceInstructions':
    'Prenez une autophoto ainsi qu’une photo de votre pièce d’identité pour confirmer instantanément votre identité.',
  'vouchedIDV.qrDesktopInstructions':
    'Les options de transfert mobile ne sont pas prised en charge en mode Sandbox. Veuillez utiliser votre webcam à la place. {qrDesktopLink}',
  'vouchedIDV.qrDesktopLink': 'Démarrer la webcam',
  'vouchedIDV.upperIdInstructions':
    "Veuillez prendre une photo nette d'une pièce d'identité valide et non périmée émise par le gouvernement (comme un permis de conduire ou un passeport).",
  'vouchedIDV.retryMessageInvalidIdPhoto':
    'Veuillez téléverser une pièce d’identité valide délivrée par le gouvernement.',
  'vouchedIDV.upperFaceInstructions':
    'Prenez une photo de vous. Vous ne devez pas porter de lunettes, de chapeau ou d’obstructions faciales, et personne d’autre ne doit apparaître sur la photo.',
  'vouchedIDV.lowestFaceInstructions':
    'Les photos de photos ne sont pas autorisées.',
  'vouchedIDV.cameraFaceLabelShowFace': 'Prendre une photo',
  'vouchedIDV.success': 'Merci, vous avez terminé.',
  'vouchedIDV.mobileHandoffDoneMessage':
    'Vous pouvez maintenant reprendre la configuration de votre profil Embark.',
  'vouchedIDV.stepTitlesFrontId': 'Étape 1',
  'vouchedIDV.stepTitlesFace': 'Étape 2',
  'idVerificationStart.headline': 'Vérifions votre identité',
  'idVerificationStart.topDescription':
    'Pour sécuriser vos renseignements personnels, nous devons vérifier votre identité, ce que vous pouvez faire de chez vous.',
  'idVerificationStart.requirementsTitle': 'Voici ce dont vous aurez besoin :',
  'idVerificationStart.requirement1':
    'La fonction appareil photo de votre dispositif',
  'idVerificationStart.requirementText1':
    'pour confirmer votre identité en temps réel',
  'idVerificationStart.requirement2':
    "Une pièce d'identité valide avec photo délivrée par le gouvernement",
  'idVerificationStart.requirementText2':
    '(p. ex., permis de conduire provincial, passeport canadien ou carte de résident permanent)',
  'idVerificationStart.requirement3': 'Une photo de vous',
  'idVerificationStart.requirementText3':
    "pour la comparer à votre pièce d'identité",
  'idVerificationStart.bottomDescription':
    'Suivez les instructions à l’écran pour suivre le processus de façon instantanée et sécuritaire.',
  'idVerificationSuccess.title': 'Super! Continuons',
  'idVerificationSuccess.message':
    "Maintenant que nous avons créé votre profil personnel, passons à votre profil d'investissement.",
  'idVerificationFail.title': 'Échec de la vérification',
  'idVerificationFail.message':
    'Désolé, la vérification de votre identité a échoué. Veuillez réessayer.',
  'idVerificationStop.title':
    'Désolé, vous avez atteint le nombre maximum de tentatives de vérification d’identité.',
  'idVerificationStop.messageText1': 'Veuillez ',
  'idVerificationStop.messageLink': 'prenez rendez-vous',
  'idVerificationStop.messageText2': ' avec nous pour poursuivre le processus.',
  'educationTargetInfo.description.text1':
    "Cette projection est fondée sur des hypothèses et n'a qu'un caractère indicatif. Il s'agit de la valeur totale projetée de votre REEE au moment où votre enfant devrait commencer ses études postsecondaires.",
  'educationTargetInfo.description.text2':
    "La valeur projetée comprend les cotisations et les subventions gouvernementales que vous êtes censé accumuler, et le revenu gagné sur ces cotisations et subventions. La valeur marchande totale de votre régime peut fluctuer quotidiennement selon la valeur des placements qui s'y trouvent. Les rendements financiers et la valeur réelle future de votre REEE ne peuvent être prédits ni garantis.",
  'educationTargetInfo.description.text3':
    "Si vous n'avez pas cotisé, nous supposons une cotisation de 100 $ par mois. À titre d'exemple uniquement.",
  'rateSelectorInfo.description':
    'Toutes les projections sont fournies à titre indicatif et ne garantissent pas les résultats réels des placements.',
  'totalCosts.university': 'Université',
  'totalCosts.college': 'Collège',
  'educationProjection.byYear': "d'ici",
  'educationProjection.year': 'an',
  'educationProjection.university': 'université',
  'educationProjection.college': 'collège',
  'educationProjection.of.college': 'du ',
  'educationProjection.of.university': "d'",
  'educationProject.glidePathTitle': 'Votre épargne de REEE',
  'educationProjection.contribute': 'Cotiser',
  'educationProjection.yourEducation': 'de votre objectif pour l’éducation',
  'educationProjection.contributionButton': 'Cotisations prévues',
  'educationProjection.primaryRoR': 'RDR de 1 à 4 %',
  'educationProjection.secondaryRoR': 'RDR de 1 à 8 %',
  'estimatedGrowth.headline': "Faites fructifier l'épargne de votre REEE",
  'estimatedGrowth.description':
    'Découvrez combien vous pouvez épargner en déposant des cotisations supplémentaires. Amusez-vous avec différents montants pour voir à quel point votre épargne peut augmenter.',
  'estimatedGrowth.cost.title': "Coût moyen de l'éducation",
  'estimatedGrowth.cost.description1': 'droits de scolarité',
  'estimatedGrowth.cost.description2': 'droits de scolarité et résidence',
  'projectionChart.dataLabel1': 'Cotisations',
  'projectionChart.dataLabel2': 'Subventions',
  'projectionChart.dataLabel3': 'Revenu de placement',
  'projectionChart.totalLabel': 'Total :',
  'rateSelector.option1': '3 %',
  'rateSelector.option2': '4 %',
  'rateSelector.option3': '5 %',
  'enrolmentSummary.title': "Sommaire de l'inscription",
  'enrolmentSummary.accountNumber': 'Numéro de compte',
  'enrolmentSummary.firstName': 'Prénom',
  'enrolmentSummary.middleName': 'Deuxième prénom légal',
  'enrolmentSummary.lastName': 'Nom',
  'enrolmentSummary.dateOfBirth': 'Date de naissance',
  'enrolmentSummary.SIN': "Numéro d'assurance sociale",
  'enrolmentSummary.employmentStatus': 'Statut professionnel',
  'enrolmentSummary.jobTitle': "Intitulé de l'emploi",
  'enrolmentSummary.householdIncome': 'Revenu brut',
  'enrolmentSummary.invesmentExperience': 'Expérience en placement',
  'enrolmentSummary.riskProfile': 'Profil de risque',
  'enrolmentSummary.electronicSignature': 'Signature électronique',
  'enrolmentSummary.subscriber': 'Abonné',
  'enrolmentSummary.ipAddress': 'Adresse IP',
  'enrolmentSummary.timestamp': 'Horodatage',
  'enrolmentSummary.EAA': 'EAA',
  'enrolmentSummary.acknowledgements': 'Remerciements',
  'enrolmentSummary.beneficiary': 'bénéficiaire',
  'enrolmentSummary.relationship': 'Relation avec le souscripteur',
  'enrolmentSummary.grants': 'Subventions',
  'enrolmentSummary.CESG': 'Subvention canadienne pour l’épargne-études (SCEE)',
  'enrolmentSummary.CLB': 'Bon d’études canadien (BEC)',
  'enrolmentSummary.ACESG':
    'Subvention canadienne pour l’épargne-études supplémentaire (SCEES)',
  'enrolmentSummary.BCTESG':
    "Subvention pour l'épargne-études et l'épargne-formation de la Colombie-Britannique (SEEEFCB)",
  'enrolmentSummary.QESI': "Incitatif québécois à l'épargne-études (IQEE)",
  'enrolmentSummary.separator': ' :',
  'studentsCard.beneficiaries': 'Vos enfants',
  'schoolCostCard.setGoal':
    'Choisissez une photo du profil et fixez-vous un objectif d’épargne-études.',
  'beneficiarySchoolCosts.headline': 'Bénéficiaires',
  'programDetails.changeProfession.btn': 'Choose another career',
  'programDetails.changeProfession.looking': 'Looking for something else?',
  'programDetails.relatedCareers.estimatedSalary': 'Estimated salary ',
  'programDetails.year': 'y',
  'programDetails.tuitionCost': 'Estimated annual tuition',
  'programDetails.tuitionDuration': 'Duration of the program',
  'programDetails.disclaimer.headline': 'Disclaimer',
  'programDetails.disclaimer.content':
    'All data displayed here is based on information available as of January 2024. Tuition fees and other costs are subject to change, and the figures provided are approximate. For the most current and accurate information, please consult the official websites of the respective universities or contact their financial services offices.',
  'programDetails.disclaimer.icon': 'Arrow icon',
  'programDetails.enrolmentRequirements.headline': 'Enrolment requirements',
  'programDetails.enrolmentRequirements.item':
    'Completion of secondary school or equivalent',
  'programDetails.relatedCareers.headline': 'Explore related careers',
  'institutionsGroup.kilometers': 'km',
  'schoolFilter.near': 'Schools near you',
  'schoolFilter.canadaWide': 'Canada Wide',
  'programMatcherMap.salary': 'Potential Starting Salary',
  'programMatcherMap.duration': 'Duration:',
  'programMatcherMap.estimatedTuition': 'Estimated annual tuition:',
  'programMatcherMap.specialization': 'Specialization needed',
  'programMatcherMap.furtherEducationRequired':
    '"Formation Supplémentaire Requise"',
  'programMatcherMap.chosenCareer': 'Your Chosen Career: ',
  'programMatcherMap.listHeader': 'School for an Aspiring',
  'programMatchMap.schoolPin.tuitionText': 'Avg Tuition: ',
  'programMatchMap.schoolPin.tuitionYear': '/yr',
  'mapView.duration': 'Duration:',
  'mapView.estimatedTuition': 'Estimated annual tuition:',
  'mapView.showMap': 'Show map',
  'mapView.showList': 'Show list of schools',
  'mapView.noSchools': 'No schools found near you',
  'mapView.selectDifferentProvince':
    'Please try selecting a different province.',
  'programsPanel.programsFound': 'See Your Program Possibilities: ',
  'programMatcher.schoolList.campus': 'Campus',
  'programMatcher.schoolList.programs': 'Program(s)',
  'programMatcher.addressFields.title': 'Residential address',
  'programMatcher.addressFields.label': "You're here",
  'programMatcher.mapChip.groceries': 'Groceries',
  'programMatcher.mapChip.transit': 'Transit',
  'programMatcher.mapChip.cafe': 'Cafes',
  'programMatcher.mapChip.restaurant': 'Restaurants',
  'programMatcher.mapChip.groceriesAlt': 'shopping cart icon',
  'programMatcher.mapChip.transitAlt': 'tram icon. public transit icon',
  'programMatcher.mapChip.cafeAlt': 'coffe mug. cafes, icon',
  'programMatcher.mapChip.restaurantAlt': 'dining icon. restaurants',
  'programMatcher.map.groceryPinAlt': 'google map pin with grocery store icon',
  'programMatcher.map.transitPinAlt':
    'google map pin with public transit, tram icon',
  'programMatcher.map.cafePinAlt': 'google map pin with cafe, coffe mug icon',
  'programMatcher.map.restaurantPinAlt': 'google map pin with restaurant icon',
  'programMatcher.map.defaultPinAlt':
    'google map pin with default location icon',
  'programMatcher.map.groceryCluster': 'Grocery stores',
  'programMatcher.map.transitCluster': 'Transit stations',
  'programMatcher.map.cafeCluster': 'Cafes',
  'programMatcher.map.restaurantCluster': 'Restaruants',
  'schoolGroup.headline': 'écoles trouvées',
  'programMatcher.back': 'Back',
  'programMatcher.done': 'Continue exploring',
  'programMatcher.years': 'years',
  'programMatcher.admissionRequirements': 'Admission requirements:',
  'programMatcher.selection.requiredToContinueError':
    'Please select an option to continue.',
  'programMatcher.selection.requiredError': 'Please select an option.',
  'pickProfessions.title1': 'Navigate their future with ',
  'pickProfessions.title2': "Embark's Career & School Matcher",
  'pickProfessions.description':
    'The only tool of its kind in Canada, The Embark Career & School Matcher provides need-to-know information, like tuition costs and program requirements, in minutes.',
  'pickProfessions.searchbar.placeholder': 'Search',
  'pickProfessions.button': 'Go',
  'pickProfessions.link.careerList.text': 'Or search all careers',
  'pickProfessions.link.careerList.link': 'here.',
  'careerList.industry.title': 'secteurs',
  'careerList.searchbar.placeholder': 'Explore careers (e.g., Accountant)',
  'careerList.header.searchbtn': 'Search',
  'careerList.occupationGroups.notFound': 'No careers found',
  'searchbar.popular': 'Popular careers',
  'pickProfessions.createdBy': 'Created by',
  'professionInfoForm.name': 'Your career match:',
  'professionInfoForm.salary': 'Estimated annual earnings',
  'professionInfoForm.content.li-1':
    'Conceive, design, build, supervise, operate, construct, and maintain infrastructure projects, including roads, airports, dams, bridges, and water treatment systems.',
  'professionInfoForm.content.li-2':
    'Focus on protecting public and environmental health.',
  'splash.careerProgramMatcher1': '',
  'splash.careerProgramMatcher2': 'Career ',
  'splash.careerProgramMatcher3': '& School Matcher',
  'splash.createdBy': 'Created by ',
  'splash.subheader':
    "Personalized analysis of your child's interests for tailored guidance on their educational journey and career opportunities.",
  'programMatcher.compareHeader':
    'Check out other schools that offer similar programs',
  'programMatcher.comparePopular': 'Most popular',
  'programMatcher.compareNearest': 'Nearest school',
  'programMatcher.compareTuition': 'Highest tuition',
  'programMatcher.compareEmptySubHeader':
    "Hmm, it seems like there's nothing here!",
  'programMatcher.compareEmptyBody': 'Try exploring other programs.',
  'programMatcher.ageDialog.title': 'How old is your child?',
  'programMatcher.ageDialog.content':
    'We want to better understand your needs and enhance our features for a more tailored experience.',
  'programMatcher.ageDialog.dropdownLabel': "Child's age",
  'programMatcher.feedbackSent.input.alt1': 'heart-image',
  'programMatcher.feedback.header': 'We value your feedback!',
  'programMatcher.feedbackSent.header': 'Thank you for helping us improve!',
  'programMatcher.feedback.body1': 'Did you enjoy your experience?',
  'programMatcher.feedback.body2': 'Let us know your feedback below!',
  'programMatcher.feedbackSent.body1': 'Your feedback could help us make this',
  'programMatcher.feedbackSent.body2':
    'feature even better for users like you.',
  'programMatcher.feedback.input.thumbsUp': 'Yes',
  'programMatcher.feedback.input.alt2': 'Thumbs-up-image',
  'programMatcher.feedback.input.thumbsDown': 'No',
  'programMatcher.feedback.input.alt3': 'Thumbs-down-image',
  'programMatcher.feedback.input.error': 'Maximum 250 characters',
  'programMatcher.feedback.input.textLabel': 'Additional Feedback',
  'programMatcher.feedback.cta1': 'Send',
  'programMatcher.feedback.cta2': 'Close',
  'programMatcher.feedbackSent.cta1': 'Done',
  'programMatcher.carIconAltText': 'car-icon',
  'programMatcher.pencilIconAltText': 'pencil-and-ruler-icon',
  'professionInfoForm.continue': 'Looks good, continue',
  'professionInfoForm.back': 'Not a fit, go back',
  'programMatcherPaywall.content.tagline':
    'This content is available to Embark subscribers.',
  'programMatcherPaywall.content.headline': 'Join Embark’s Community',
  'programMatcherPaywall.content.description':
    'Unlock comprehensive enrolment criteria, insider knowledge on career outcomes, and custom resources designed for proactive students.',
  'programMatcherPaywall.content.cta': 'Join Embark',
  'programMatcherPaywall.content.signIn.title': 'Already a member?',
  'programMatcherPaywall.content.signIn.text': 'To access benefits, ',
  'programMatcherPaywall.content.signIn.link': 'sign in here',
  'programMatcherPaywall.content.activate.text':
    'Did you receive an activation email?',
  'programMatcherPaywall.content.activate.link': 'Activate your account',
  'programMatcherPaywall.card.title': 'Benefits include:',
  'programMatcherPaywall.card.bulletPoint1': 'Personalized Savings Plans',
  'programMatcherPaywall.card.bulletPoint2': 'Advanced Financial Calculators',
  'programMatcherPaywall.card.bulletPoint3': 'Expert Advice',
  'programMatcherPaywall.card.bulletPoint4':
    'Comprehensive Guides and Resources',
  'programMatcherPaywall.card.bulletPoint5': 'Exclusive Webinars and Workshops',
  'programMatcherPaywall.card.bulletPoint6': 'Priority Customer Support',
  'programMatcherPaywall.blurredImage.alt':
    'Blurred background of admissions, driving distance, location, related to the specific occupation school and program of your choice',
  'programMatcherPaywall.checkmark.alt': 'checkmark inside a circle',
  'openRESP.header': 'REEE',
  'openRESP.cta.heading': 'Inscrivez-vous à un REEE',
  'openRESP.cta.description':
    'Inscrivez-vous à un Régime étudiant Embark et commencez à épargner pour l’avenir de votre enfant.',
  'openRESP.cta.button': 'Ouvrir un REEE',
  'openRESP.backgroundImg.alt': 'fond rose avec diverses formes',
  'openRESP.backgroundImgPhone.alt':
    'application utilisée sur téléphone mobile',
  'budgeting.header': 'Coût des études',
  'budgeting.cta.heading': 'C’est presque terminé!',
  'budgeting.cta.descriptionNoResp':
    'Notre outil exclusif de budgétisation est conçu pour vous aider à tirer le meilleur parti de votre REEE. En ouvrant un compte chez nous, vous bénéficierez de nombreux avantages et franchirez une étape décisive pour assurer l’avenir de votre enfant.',
  'budgeting.cta.descriptionResp':
    'Notre outil d’établissement de budget est une fonctionnalité exclusive offerte à nos clients de REEE. Pour tirer le meilleur parti de cet outil, rendez-vous sur votre tableau de bord REEE et débloquez tous les avantages !',
  'budgeting.cta.buttonNoResp': 'Ouvrir un REEE',
  'budgeting.cta.buttonResp': 'Accéder à mon tableau de bord',
  'budgeting.backgroundImg.alt': 'fond rose avec diverses formes',
  'budgeting.backgroundImgPhone.alt':
    'application utilisée sur téléphone mobile',
  'schoolCostCard.title': 'Coût estimé',
  'schoolCostCard.viewProfile': 'Voir le profil',
  'schoolCostCard.createProfile': 'Créer un profil',
  'schoolCostCard.completeProfile': 'Profil complet',
  'schoolCostCard.costTotal': 'Objectif d’épargne-études : ',
  'termsConditions.title': 'Conditions',
  'termsConditions.singleSubscriber.eaaBox1': "J'ai lu et j'accepte la",
  'termsConditions.singleSubscriber.eaaBox2':
    " Je comprends qu'il s'agit du contrat de mon régime",
  'termsConditions.singleSubscriber.disclosureBox1': 'J’ai lu et j’accepte',
  'termsConditions.singleSubscriber.electronicBox1':
    'Livraison électronique des documents fiscaux:',
  'termsConditions.singleSubscriber.electronicBox2':
    "J'accepte la livraison électronique de tous les documents fiscaux, y compris les formulaires, feuillets, reçus ou autres documents ou renseignements que Embark étudiant corp. pourrait être tenu d'envoyer maintenant ou à l'avenir en vertu de la législation fiscale applicable",
  'termsConditions.singleSubscriber.promoBox1':
    "J'accepte de recevoir des nouvelles, des offres, du matériel promotionnel et des mises à jour de Embark étudiant corp. et de la Fondation Embark pour étudiants. Je comprends que je peux me désabonner à tout moment.",
  'termsConditions.disagreeError': 'Veuillez accepter de continuer.',
  'termsConditions.eaa':
    "Convention d'aide aux études et les Reconnaissances. ",
  'termsConditions.eaa.link': `${__STUDENT_SERVICES_URL__}/documents/Embark_Student_Family_Plan_EAA_&_Acknowledgements_&_Prospectus_FR_DIGITAL.pdf`,
  'termsConditions.relationshipDisclosure':
    'les informations sur les relations',
  'termsConditions.relationshipDisclosure.link': `${__STUDENT_SERVICES_URL__}/documents/Embark_Relationship_Disclosure_fr.pdf`,
  'termsConditions.conflictsDisclosure':
    "la divulgation des conflits d'intérêts",
  'termsConditions.conflictsDisclosure.link': '/terms',
  'promotion.unsubscribeLink': '/unsubscribe',
  'enrolmentSummaryPDF.downloadBtnText': "Résumé de l'inscription",
  'enrolmentSummaryPDF.downloadError':
    "Quelque chose s'est mal passé. Veuillez réessayer.",
  'termsConditions.singleSubscriber.ESCandD1':
    " Je consens par la présente au traitement de mes données personnelles que j'ai fournies et je confirme que j'ai lu et accepté la",
  'termsConditions.singleSubscriber.ESCandD2': 'et',
  'termsConditions.ESCandD1.link': 'Politique de protection de la vie privée',
  'termsConditions.ESCandD2.link':
    'les conditions numériques de Embark étudiant corp',
  'termsConditions.singleSubscriber.EnrolmentSummary':
    "Je confirme et accepte tous les détails que j'ai partagés avec l'agent pendant le flux assisté. ",
  'termsConditions.link.EnrolmentSummary': "Sommaire de l'inscription",
  'fileUpload.title': 'Téléchargement de fichiers',
  'fileUpload.upload': 'Télécharger',
  'fileUpload.remove': 'Retirer',
  'fileUpload.maxFileSize': 'Taille maximale du fichier :',
  'fileUpload.maxFileSizeError1':
    'Veuillez télécharger une taille de fichier valide.',
  'fileUpload.fileTypeError': 'Veuillez télécharger un type de fichier valide.',
  'documents.title': 'Documents',
  'documents.financialYear': 'Année',
  'documents.account': 'Des plans',
  'documents.taxSlips': 'Relevés d’impôt',
  'documents.financialStatements': 'États financiers',
  'documents.tradeConfirmations': 'Avis d’exécution',
  'documents.enrollmentSummary': "Résumé de l'inscription",
  'fileUpload.MB': 'Mo',
  'profile.personalDetails': 'Renseignements personnels',
  'profile.emailCommunicationPreferences':
    'Préférence de communication par courriel',
  'profile.taxStatements': 'Livraison électronique des documents fiscaux',
  'profile.newsAndMarketing': 'Actualité, offres et mises à jour de marketing',
  'profile.investmentProfile': 'Profil d’investissement',
  'profile.addressTitle': 'Quelle est votre adresse?',
  'profile.phoneTitle': 'Quel est votre numéro de téléphone?',
  'childProfileSelect.title': "Qui va à l'école?",
  'childProfileSelect.addProfile': 'Ajouter un profil',
  'digitalAccess.title': 'ACTIVEZ VOTRE COMPTE NUMÉRIQUE',
  'existingRESP.headline':
    'Êtes-vous un parent ayant souscrit à un REEE auprès de La Première financière du savoir, de Héritage ou d’Embark?',
  'existingRESP.alert':
    'L’activation numérique est actuellement limitée aux parents souscripteurs. L’activation numérique par les étudiants n’est pas offerte pour le moment.',
  'respOpeningPeriod.headline':
    'Avez-vous ouvert votre ou vos REEE entre 1995 et février 2023?',
  'respOpeningPeriodOption.plansBeforeAndAfterFeb2023':
    'J’ai ouvert des régimes avant et après février 2023.',
  'welcome.headline': 'Avant de commencer',
  'welcome.para1':
    'Les services d’accès numérique à votre ou vos régimes avec La Première financière du savoir seront activés lorsque vous aurez terminé votre inscription. Vous pourrez également profiter de notre large gamme de produits et services exclusifs.',
  'welcome.detailList.title':
    'Vous devez avoir sous la main les renseignements suivants :',
  'welcome.detailList.bullet1': 'Numéro d’assurance sociale (NAS)',
  'welcome.detailList.bullet2':
    'Assurez-vous d’avoir l’une de ces pièces d’identité avec photo délivrées par le gouvernement  :',
  'welcome.detailList.bullet2.bullet1': 'Permis de conduire provincial',
  'welcome.detailList.bullet2.bullet2': 'Passeport',
  'welcome.detailList.bullet2.bullet3': 'Carte de résident permanent',
  'welcome.detailList.note.important': 'IMPORTANT:',
  'welcome.detailList.note':
    'Vous ne pouvez pas utiliser une pièce d’identité expirée.',
  'welcome.estimatedTime': 'Durée : 5 minutes',
  'welcome.needMoreInfo': 'Vous avez des questions?',
  'welcome.call.part1': 'Communiquez avec notre équipe en appelant au',
  'welcome.call.part2': '.',
  'existingEmbarkCustomer.headline':
    'Il semble que vous avez déjà un régime avec nous!',
  'existingEmbarkCustomer.message':
    'Connectez-vous à votre tableau de bord pour consulter vos régimes.',
  'existingEmbarkCustomer.signInBtn': 'Se connecter maintenant',
  'childProfileSelect.addIcon': 'plus icon',
  'programLength.lessThanOneYear': "Moins d'un an",
  Today: "Aujourd'hui",
  'jobTitle.maxLength':
    'Le titre du poste a une limite de taille de 40 caractères',
  'generalError.title': 'Quelque chose ne va pas.',
  'generalError.text': 'Veuillez réessayer plus tard.',
  'investmentProfile.maritalStatus': 'Avez-vous un conjoint ou une conjointe?',
  'investmentProfile.headline': 'Faisons un bref examen de votre profil',
  'advisor.headline': 'Verify your agent ID',
  'advisor.description': 'Please enter your agent ID',
  'advisor.agentId': 'Agent ID#',
  'advisor.error': 'Please enter your ID',
  'onboardingPlanSelection.title': 'Choisir un régime de REEE',
  'onboardingPlanSelectionOption.label.family': 'Embark familial',
  'onboardingPlanSelectionOption.label.individual': 'Embark individuel',
  'onboardingPlanSelectionOption.helperText.family':
    'Les souscripteurs doivent être un parent (biologique ou adoptif), des grands-parents ou un frère ou une sœur.',
  'onboardingPlanSelectionOption.helperText.individual':
    "Les souscripteurs ne sont pas tenus d'être liés au bénéficiaire. Les adultes peuvent également ouvrir ce REEE pour eux-mêmes.",
  'createAccount.title': 'CRÉER UN COMPTE',
  'identification.head': "Vérifier l'identifiant de l'abonné",
  'identification.idType': "Type d'identification",
  'identification.typeError': "Veuillez sélectionner le type d'identifiant.",
  'identification.idTypeNotes':
    "Doit être une pièce d'identité valide avec photo émise par le gouvernement (par exemple, un permis de conduire provincial, un passeport ou une carte RP).",
  'identification.idNumber': "numéro d'identification",
  'identification.idNumberError': "Veuillez entrer le numéro d'identification.",
  'identification.expireDate': "Date d'expiration de la pièce d'identité",
  'identification.issuingJurisdiction': "Juridiction d'émission",
  'identification.issuingError': 'Veuillez entrer la juridiction émettrice.',
  'identification.maxCharError': 'Veuillez saisir 40 chiffres ou moins.',
  openRESP: 'REEE ouvert',
  'onboardingPersonalInfo.DateOfBirth': 'Date de naissance',
  'onboardingPersonalInfo.MobileNumber': 'Numéro de téléphone portable',
  'unauthorizedAccess.headline': 'Vous n’avez pas accès à cette application.',
  'unauthorizedAccess.content':
    'Veuillez communiquer avec votre administrateur pour demander l’accès.',
  'success.heading': 'Vous êtes prêt!',
  'success.message1':
    "Explorons votre tableau de bord et commençons à épargner pour l'éducation de ",
  'success.message2': '.',
  'success.contribute': 'Cotiser',
  'success.dashboard': 'Tableau de bord',
  'partialSuccess.heading':
    'Convention du ou de la titulaire de compte conjoint en attente de confirmation',
  'partialSuccess.message':
    'Votre compte REEE n’est pas encore ouvert. Votre titulaire de compte conjoint doit lire et accepter les modalités de la convention avant que nous puissions finaliser l’admission de votre compte REEE. Nous vous préviendrons par courriel dès que le processus sera terminé.',
  'idleLogout.title': 'Vous avez été déconnecté',
  'idleLogout.body1': 'Vous avez été déconnecté après 15 minutes d’inactivité.',
  'idleLogout.body2': 'Veuillez ouvrir une nouvelle session pour continuer.',
  'idleLogout.cta1': 'Connectez-vous.',
  'idleLogout.cta2': 'Fermer',
  'childProfile.title': 'Who’s going to school?',
  'childProfile.subTitle': 'Create a profile below to get started.',
  'childProfile.headerOne': 'Child profile',
  'childProfile.headerTwo': 'Are you sure you want to leave?',
  'childProfile.body': 'Your changes will not be saved.',
  'childProfile.interestOne': 'Interest one',
  'childProfile.interestTwo': 'Interest two',
  'childProfile.interestThree': 'Interest three',
  'childProfile.interestFour': 'Interest four',
  'childProfile.fieldsError': 'Complete profile details to continue',
  'childProfile.saveError': 'Something went wrong. Please try again.',
  'childProfile.ctaOne': 'Yes, leave',
  'childProfile.ctaTwo': 'No, stay',
  'childProfile.nameRequired': 'Please enter a name.',
  'externalTransfer.header': 'Passer à Embark',
  'externalTransfer.title.part1': 'Transférez ',
  'externalTransfer.title.part2': 'votre REEE à un régime Embark et obtenez ',
  'externalTransfer.title.part4': ' de plus à nos frais.',
  'externalTransfer.title.helpText':
    'Remplissez le formulaire ci-dessous et nous vous communiquerons les prochaines étapes sous peu.',
  'externalTransfer.terms.part1': 'Voir ',
  'externalTransfer.terms.part2': ' pour obtenir plus d’information.',
  'externalTransfer.terms.link': 'conditions générales',
  'externalTransfer.termsIcon.alt': 'Icône de redirection',
  'externalTransfer.info.title': 'Processus de transfert du REEE simplifié',
  'externalTransfer.info.description':
    'Transférez facilement vos REEE chez Embark. Inscrivez les informations demandées ci-dessous et nous vous appellerons pour vous guider tout au long du processus.',
  financialInstituteLabel: 'Quelle institution financière détient vos REEE?',
  financialInstituteLabelHelper: 'Institution financière',
  financialInstitutionNameRequired:
    'Veuillez inscrire le nom de l’institution financière.',
  respAmountLabel: 'Quel est le solde estimatif de vos REEE?',
  respAmountLabelHelper: 'Montant',
  backIcon: 'Icône Retour',
  'externalTransfer.icon.alt': 'Icône de transfert',
  'externalTransfer.semiAnnulus.icon.alt': 'Icône de semi-anneau',
  'externalTransfer.square.icon.alt': 'Icône carrée',
  'searchbar.ariaLabel.clearField': 'Champ de recherche effacer',
  'searchbar.ariaLabel.setDefaultState':
    'Définissez la recherche sur le champ par défaut',
  'img.alt.carIcon': 'aperçu de la voiture',
  'img.alt.folderIcon': "aperçu d'un dossier",
  'img.alt.giftCardIcon': 'Icône de la carte-cadeau',
  'img.alt.embarkBgText': "Abréviation d'embarquement: e, a",
  'img.alt.devices':
    'Deux appareils mobiles affichant Career and School Matcher',
  'img.alt.embarkLogo': 'Embark',
  'img.alt.errorIcon': 'Erreur',
  'headerNav.resps': 'REEE',
  'headerNav.openResp': 'Ouvrir un compte',
  'headerNav.budget': 'Coût des études',
  'headerNav.matcher': "Matcheur de carrière et d'école",
  'headerNav.scholarships': 'Bourses',
  'headerNav.refer': 'Référez un ami',
  'financialPlanDropdown.canada': 'Canada',
  'financialPlanLineChart.disclaimer':
    'This projection is based on assumptions and is for illustrative purposes only. Investment returns and actual future value of your RESP cannot be predicted or guaranteed.',
  'financialPlanEducationCost.title': 'Average cost of education',
  'financialPlanEducationCost.tuition': 'Tuition',
  'financialPlanEducationCost.total': 'Tuition and residence',
  'financialPlanLineChartHeader.projectedSavings': 'Projected savings',
  'financialPlanLineChartHeader.shortfallSurplus': 'Total shortfall/surplus ',
  'financialPlanLineChartHeader.year': 'by ',
  'financialPlanLineChartHeader.title': 'Your RESP Savings',
  'financialPlannerEntry.heading.headline': 'Education Savings Calculator',
  'financialPlannerEntry.useRespData': 'Use RESP Data',
  'financialPlannerEntry.heading.content':
    'Figure out the total estimated cost of school. Realidtically forecast your expenses, plus ideas on how to cover your costs.',
  'interestQuestionnaireEntry.headline': 'Career kickstart quiz',
  'interestQuestionnaireEntry.body':
    "Are you sure about doctor? Whether you're a parent or future scholar, our career quiz reveals paths just as exciting as medicine—and maybe even more high-paying.",
  'interestQuestionnaireEntry.step1.headline': 'Step 1',
  'interestQuestionnaireEntry.step1.title': 'Take the quiz',
  'interestQuestionnaireEntry.step1.body':
    "Let's take the guesswork out of work.",
  'interestQuestionnaireEntry.step2.headline': 'Step 2',
  'interestQuestionnaireEntry.step2.title': 'Explore the results',
  'interestQuestionnaireEntry.step2.body':
    'Discover potential strengths and careers that suit you.',
  'interestQuestionnaireEntry.step3.headline': 'Step 3',
  'interestQuestionnaireEntry.step3.title': 'See Career & School Matcher',
  'interestQuestionnaireEntry.step3.body':
    'Check out schools near you for that career.',
  'interestQuestionnaireEntry.cta': "Let's go!",
  'interestQuestionnaireQuizDialog.header': 'Are you sure you want to leave?',
  'interestQuestionnaireQuizDialog.body': 'You will lose any unsaved changes.',
  'interestQuestionnaireQuizRestartDialog.title1':
    "Uh-oh, we've run out of questions for you.",
  'interestQuestionnaireQuizRestartDialog.title2': 'Please start over.',
  'interestQuestionnaireQuizRestartDialog.cta': 'Start Over',
  'interestQuestionnaireQuizDialog.no': 'No, stay',
  'interestQuestionnaireQuizDialog.yes': 'Yes, leave',
  'interestQuestionnaireEmail.headline': "You're almost there!",
  'interestQuestionnaireEmail.body':
    'Enter your email to unlock your quiz results.',
  'interestQuestionnaireEmail.cta': 'See the results',
  'interestQuestionnaireEmail.disclaimer1':
    "By providing your email address, you consent to receive communications from both Embark Student Corp. and Embark Student Foundation. You acknowledge and agree to Embark Student Corp's. ",
  'interestQuestionnaireEmail.disclaimer2':
    '. You may withdraw consent at any time by opting out. All your data is secure using SHA-256 encryption.',
  'interestQuestionnaireCareers.headline': "The future's looking bright!",
  'interestQuestionnaireCareers.body':
    'Sunglasses may be needed. Here are a few brag-worthy traits and the awesome potential career paths that go with them.',
  'interestQuestionnaireCareers.cta': 'See top schools for ',
  'interestQuestionnaireCareers.feedbackHeadline': 'Was this quiz helpful?',
  'interestQuestionnaireCareers.feedbackBody': 'Thanks for your feedback.',
  'childProfileCard.year': 'an',
  'childProfileCard.careerLabel': 'Carrière en herbe',
  'childProfileCard.careerDefault': 'Aucune carrière choisie',
  'childProfileCard.careerIconAlt': 'Casquette scolaire',
  'childProfileCard.schoolLabel': 'Ecole de choix',
  'childProfileCard.schoolDefault': 'Aucune école',
  'childProfileCard.link.careers': 'Explorer les carrières',
  'childProfileCard.link.details': 'Afficher les détails',
  'childProfileCard.schoolIconAlt': 'Casquette scolaire',
  'valuePropTour.loading.text':
    'L’avenir de votre enfant commence aujourd’hui.',
  needsToCompleteRegistration: 'fNeeds to Complete Registration',
  'dashboard.coSubInviteCard.title':
    ' vous a invité à devenir titulaire d’un compte joint',
  'dashboard.coSubInviteCard.new.description':
    'Commencez le débit du compte d’adhésion.',
  'dashboard.coSubInviteCard.interrupted.description':
    'Reprenez là où vous vous êtes arrêté.',
  'dashboard.coSubInviteCard.new.button': 'Commençons ensemble',
  'dashboard.coSubInviteCard.interrupted.button': 'Continuer',
  childName: 'Child name',
  childNameRequiredError: "Please enter the child's name",
  schoolTypeRequiredError: 'Please enter select a school type',
  yearsOfPseStudy: 'Years of PSE study',
  respSavings: 'RESP Savings',
  monthlycontribution: 'Monthly Deposit',
  annualTuition: 'Annual tuition',
  annualCompulsoryFees: 'Annual compulsory fees',
  annualResidenceMeals: 'Annual residence/meals',
  annualTextbooksSupplies: 'Annual textbook/supplies',
  annualPersonalExpenses: 'Annual personal expenses',
  rateOfReturn: 'Rate of returns',
  totalEducationCost: 'Total education cost',
  'valueProp.iconAlt.moneyPlant': 'Plante à argent',
  'valueProp.iconAlt.capBook': 'Livre à casquettes',
  'valueProp.iconAlt.bagCoints': 'Bag Coins',
  'valueProp.iconAlt.goldBar': 'Monnaie de poche',
  'valueProp.iconAlt.coinCap': 'Capuchon pour pièces de monnaie',
  'valueProp.embarkStudentPlanTitle': 'Le régime étudiant Embark',
  'whyEmbark.title': 'Pourquoi choisir Embark?',
  'whyEmbark.years': '60 ans',
  'whyEmbark.yearsText': 'd’expertise en épargne-études et en planification',
  'whyEmbark.students': 'Plus de 60 000 étudiants',
  'whyEmbark.studentsText': 'reçoivent du soutien chaque année',
  'whyEmbark.aum': '6,4 milliards de dollars',
  'whyEmbark.aumText': 'd’actifs sous gestion (ASG)',
  'whyEmbark.ourFocusTitle': 'Nos priorités',
  'whyEmbark.ourFocusText':
    'Soutenue par la <strong>Fondation Embark étudiant</strong>, un organisme sans but lucratif, et <strong>Embark étudiant inc.</strong>, le fournisseur de régimes, Embark se spécialise dans l’épargne-études, la planification et le soutien. Notre mission est de rendre l’éducation accessible et de permettre aux étudiants de réaliser leur plein potentiel.',
  'whyEmbark.keyBenefitsTitle': 'Principaux avantages pour vous',
  'whyEmbark.toolTitle': 'Outils pour les études',
  'whyEmbark.toolText':
    'Le seul outil de ce type au Canada : le rapprochement école-carrière d’Embark.',
  'whyEmbark.taxTitle': 'Avantages au titre de la fiscalité et des subventions',
  'whyEmbark.taxText':
    'Maximisez les subventions tout en faisant fructifier votre épargne à l’abri de l’impôt. Les retraits pour études sont imposés à un taux inférieur entre les mains de l’étudiant.',
  'whyEmbark.flexibleTitle': 'Conditions d’accès souples',
  'whyEmbark.flexibleText':
    'Gérez votre REEE en ligne, suivez sa croissance et retirez facilement des fonds pour les études de votre enfant.',
  'whyEmbark.eligibilityTitle': 'Critères d’admissibilité larges',
  'whyEmbark.eligibilityText':
    'Utilisez les fonds de votre REEE pour l’université, le collège, les métiers ou les formations d’apprenti, à temps plein ou à temps partiel, au Canada ou à l’étranger.',
  'tailoredSavings.title': 'Le régime étudiant Embark',
  'tailoredSavings.planTitle': 'Des plans d’épargne personnalisés',
  'tailoredSavings.planSubtitle': 'selon l’âge de votre enfant',
  'tailoredSavings.investmentTitle': 'Stratégie de placement',
  'tailoredSavings.investmentSubtitle': 'du régime étudiant Embark',
  'tailoredSavings.feeStructure':
    'Une structure tarifaire simple et concurrentielle',
  'tailoredSavings.managementFee':
    'Frais de gestion (RFG) : 1,65 % + taxes applicables, calculés selon la valeur liquidative de la totalité des épargnes du régime. Frais déduits chaque mois des revenus du régime.',
  'tailoredSavings.portfolioTitle': 'Portefeuille :',
  'tailoredSavings.portfolioDescription':
    'risque faible à moyen, axé sur la préservation de l’épargne en vue des études postsecondaires.',
  'tailoredSavings.contributions': 'Cotisations',
  'tailoredSavings.maxContributionTitle': 'Cotisation maximale :',
  'tailoredSavings.maxContribution': 'Jusqu’à 50 000 $ par enfant',
  'tailoredSavings.addedValueTitle': 'Valeur ajoutée :',
  'tailoredSavings.addedValue': 'Créez une page des cadeaux pour votre enfant',
  'tailoredSavings.fullDetailsTitle': 'Informations complètes :',
  'tailoredSavings.fullDetails':
    'Se reporter au prospectus pour connaître les frais et les renseignements sur le régime',
  'governmentGrant.title': 'Subventions gouvernementales',
  'governmentGrant.subtitle': 'Épargne dynamisée par le gouvernement',
  'governmentGrant.cesg.title':
    'Subvention canadienne pour l’épargne-études (SCEE)',
  'governmentGrant.cesg.lifetimeMaximum': 'Maximum à vie',
  'governmentGrant.cesg.lifetimeMaximumValue': '7 200 $',
  'governmentGrant.cesg.annualGrant': 'Attribution annuelle',
  'governmentGrant.cesg.annualGrantValue':
    '20 % sur la première tranche de 2 500 $ versée',
  'governmentGrant.cesg.additional': 'SCEE supplémentaire',
  'governmentGrant.cesg.additionalValue':
    'Jusqu’à 10 % ou 20 % sur la première tranche de 500 $ versée, en fonction du revenu',
  'governmentGrant.cesg.availability': 'Disponibilité',
  'governmentGrant.cesg.availabilityValue':
    'Jusqu’à la fin de l’année où votre enfant atteint l’âge de 17 ans',
  'governmentGrant.clb.title': 'Bon d’études canadien (BEC)',
  'governmentGrant.clb.provides': 'Offre',
  'governmentGrant.clb.providesValue':
    'Jusqu’à 2 000 dollars pour les enfants admissibles nés en 2004 ou après',
  'governmentGrant.clb.eligibility': 'Admissibilité',
  'governmentGrant.clb.eligibilityValue':
    'Familles qui respectent les plafonds de revenus',
  'governmentGrant.clb.applicationDeadline':
    'Date limite de dépôt de la demande',
  'governmentGrant.clb.applicationDeadlineValue':
    'Le bénéficiaire doit être âgé de moins de 21 ans au moment du dépôt de la demande',
  'governmentGrant.bc.title':
    'Subvention pour l’épargne-études et l’épargne-formation de la Colombie-Britannique',
  'governmentGrant.bc.grant': 'Subvention',
  'governmentGrant.bc.grantValue':
    '1 200 $ pour les résidents de la Colombie-Britannique',
  'governmentGrant.bc.childEligibility': 'Admissibilité de l’enfant',
  'governmentGrant.bc.childEligibilityValue':
    'Né le 1er janvier 2006 ou après cette date',
  'governmentGrant.bc.applicationPeriod':
    'Période pendant laquelle une demande peut être présentée',
  'governmentGrant.bc.applicationPeriodValue':
    'Entre le 6ᵉ et le 9ᵉ anniversaire de l’enfant',
  'governmentGrant.qc.title': 'Incitatif québécois à l’épargne-études (IQEE)',
  'governmentGrant.qc.lifetimeMaximum': 'Garantie maximale à vie',
  'governmentGrant.qc.lifetimeMaximumValue': '3 600 $ par enfant',
  'governmentGrant.qc.potentialEarnings': 'Revenus escomptés',
  'governmentGrant.qc.potentialEarningsValue': 'Jusqu’à 3 600 $ par enfant',
  'governmentGrant.qc.annualGrant': 'Attribution annuelle',
  'governmentGrant.qc.annualGrantValue':
    '10 % des cotisations à un REEE, jusqu’à 250 $ par an',
  'governmentGrant.eligibilityNotice':
    'Des conditions d’admissibilité s’appliquent. Pour connaître tous les détails, veuillez consulter le prospectus actuel du régime étudiant Embark.',
  'governmentGrant.respUsage.title': 'Que peut financer votre REEE?',
  'governmentGrant.respUsage.tuitionFees': 'Frais de scolarité',
  'governmentGrant.respUsage.residenceAndMeals': 'Résidence et repas',
  'governmentGrant.respUsage.residenceAndMealsValue':
    'Logement, loyers, services publics',
  'governmentGrant.respUsage.booksAndSupplies': 'Livres et fournitures',
  'governmentGrant.respUsage.booksAndSuppliesValue':
    'Ordinateurs portables, blocs-notes, tablettes',
  'governmentGrant.respUsage.transportation': 'Transport',
  'governmentGrant.respUsage.transportationValue':
    'Voiture, transports en commun',
  'governmentGrant.respUsage.personalExpenses': 'Dépenses personnelles',
  'governmentGrant.respUsage.personalExpensesValue':
    'Divertissement, téléphone cellulaire, vêtements',
  'governmentGrant.ifNotPostSecondary.title':
    'Qu’arrive-t-il si votre enfant décide de ne pas poursuivre d’études postsecondaires?',
  'governmentGrant.ifNotPostSecondary.option1':
    'Vous pouvez continuer de tirer un revenu des actifs du régime pendant une période allant jusqu’à 35 ans',
  'governmentGrant.ifNotPostSecondary.option2':
    'Vous pouvez partager le REEE avec un autre enfant ou le transférer à celui-ci',
  'governmentGrant.ifNotPostSecondary.option3':
    'Vous pouvez transférer le revenu inutilisé dans un REER ou sous forme de paiement de revenu accumulé (PRA)*',
  'governmentGrant.ifNotPostSecondary.note':
    '* Les revenus accumulés retirés sont imposables, assujettis à un impôt fédéral de 20 % (12 % pour les résidents du Québec) ou peuvent être transférés dans un REER, jusqu’à concurrence de 50 000 $ par souscripteur (en fonction des droits de cotisation au REER et de la réglementation fiscale).',
  'headerNavLinks.home': 'Accueil',
  'headerNavLinks.money': 'Argent',
  'headerNavLinks.rewards': 'Récompenses',
  'headerNavLinks.offers': 'Offres',
  'headerNavLinks.refer': 'Refer a friend',
  'headerNavMenuItems.addAChild': 'Ajouter un enfant',
  'headerNavMenuItems.linkABankAccount': 'Lier un compte bancaire',
  'headerNavMenuItems.addAPlan': 'Ajouter un régime',
  'headerNavMenuItems.giftingLink': 'Partagez le lien de cadeau',
  'headerNavMenuItems.transferIn': 'Transférer un REEE',
  'headerNavMenuItems.addCosubscriber': 'Créez un compte conjoint',
  'headerNavMenuItems.settings': 'Paramètres',
  'headerNavMenuItems.openResp': 'Ouvrir un REEE',
  'headerNavMenuItems.documents': 'Documents',
  'headerNavMenuItems.logout': 'Déconnexion',
  'settings.header': 'Paramètres',
  'settings.profile.info': 'Renseignements personnels',
  'settings.profile.name': 'Nom:',
  'settings.profile.email': 'Courriel:',
  'settings.profile.phone': 'Numéro de téléphone mobile:',
  details: 'Détails',
  contact: 'Nous joindre',
  changeLanguage: 'Modifier la langue',
  emailCommunication: 'Communication par courriel',
  newsOffersMarketingUpdates: 'Actualité, offres et mises à jour de marketing',
  'settings.security.changePassword': 'Modifier votre mot de passe',
  'settings.security.stepOne':
    'Pour mettre à jour votre mot de passe, commencez par fournir votre adresse courriel et votre numéro de téléphone, puis vérifiez votre mot de passe par message texte ou par courriel.',
  'settings.security.stepTwo':
    'Ensuite, créez un nouveau mot de passe conforme aux exigences indiquées, telles que la longueur et les caractères spéciaux. Une fois ces étapes terminées, cliquez simplement sur le bouton « Continuer ».',
  'settings.security.continue': 'Modifier le mot de passe',
  'settings.messages.header': 'Messages (à venir)',
  'surveyFeedbackDialogSuccess.description':
    'Vos commentaires comptent vraiment. En nous faisant part de vos commentaires, vous nous aidez à améliorer encore davantage Embark.',
  'surveyFeedbackDialogSuccess.thanks':
    'Merci de vous être joint à nous! Votre avis nous aidera à améliorer votre expérience.',
  'survey.language': 'Quelle est votre langue préférée?',
  'survey.gender': 'Veuillez indiquer votre genre',
  'survey.discovery': 'Comment avez-vous entendu parler de nous?',
  'survey.additionalSavings':
    'Avez-vous d’autres épargnes-études dans d’autres comptes?',
  'survey.educationFunds':
    'Où mettez-vous également de l’argent de côté pour les études?',
  'survey.headsUp': 'Petit rappel : vos réponses ne seront pas sauvegardées.',
  quickSurvey: 'Sondage éclair',
  'language.english': 'Anglais',
  'language.french': 'Français',
  'language.mandarin': 'Mandarin',
  'language.cantonese': 'Cantonais',
  'language.hindi': 'Hindi',
  'language.urdu': 'Ourdou',
  'language.arabic': 'Arabe',
  'language.tagalog': 'Tagalog',
  'language.others': 'Autres',
  'source.google': 'Google',
  'source.socialMedia': 'Médias sociaux',
  'source.friendsFamily': 'Famille et amis',
  'source.newspaperMagazine': 'Journaux et magazines',
  'source.tvStreaming': 'Télé / diffusion en continu',
  'source.billboards': 'Panneaux d’affichage',
  'source.radioPodcast': 'Radio / balado',
  'amount.lessThan5000': 'Inférieur à 5 000 $',
  'amount.moreThan5000': 'Supérieur à 5 000 $',
  'amount.preferNotToSay': 'Préfère ne pas répondre',
  'account.anotherRESP': 'Un autre REEE',
  'account.tfsa': 'Compte d’épargne libre d’impôt (CELI)',
  'account.chequingSavings': 'Compte chèques / épargne',
  'account.preferNotToSay': 'Préfère ne pas répondre',
  additionalFeedback: 'Rétroaction supplémentaire',
  accountType: 'Type de compte',
  'done.survey': 'Terminé',
  'money.header': 'Gérer votre épargne',
  'money.add.header': 'Ajouter des fonds',
  'money.add.dialogBody':
    'Nous sommes là pour vous aider! Pour l’instant, il se peut que vous ne puissiez pas ajouter de fonds pour l’une des raisons suivantes :',
  'money.withdraw.header': 'Retirer des fonds',
  'money.withdraw.dialogBody':
    'Nous sommes là pour vous aider! Pour l’instant, il se peut que vous ne puissiez pas retirer de fonds pour l’une des raisons suivantes :',
  'money.link.header': 'Lier un compte bancaire',
  'money.link.dialogBody':
    'Vous n’avez pas encore lié de compte bancaire. Ouvrez un régime pour lier vos comptes bancaires et gérer vos cotisations et retraits.',
  'money.reason1': 'Vous n’avez pas de',
  'money.reason1.urlText': 'régime REEE.',
  'money.reason2': 'Vous n’avez peut-être pas encore',
  'money.reason2.urlText': 'lié de compte bancaire.',
  termsAndConditionsApply: '* Des conditions générales s’appliquent',
  'termsAndConditionsLink.open':
    'https://www.embark.ca/fr/atterrissage/offre-de-reee#terms',
  'termsAndConditionsLink.transfer':
    'https://www.embark.ca/fr/conditions-generales-de-prime-de-transfert-entrant-et-de-depot',
  transferYourRESP: 'Transférez votre REEE',
  continueApplication: 'Poursuivre la demande',
  startApplication: 'Démarrer votre demande',
  actionRequired: 'Mesure à prendre',
  'home.nonRESP.header': 'Ouvrez le REEE de votre enfant dès aujourd’hui',
  'home.nonRESP.description':
    'Ouvrez un REEE ou transférez un REEE existant d’une autre institution.',
  'home.nonRESP.openCard.subheader': 'Ouvrir un REEE',
  'home.nonRESP.openCard.body1': 'Huit minutes suffisent pour ouvrir un REEE.',
  'home.nonRESP.openCard.body2':
    ' Utilisez le code EASY pour bénéficier d’une prime de 250 $',
  'home.nonRESP.openCard.body3': ' et commencer à accumuler des subventions.',
  'home.nonRESP.transferCard.subheader': 'Transférer un REEE existant',
  'home.nonRESP.transferCard.body':
    'Transférez un REEE existant à Embark et recevez une prime de 2 %.',
  'home.nonRESP.pendingPrimaryCard.subheader': 'Votre demande est en attente',
  'home.nonRESP.pendingPrimaryCard.body':
    'Cela peut prendre quelques jours ouvrables. Vous recevrez un courriel dès que l’approbation aura été obtenue.',
  'home.nonRESP.pendingJointCard.subheader':
    'Votre demande de compte conjoint est en attente',
  'home.nonRESP.pendingJointCard.body':
    'Cela peut prendre quelques jours ouvrables. Vous recevrez un courriel dès que l’approbation aura été obtenue.',
  'home.nonRESP.continuePrimaryCard.subheader': 'Continuer votre demande',
  'home.nonRESP.continuePrimaryCard.body':
    'Reprenez là où vous vous êtes arrêté.',
  'home.nonRESP.continueJointCard.subheader':
    'vous a invité à devenir titulaire d’un compte conjoint',
  'home.nonRESP.continueJointCard.body':
    'Reprenez là où vous vous êtes arrêté.',
  'home.nonRESP.inviteCard.subheader':
    'vous a invité à devenir titulaire d’un compte conjoint',
  'home.nonRESP.inviteCard.body':
    'Vous avez reçu une invitation à ouvrir un compte REEE. Démarrons votre demande et procédons à votre inscription.',
  'home.nonRESP.staticCards.header': 'L’accès facile au REEE',
  'home.nonRESP.staticCards.subheader1': 'Ouvrez un REEE en quelques minutes',
  'home.nonRESP.staticCards.body1':
    'Nous avons compris, vous êtes un parent occupé. C’est pourquoi vous pouvez ouvrir un REEE en quelques minutes. De chez vous.',
  'home.nonRESP.staticCards.subheader2': 'Frais initiaux de 0 $',
  'home.nonRESP.staticCards.body2':
    'Épargnez ce que vous voulez, quand vous voulez. Des montants sans stress adaptés à votre budget.',
  'home.nonRESP.staticCards.subheader3': 'Plus de 7 200 $ en subventions',
  'home.nonRESP.staticCards.body3':
    'Cotisez à votre REEE et obtenez une subvention correspondant à 20 % du montant cotisé, jusqu’à concurrence de 500 $ par année et d’un total de 7 200 $.',
  'home.nonRESP.pendingPrimaryDialog.header': 'Ouvrir un REEE',
  'home.nonRESP.pendingPrimaryDialog.subHeader':
    'Vous avez déjà un REEE? Voici les raisons pour lesquelles il se peut que vous ne puissiez pas ouvrir un nouveau REEE :',
  'home.nonRESP.pendingPrimaryDialog.listItem1':
    'Une demande est en cours d’examen.',
  'home.nonRESP.pendingPrimaryDialog.listItem2': 'Vous avez déjà ',
  'home.nonRESP.pendingPrimaryDialog.listItem2Link': 'commencé une demande.',
  'home.nonRESP.pendingPrimaryDialog.listItem3Link':
    'Vous avez reçu une invitation',
  'home.nonRESP.pendingPrimaryDialog.listItem3':
    ' à adhérer au REEE d’une autre personne.',
  'childSavingsCalculator.v2.header': 'Calculateur d’épargne',
  'childSavingsCalculator.v2.description':
    'Voyez comment votre REEE peut croître — pour être prêt quand votre enfant le sera.',
  'childSavingsCalculator.v2.savingsLabel': 'Votre épargne REEE estimée est de',
  aboutThisCalculator: 'À propos de ce calculateur',
  'aboutThisCalculator.body1':
    'Cet outil n’est présenté qu’à des fins d’illustration et d’information générale. À l’aide de vos informations et observations, l’outil calcule une valeur totale prévue au moment où votre enfant devrait commencer ses études postsecondaires.',
  'aboutThisCalculator.body2':
    'Ce calcul comprend les cotisations (maximum de 50 000 $), à l’exception de la Subvention canadienne pour l’épargne-études (SCEE) qui devrait augmenter de 20 % (maximum de 7 200 $), et l’estimation des revenus découlant de ces cotisations et subventions à un rendement net de x %.',
  'aboutThisCalculator.body3':
    'Ni un indicateur ni une garantie du rendement futur, il ne doit pas être considéré comme un conseil financier, et le montant de votre cotisation dépendra de votre capacité financière personnelle.',
  mostPopularChoice: 'Choix le plus populaire',
  maximizeYourGovernmentGrants: 'Maximisez vos subventions gouvernementales',
  'rewards.header': 'Optez pour une épargne judicieuse',
  'rewards.description':
    'Vous êtes un élément essentiel de notre parcours. Profitez de récompenses exclusives conçues pour vous aider à épargner plus judicieusement et à atteindre vos objectifs financiers plus rapidement.',
  'rewards.savingOption1.subheader': 'Passez à une épargne intelligente',
  'rewards.savingOption1.description':
    'Transférez votre REEE à un régime Embark et obtenez 2 % de plus, un petit surplus pour vous aider à démarrer.',
  'rewards.savingOption2.subheader':
    'Faites-vous des amis en leur offrant 250 $*',
  'rewards.savingOption2.description':
    'Recommandez un ami et vous pourriez chacun obtenir jusqu’à 250 $! C’est un excellent moyen de faire fructifier votre REEE pendant que nous nous occupons du reste.',
  'rewards.subheader1': 'Offres de nos partenaires',
  'rewards.partnerOffers.policyMe.header': 'L’assurance vie, simplifiée',
  'rewards.partnerOffers.policyMe.body1':
    'Obtenez les deux premiers mois gratuits avec Embark.',
  'rewards.partnerOffers.policyMe.body2':
    'Obtenez une soumission en moins de 30 secondes.',
  'rewards.partnerOffers.policyMe.learnMoreLink':
    'https://policyme.pxf.io/c/5711270/2138596/15713',
  'rewards.partnerOffers.willful.header':
    'Rédigez un testament en quelques minutes avec Willful',
  'rewards.partnerOffers.willful.body':
    'Profitez d’un rabais de 20 % sur votre testament légal.',
  'rewards.partnerOffers.willful.learnMoreLink':
    'https://try.willful.co/embark',
  'rewards.partnerOffers.apollo.header': 'Assurance locataire en 5 minutes',
  'rewards.partnerOffers.apollo.body':
    'Acceptation garantie par les gestionnaires immobiliers et les propriétaires partout au Canada.',
  'rewards.partnerOffers.apollo.learnMoreLink':
    'https://info.apollocover.com/embark',
  'rewards.partnerOffers.csl.header':
    'Logements pour étudiants d’un océan à l’autre',
  'rewards.partnerOffers.csl.body':
    'La vie étudiante au Canada offre dans tout le Canada des logements pour étudiants modernes, gérés par des professionnels, assortis de commodités haut de gamme et proposant des ressources dédiées. Bref, ils sont conçus pour favoriser la réussite des étudiants.',
  'rewards.partnerOffers.csl.logoAlt': 'La vie étudiante au Canada',
  'cslOfferDialog.url': 'https://www.canadianstudentliving.com/embark',
  'cslOfferDialog.title':
    'Le logement pour étudiants simplifié grâce à La vie étudiante au Canada',
  'cslOfferDialog.body1a':
    'Par l’intermédiaire d’Embark, vous pouvez désormais vous connecter au réseau de résidences étudiantes de confiance de La vie étudiante au Canada. Ce réseau convient parfaitement aux étudiants qui souhaitent avoir des commodités modernes, se sentir en sécurité et être moins stressés pendant leur année scolaire',
  'cslOfferDialog.body1b':
    'Les immeubles de La vie étudiante au Canada sont prêts pour l’emménagement. Tout est compris, du mobilier aux salles de sport et de jeux, en passant par l’accès à Internet et la buanderie.',
  'cslOfferDialog.listTitle': 'Voici ce que vous obtiendrez :',
  'cslOfferDialog.listItem1': 'Loyer tout compris',
  'cslOfferDialog.listItem2': 'Suites prêtes à l’emménagement',
  'cslOfferDialog.listItem3':
    'À quelques pas des salles de classe, des épiceries et des transports en commun',
  'cslOfferDialog.listItem4': 'Collectivité et soutien intégrés',
  'cslOfferDialog.listItem5':
    'La vie étudiante simplifiée grâce à un bail qui vous convient',
  'cslOfferDialog.body2':
    'Offrez plus qu’un dortoir à votre enfant. Donnez-lui un environnement propice à la réussite.',
  'cslOfferDialog.cta': 'Voyez ce qui est offert',
  'cslOfferDialog.body3a': 'En cliquant sur cette offre, vous acceptez ',
  'cslOfferDialog.body3b': 'l’entente d’information sur les recommandations',
  'cslOfferDialog.rdaUrl': `${__BASEURL__}/documents/Referral_Disclosure_Canadian_Student_Living_FR.pdf`,
  goToDashboard: 'Aller au tableau de bord',
  lifetime: ' à vie',
  grantsRecieved: 'Subventions reçues',
  'bonus&Referrals': 'Primes et recommandations',
  'bonus&Referrals.description':
    'Il s’agit du total que vous avez obtenu grâce à des offres d’adhésion spéciales et à des recommandations d’amis qui ont ouvert un REEE auprès d’Embark. Il comprend toutes les primes et les recommandations que vous avez reçues depuis votre adhésion.',
  'cosubInvitation.header':
    'vous a ajouté à titre de titulaire d’un compte conjoint',
  'cosubInvitation.body1':
    'Vous avez été invité à titre de titulaire de compte conjoint dans le REEE de',
  'cosubInvitation.body2': '. L’acceptation ne prend que quelques instants.',
  joinResp: 'Adhérer au REEE',
  applicationInReview: 'Demande en cours d’examen',
  'applicationInReview.description':
    'Nous revoyons vos renseignements. Cela peut prendre quelques jours ouvrables. Vous recevrez un courriel dès que l’approbation aura été obtenue.',
  'genesys.Chat.CTA': 'Clavardage',
  'genesys.Chat.CTA.alt': 'Talk to a human Icon',
  'respHome.plans.header': 'Régimes',
  'respHome.plans.body.bold': 'Transfert de régime en cours.',
  'respHome.plans.body':
    ' Nous fermerons votre ancien régime une fois le transfert terminé (environ 45 à 60 jours ouvrables). Vos cotisations préautorisées sont maintenant versées dans votre nouveau régime; vous pouvez commencer à en ajouter en tout temps.',
  'respHome.plans.cta': 'Ajouter un régime',
  'respHome.plans.alert.transfer': 'Transfert de régime en cours',
  'respHome.plans.alert.review': 'Demande en cours d’examen',
  'respHome.plans.alert.actionRequired': 'Mesure à prendre',
  'respHome.plans.alert.inProgress': 'En cours',
  'respHome.plans.type.familyConservative': 'Régime familial conservateur',
  'respHome.plans.type.familyGlidepath': 'Stratégie évolutive familiale',
  'respHome.plans.type.individualConservative':
    'Régime individuel conservateur',
  'respHome.plans.type.individualGlidepath': 'Stratégie évolutive individuelle',
  'addChildOfferCard.title': 'Ajoutez un enfant, obtenez 100 $',
  'addChildOfferCard.body':
    'Lorsque vous faites fructifier votre REEE, nous le faisons fructifier avec vous. Ajoutez un enfant et nous cotiserons 100 $.',
  'addChildOfferDialog.body.p1':
    'Pour chaque enfant que vous ajoutez à votre REEE avant ',
  'addChildOfferDialog.body.date': 'le 25 août,',
  'addChildOfferDialog.body.p2':
    ' nous ferons fructifier votre REEE avec vous. Nous cotiserons 100 $ pour leur avenir, qu’ils soient tout nouveaux ou simplement nouveaux dans votre régime.',
  'addChildOfferDialog.t&c.p1': '* L’offre prend fin le 25 août. Des ',
  'addChildOfferDialog.t&c.p2': 'conditions générales',
  'addChildOfferDialog.t&c.p3': ' s’appliquent.',
  'addChildOfferDialog.t&c.link':
    'https://www.embark.ca/fr/nouvelle-offre-de-primes-aux-beneficiaires',
  logout: 'Déconnexion',
  selectedPlan: 'Régime sélectionné',
  review: 'Évaluation',
  saveAndContinue: 'Sauvegarder et continuer',
  saveAndExit: 'Sauvegarder et quitter',
  skipForNow: "Ignorer pour l'instant",
  delete: 'Supprimer',
  brockUniversity: 'Brock University',
  carletonUniversity: 'Carleton University',
  dalhousieUniversity: 'Dalhousie University',
  macewanUniversity: 'Macewan University',
  memorialUniversityOfNewfoundland: 'Memorial University of Newfoundland',
  simonFraserUniversity: 'Simon Fraser University',
  torontoMetropolitanUniversity: 'Toronto Metropolitan University',
  universityCollegeOfTheFraserValley: 'University College of the Fraser Valley',
  universityOfAlberta: 'University of Alberta',
  universityOfBritishColumbiaSaunders:
    'University of British Columbia Saunders',
  universityOfBritishColumbia: 'University of British Columbia',
  universityOfCalgaryCummingSchoolOfMedicine:
    'University of Calgary Cumming School of Medicine',
  universityOfCalgary: 'University of Calgary',
  universityOfGuelphHumber: 'University of Guelph Humber',
  universityOfGuelph: 'University of Guelph',
  universityOfOttawa: 'University of Ottawa',
  universityOfTorontoMississauga: 'University of Toronto Mississauga',
  universityOfTorontoScarborough: 'University of Toronto Scarborough',
  universityOfTorontoWoodsworth: 'University of Toronto Woodsworth',
  universityOfVictoria: 'University of Victoria',
  universityOfWaterloo: 'University of Waterloo',
  universityOfWesternOntario: 'University of Western Ontario',
  wilfridLaurierUniversity: 'Wilfrid Laurier University',
  'brockUniversity.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/Brock University.pdf`,
  'carletonUniversity.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/Carleton University.pdf`,
  'dalhousieUniversity.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/Dalhousie University.pdf`,
  'macewanUniversity.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/Macewan University.pdf`,
  'memorialUniversityOfNewfoundland.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/Memorial University of Newfoundland.pdf`,
  'simonFraserUniversity.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/Memorial University of Newfoundland.pdf`,
  'torontoMetropolitanUniversity.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/Toronto Metropolitan University.pdf`,
  'universityCollegeOfTheFraserValley.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University College of the Fraser Valley.pdf`,
  'universityOfAlberta.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Alberta.pdf`,
  'universityOfBritishColumbiaSaunders.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of British Columbia Saunders.pdf`,
  'universityOfBritishColumbia.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of British Columbia.pdf`,
  'universityOfCalgaryCummingSchoolOfMedicine.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Calgary Cumming School of Medicine.pdf`,
  'universityOfCalgary.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Calgary.pdf`,
  'universityOfGuelphHumber.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Guelph Humber.pdf`,
  'universityOfGuelph.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Guelph.pdf`,
  'universityOfOttawa.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Ottawa.pdf`,
  'universityOfTorontoMississauga.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Toronto Mississauga.pdf`,
  'universityOfTorontoScarborough.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Toronto Scarborough.pdf`,
  'universityOfTorontoWoodsworth.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Toronto Woodsworth.pdf`,
  'universityOfVictoria.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Victoria.pdf`,
  'universityOfWaterloo.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/UUniversity of Waterloo.pdf`,
  'universityOfWesternOntario.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/University of Western Ontario.pdf`,
  'wilfridLaurierUniversity.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/Wilfrid Laurier University.pdf`,
  'other.pdf': `${__STUDENT_SERVICES_URL__}/voeSamples/Other_FR.pdf`,
  'onboardingPlanTypeOption.CTA.family': 'Ouvrez un régime familial',
  'onboardingPlanTypeOption.CTA.individual': 'Obtenez un régime individuel',
  popular: 'Populaire',
  icon: 'icône',
  'icon.alt.scotia': 'Icône de la Banque Scotia',
  'icon.alt.rbc': 'Icône RBC',
  'icon.alt.bmo': 'Icône BMO',
  'icon.alt.cibc': 'Icône CIBC',
  'icon.alt.nationalbank': 'Icône Banque Nationale',
  'icon.alt.desjardins': 'Icône desjardins',
  'icon.alt.simplii': 'Icône simplii',
  'icon.alt.tangerine': 'Icône tangerine',
  governmentGrants: 'Subventions gouvernementales',
  accumulatedIncome: 'Revenu accumulé',
  'onboardingGoal.title': 'Que voulez-vous faire?',
  'onboardingGoal.description':
    'Choisissez un objectif parmi les options ci-dessous',
  'onboardingPlanType.stepperHeader': 'Ouvrir un REEE',
  'onboardingBeneInfo.stepperHeader': 'Profil de l’enfant',
  'onboardingCustomerProfile.stepperHeader': 'Profil du client',
  'onboardingInvestmentProfile.stepperHeader': 'Profil d’investissement',
  'onboardingGrants.stepperHeader': 'Subventions gouvernementales',
  'onboardingSubscriberInfo.stepperHeader': 'Vérifiez votre identité',
  'onboardingSubscriberSIN.stepperHeader': 'Numéro d’assurance sociale',
  'onboardingReview.stepperHeader': 'Examen de la demande',
  'onboardingTermsAndCondition.stepperHeader': 'Conditions',
  'coSubOnboardingRelationship.stepperHeader': 'Confirm your relationship',
  'coSubOnboardingReview.stepperHeader': 'Revoir vos renseignements',
  'coSubOnboardingReview.header': 'Passons rapidement en revue',
  'onboarding.grants.headline.part1': 'Vous pouvez recevoir jusqu’à ',
  'onboarding.grants.headline.part2': '7 200 $ *',
  'onboarding.grants.headline.part3': ' pour chaque enfant au cours de sa vie.',
  'onboardingTermsAndCondition.headline':
    'Veuillez consulter les termes et conditions',
  'onboardingTermsAndCondition.description':
    'Une copie de tous les accords sera disponible pour votre référence dans les paramètres du compte.',
  'onboardingTermsAndCondition.eaa.description1': 'J’ai lu et j’accepte la',
  'onboardingTermsAndCondition.eaa.description2':
    'Je comprends que le présent document sert de contrat de régime et comprend le prospectus, qui donne tous les détails sur le produit, les coûts, les risques et les avantages',
  'onboardingTermsAndCondition.eaa.link':
    'onvention de plan d’épargne-études, les accusés de réception et le prospectus',
  'onboardingPlanType.headline': 'Quel régime vous convient le mieux?',
  'onboardingPlanType.label': 'Type de régime REEE',
  'onboardingPlanType.headline.addAPlan': 'Sélectionnez un type de régime REEE',
  'onboardingPlanType.helper.title':
    'Tous les régimes comprennent ce qui suit :',
  'onboardingPlanType.helper.text1': 'Aucuns frais initiaux ou frais cachés',
  'onboardingPlanType.helper.text2':
    'Frais de gestion (RFG)* : 1,65 % plus taxes',
  'onboardingPlanType.helper.text3':
    'Composition des actifs adaptée selon l’âge de chaque enfant',
  'onboardingPlanType.helper.text4':
    'Portefeuille à risque faible à moyen avec des partenaires de confiance qui administrent le régime',
  'onboardingPlanType.helper.text4.subtext1.part1':
    'Fiduciaire et dépositaire de la ',
  'onboardingPlanType.helper.text4.subtext1.part2': 'Banque Scotia',
  'onboardingPlanType.helper.text4.subtext2.part1': 'Dépositaire ',
  'onboardingPlanType.helper.text4.subtext2.part2': 'RBC',
  'onboardingPlanType.helper.text4.subtext3.part1': 'BMO ',
  'onboardingPlanType.helper.text4.subtext3.part2':
    'Gestionnaire d’investissement de',
  'onboardingPlanType.helper.text5':
    'Accès à toutes les subventions applicables (SCEE, SCEES, BEC, SEEEFCB, IQEE)',
  'onboardingPlanTypeOption.family.label': 'Régime familial',
  'onboardingPlanTypeOption.family.subheading':
    'Recommandé aux parents, aux grands-parents ou aux frères et sœurs de l’enfant ou des enfants pour qui vous épargnez ou pour combiner des REEE individuels',
  'onboardingPlanTypeOption.family.helperList.item1':
    'Il peut être ouvert pour un ou plusieurs enfants s’ils sont frères ou sœurs par le sang ou par adoption, et vous pouvez ajouter d’autres frères ou sœurs plus tard',
  'onboardingPlanTypeOption.family.helperList.item2':
    'Les enfants peuvent partager les subventions et les revenus de placement',
  'onboardingPlanTypeOption.individual.label': 'Régime individuel',
  'onboardingPlanTypeOption.individual.helperList.item1':
    'N’importe qui peut devenir un souscripteur',
  'onboardingPlanTypeOption.individual.helperList.item2':
    'Épargnes pour un seul bénéficiaire',
  'onboardingPlanTypeOption.individual.helperList.item3':
    'Les subventions et les revenus de placement ne peuvent pas être partagés',
  'onboardingPlanTypeOption.V2.family.label': 'Plan familial',
  'onboardingPlanTypeOption.V2.family.subheading':
    'Épargnes de REEE en un seul endroit.',
  'onboardingPlanTypeOption.V2.family.note':
    '* Jusqu’à un maximum de 7 200 $ de SCEE',
  'onboardingPlanTypeOption.V2.family.helperList.item1.title':
    'Partager des épargnes',
  'onboardingPlanTypeOption.V2.family.helperList.item1.description':
    'Vos enfants peuvent partager leurs cotisations, leurs subventions et leurs revenus.',
  'onboardingPlanTypeOption.V2.family.helperList.item2.title':
    'Axé sur la famille',
  'onboardingPlanTypeOption.V2.family.helperList.item2.description':
    'Idéal pour les parents ou les grands-parents qui épargnent pour leurs enfants ou petits-enfants.',
  'onboardingPlanTypeOption.V2.family.helperList.item3.title':
    'Ajouter des frères et sœurs',
  'onboardingPlanTypeOption.V2.family.helperList.item3.description':
    'Ajouter ou changer des frères et sœurs (liés par le sang ou l’adoption) à mesure que votre famille grandit.',
  'onboardingPlanTypeOption.V2.individual': 'Plan individuel',
  'onboardingPlanTypeOption.V2.individual.subheading':
    'Pour un enfant à la fois.',
  'onboardingPlanTypeOption.V2.individual.helperList.item1.title':
    'L’enfant n’a pas à être de même sang.',
  'onboardingPlanTypeOption.V2.individual.helperList.item1.description':
    'Idéal pour les tantes, les oncles ou d’autres personnes sans lien de parenté.',
  'onboardingPlanTypeOption.V3.family.label': 'Plan familial',
  'onboardingPlanTypeOption.V3.family.subheading':
    'Caractéristiques principales :',
  'onboardingPlanTypeOption.V3.family.helperList.item1.title':
    'Épargne partagée ',
  'onboardingPlanTypeOption.V3.family.helperList.item1.description':
    'Vos enfants peuvent partager leurs cotisations, leurs subventions et leurs revenus.  Jusqu’à concurrence de 7 200 $ de la Subvention canadienne pour l’épargne-études (SCEE).',
  'onboardingPlanTypeOption.V3.family.helperList.item2.title':
    'Pour les parents ou les grands-parents',
  'onboardingPlanTypeOption.V3.family.helperList.item2.description':
    'Idéal pour les parents ou les grands-parents qui épargnent pour leurs enfants ou leurs petits-enfants (les enfants dans le régime doivent être liés par le sang ou l’adoption).',
  'onboardingPlanTypeOption.V3.family.helperList.item3.title':
    'Ajouter facilement des frères et sœurs',
  'onboardingPlanTypeOption.V3.family.helperList.item3.description':
    'Ajouter ou changer des frères et sœurs (liés par le sang ou l’adoption) à mesure que votre famille grandit.',
  'onboardingPlanTypeOption.V3.individual.label': 'Plan individuel',
  'onboardingPlanTypeOption.V3.individual.subheading':
    'Caractéristiques principales :',
  'onboardingPlanTypeOption.V3.individual.helperList.item1.title':
    'Il n’est pas nécessaire que vous soyez directement lié à l’enfant.',
  'onboardingPlanTypeOption.V3.individual.helperList.item1.description':
    'Idéal pour les tantes, les oncles ou d’autres personnes non apparentées.',
  'onboardingPlanType.V3.helper.title': 'Tous les plans comprennent:',
  'onboardingPlanType.V3.helper.text1':
    'Pas de frais initiaux ni de coûts cachés',
  'onboardingPlanType.V3.helper.text2':
    'Frais de gestion hautement concurrentiels',
  'onboardingPlanType.V3.helper.text3':
    'Répartition personnalisée de l’actif selon l’âge de chaque enfant',
  'onboardingPlanType.V3.helper.text4':
    'Accès à toutes les subventions gouvernementales applicables jusqu’à concurrence de 12 800 $ *',
  'onboardingPlanType.V3.helper.text5':
    'Partenaires de confiance qui détiennent et gèrent tous vos fonds',
  'onboardingPlanType.V3.helper.text5.subtext1.part1': 'Banque Scotia',
  'onboardingPlanType.V3.helper.text5.subtext1.part2':
    'Fiduciaire et dépositaire de la ',
  'onboardingPlanType.V3.helper.text5.subtext2.part1': 'RBC',
  'onboardingPlanType.V3.helper.text5.subtext2.part2': 'Dépositaire',
  'onboardingPlanType.V3.helper.text5.subtext3.part1': 'BMO',
  'onboardingPlanType.V3.helper.text5.subtext3.part2':
    'Gestionnaire d’investissement de',
  'onboardingPlanType.V3.footer':
    '* Le plafond à vie de 12 800 $ par enfant peut varier selon les critères d’admissibilité et la province de résidence.  Les montants réels des subventions peuvent différer.',
  'onboardingPlanType.howRESPWork.link': 'Comment fonctionne votre REEE',
  'onboardingPlanType.howRESPWork.title': 'Comment fonctionne votre REEE',
  'onboardingPlanType.howRESPWork.sectionOne.header':
    'Voici ce qui rend cette solution idéale pour financer des études :',
  'onboardingPlanType.howRESPWork.sectionOne.listItem1.header':
    'L’argent gratuit du gouvernement',
  'onboardingPlanType.howRESPWork.sectionOne.listItem1.description':
    'Obtenez jusqu’à 500 $ par année en subventions simplement en cotisant. De plus, votre épargne fructifie à l’abri de l’impôt.',
  'onboardingPlanType.howRESPWork.sectionOne.listItem2.header':
    'Choix scolaires flexibles',
  'onboardingPlanType.howRESPWork.sectionOne.listItem2.description':
    'Utilisez les fonds de votre REEE pour des études à temps plein ou à temps partiel – université, collège, métiers spécialisés ou formations d’apprenti, au Canada ou à l’étranger.',
  'onboardingPlanType.howRESPWork.sectionOne.listItem3.header':
    'Des frais peu élevés et transparents',
  'onboardingPlanType.howRESPWork.sectionOne.listItem3.description':
    '1,65 % de frais de gestion (RFG), plus taxes. C’est tout.',
  'onboardingPlanType.howRESPWork.sectionOne.listItem4.header':
    'Stratégie de placement conçue pour les étudiants',
  'onboardingPlanType.howRESPWork.sectionOne.listItem4.description':
    'Un portefeuille conçu pour protéger votre épargne à l’approche des études.',
  'onboardingPlanType.howRESPWork.sectionTwo.header':
    'Plafond de cotisations :',
  'onboardingPlanType.howRESPWork.sectionTwo.listItem1.description':
    'Économisez jusqu’à 50 000 $ par enfant (vérifiez les détails de votre plan)',
  'onboardingPlanType.howRESPWork.sectionThree.header': 'Ce qu’il couvre :',
  'onboardingPlanType.howRESPWork.sectionThree.description':
    'Frais de scolarité, livres, loyer, épicerie, fournitures – même les frais de transport et les frais personnels.',
  'onboardingPlanType.howRESPWork.sectionFour.headerOne':
    'Vous ne l’utilisez pas immédiatement?',
  'onboardingPlanType.howRESPWork.sectionFour.headerTwo':
    'Aucun problème – vous avez plusieurs options :',
  'onboardingPlanType.howRESPWork.sectionFour.listItem1':
    'Le laisser fructifier jusqu’à 35 ans',
  'onboardingPlanType.howRESPWork.sectionFour.listItem2':
    'Le transférer à un autre enfant',
  'onboardingPlanType.howRESPWork.sectionFour.listItem3':
    'Transférez jusqu’à 50 000 $ dans votre REER (si vous avez des droits de cotisation)',
  'onboardingPlanType.howRESPWork.sectionFour.listItem4':
    'Retirez-le plus tard à titre de revenu (appelé PRA)',
  'onboardingPlanType.howRESPWork.footer':
    '* Les revenus accumulés retirés sont imposables, assujettis à un impôt fédéral de 20 % (12 % pour les résidents du Québec) ou peuvent être transférés dans un REER, jusqu’à concurrence de 50 000 $ par souscripteur (en fonction des droits de cotisation au REER et de la réglementation fiscale).',
  'onboardingGrants.grantSelection.headline':
    'Dans quelle province êtes-vous? ',
  'onboardingGrants.grantSelection.description':
    'Nous solliciterons ces subventions en votre nom.',
  'onboardingGrants.grants.headline': 'Government grants available to you:',
  'onboardingGrants.footer':
    '* Le plafond à vie de 7 200 $ par enfant peut varier selon les critères d’admissibilité et la province de résidence.  Les montants réels des subventions peuvent différer.',
  'onboardingGrants.howRespWorks.link': 'En savoir plus sur les subventions',
  'onboardingGrants.howRespWorks.title': 'En savoir plus sur les subventions',
  'onboardingGrants.howRESPWork.sectionOne.header':
    'Subvention canadienne pour l’épargne-études (SCEE)',
  'onboardingGrants.howRESPWork.sectionOne.listItem1.span': 'Maximum à vie :',
  'onboardingGrants.howRESPWork.sectionOne.listItem1': '7 200 $',
  'onboardingGrants.howRESPWork.sectionOne.listItem2.span':
    'Attribution annuelle :',
  'onboardingGrants.howRESPWork.sectionOne.listItem2':
    '20 % sur la première tranche de 2 500 $ versée',
  'onboardingGrants.howRESPWork.sectionOne.listItem3.span':
    'SCEE supplémentaire :',
  'onboardingGrants.howRESPWork.sectionOne.listItem3':
    'Jusqu’à 10 % ou 20 % sur la première tranche de 500 $ versée, en fonction du revenu',
  'onboardingGrants.howRESPWork.sectionOne.listItem4.span': 'Disponibilité :',
  'onboardingGrants.howRESPWork.sectionOne.listItem4':
    'Jusqu’à la fin de l’année où votre enfant atteint l’âge de 17 ans',
  'onboardingGrants.howRESPWork.sectionTwo.header':
    'Bon d’études canadien (BEC)',
  'onboardingGrants.howRESPWork.sectionTwo.listItem1.span': 'Offre :',
  'onboardingGrants.howRESPWork.sectionTwo.listItem1':
    'Jusqu’à 2 000 dollars pour les enfants admissibles nés en 2004 ou après',
  'onboardingGrants.howRESPWork.sectionTwo.listItem2.span': 'Admissibilité :',
  'onboardingGrants.howRESPWork.sectionTwo.listItem2':
    'Familles qui respectent les plafonds de revenus',
  'onboardingGrants.howRESPWork.sectionTwo.listItem3.span':
    'Date limite de dépôt de la demande :',
  'onboardingGrants.howRESPWork.sectionTwo.listItem3':
    'Le bénéficiaire doit être âgé de moins de 21 ans au moment du dépôt de la demande',
  'onboardingGrants.howRESPWork.sectionThree.header':
    'Subvention pour l’épargne-études et l’épargne-formation de la Colombie-Britannique',
  'onboardingGrants.howRESPWork.sectionThree.listItem1.span': 'Subvention :',
  'onboardingGrants.howRESPWork.sectionThree.listItem1':
    '1 200 $ pour les résidents de la Colombie-Britannique',
  'onboardingGrants.howRESPWork.sectionThree.listItem2.span':
    'Admissibilité de l’enfant :',
  'onboardingGrants.howRESPWork.sectionThree.listItem2':
    'Né le 1er janvier 2006 ou après cette date',
  'onboardingGrants.howRESPWork.sectionThree.listItem3.span':
    'Période pendant laquelle une demande peut être présentée :',
  'onboardingGrants.howRESPWork.sectionThree.listItem3':
    'Entre le 6ᵉ et le 9ᵉ anniversaire de l’enfant',
  'onboardingGrants.howRESPWork.sectionFour.header':
    'Incitatif québécois à l’épargne-études (IQEE)',
  'onboardingGrants.howRESPWork.sectionFour.listItem1.span':
    'Garantie maximale à vie :',
  'onboardingGrants.howRESPWork.sectionFour.listItem1': '3 600 $ par enfant',
  'onboardingGrants.howRESPWork.sectionFour.listItem2.span':
    'Revenus escomptés :',
  'onboardingGrants.howRESPWork.sectionFour.listItem2':
    'Jusqu’à 3 600 $ par enfant',
  'onboardingGrants.howRESPWork.sectionFour.listItem3.span':
    'Attribution annuelle :',
  'onboardingGrants.howRESPWork.sectionFour.listItem3':
    '10 % des cotisations à un REEE, jusqu’à 250 $ par an',
  'onboardingGrants.howRESPWork.footer':
    'Des conditions d’admissibilité s’appliquent. Pour connaître tous les détails, veuillez consulter le prospectus actuel du régime étudiant Embark.',
  'onboardingGateway.title': 'OUVRIR UN COMPTE REEE',
  'onboardingGateway.requirementsTitle3': 'Vous aurez besoin de ce qui suit :',
  'onboardingGateway.requirementItem6': 'Etre un résident canadien',
  'onboardingGateway.requirementItem7':
    'Un numéro d’assurance sociale (NAS) valide pour vous et votre enfant, conformément aux exigences de l’ARC',
  'onboardingGateway.requirementItem8':
    'Des renseignements personnels sur vous et votre enfant',
  'onboardingGateway.cosub.requirementItem7':
    'Votre numéro d’assurance sociale (NAS)',
  'onboardingGateway.cosub.requirementItem8': 'Vos renseignements personnels',
  'onboardingGateway.requirementItem9':
    'S’il y a lieu, courriel et nom légal du cosouscripteur',
  'onboardingGateway.promoTitle':
    'Avez-vous un code fourni par un conseiller ou un code promotionnel?',
  'onboardingMoneyQuestion.header': 'Posons quelques questions',
  'onboardingMoneyQuestion.info':
    'Les réglementations gouvernementales nous obligent à poser certaines questions personnelles afin de déterminer ce qui vous convient le mieux. Il s’agit d’une pratique courante pour tous les fournisseurs de services de placement au Canada.',
  'onboardingBalancingBenefit.title.line.firstWord':
    'Rééquilibrage automatique',
  'onboardingBalancingBenefit.title.line': " du Régime d'épargne-études Embar",
  'onboardingBalancingBenefit.description':
    'Nous investissons de façon stratégique pour maximiser la croissance des premières années, ce qui permet à votre épargne de croître plus rapidement.',
  'onboardingBalancingBenefit.slider.label': 'Âge de l’enfant',
  'onboardingBalancingBenefit.chart.label.equity': 'Équité',
  'onboardingBalancingBenefit.chart.label.fixedIncome': 'Revenu fixe',
  'onboardingBalancingBenefit.chart.label.yearsOld': 'ans',
  'onboardingBalancingBenefit.chart.label.yearOld': 'an',
  'onboardingBeneficiaries.stopAndResume.sinHeadline.child':
    "Aux fins de l'impôt et des subventions, nous avons besoin que votre NAS et celui de votre enfant soient inclus dans le régime REEE.",
  'onboardingBeneficiaries.stopAndResume.sinHeadline.children':
    "Aux fins de l'impôt et des subventions, nous avons besoin que votre NAS et celui de vos enfants soient inclus dans le régime REEE.",
  'addPlan.sinHeadline.child':
    "Aux fins de l'impôt et des subventions, nous avons besoin que le NAS de votre enfant soit inclus dans le REEE.",
  'addPlan.sinHeadline.children':
    "Aux fins de l'impôt et des subventions, nous avons besoin que le NAS de vos enfants soit inclus dans le régime REEE.",
  'onboardingBeneficiaries.stopAndResume.headline.addAPlan':
    'Aux fins d’impôt et de subventions, nous devons inscrire le NAS de votre enfant dans le REEE.',
  'onboardingBeneficiarySIN.infoGuide1.primary':
    'Vous n’avez pas de numéro d’assurance sociale (NAS)?',
  'onboardingBeneficiarySIN.infoGuide1.primary.note':
    'Vos progrès seront sauvegardés et vous pourrez revenir quand vous serez prêt. Voici comment obtenir un NAS.',
  'onboardingBeneficiarySIN.infoGuide2.primary': 'Voici comment obtenir un NAS',
  'onboarding.popup.whyDoWeAsk.label': 'Pourquoi le demandons-nous?',
  'onboarding.popup.whyDoWeAsk.content':
    'Les organismes de réglementation canadiens exigent que nous recueillions ces renseignements dans le cadre de nos obligations de connaissance du client. Vos données sont en sécurité et ne seront jamais partagées par Embark.',
  'onboarding.sin.whyWeAsk.popUp.header': 'Pourquoi en avons-nous besoin?',
  'onboarding.sin.whyWeAsk.popUp.title': 'Numéro d’assurance sociale',
  'onboarding.sin.whyWeAsk.popUp.content':
    "Emploi et Développement social Canada (EDSC) a besoin de votre numéro d’assurance sociale (NAS) pour appuyer efficacement vos demandes de subvention. Il s'agit d'un élément essentiel pour traiter avec exactitude les subventions gouvernementales en votre nom.",
  'onboardingBeneficiarySIN.V2.headline.1':
    'Le numéro d’assurance sociale (NAS) de ',
  'onboardingBeneficiarySIN.V2.headline.2':
    ' est requis par Emploi et Développement social Canada (EDSC) pour demander des subventions gouvernementales.',
  'onboardingBeneficiarySIN.V2.footer.title':
    'Vous n’avez pas de numéro d’assurance sociale (NAS)?',
  'onboardingBeneficiarySIN.V2.footer.description.1':
    'Vos progrès seront sauvegardés et vous pourrez revenir lorsque vous serez prêt. ',
  'onboardingBeneficiarySIN.V2.footer.description.1.link':
    'https://www.canada.ca/fr/emploi-developpement-social/services/numero-assurance-sociale/demande.html',
  'onboardingBeneficiarySIN.V2.footer.description.2':
    'Voici comment obtenir un NAS.',
  'onboardingPersonalSIN.headline':
    'Quel est votre numéro d’assurance sociale (NAS)?',
  'digitalAccessPersonalInfo.headline':
    'Confirmons maintenant vos renseignements',
  'onboardingSubscriberInfo.headline': 'Vos renseignements personnels',
  'onboardingSubscriberInfo.governmentName':
    "Prénom figurant sur votre pièce d'identité délivrée par le gouvernement.",
  'onboardingSubscriberInfo.MobileNumberHeader': 'Numéro de portable',
  'onboardingSubscriberInfo.MobileNumber': 'Numéro de téléphone portable',
  'onboardingNewGrants.headline.one': 'Vous pouvez recevoir jusqu’à ',
  'onboardingNewGrants.headline.two': ' pour chaque enfant au cours de sa vie*',
  'onboardingNewGrants.description':
    'Maximisez votre épargne REEE grâce à des subventions gouvernementales à impôt différé. Nous vous demandons ces subventions en votre nom.',
  'onboardingNewGrants.grants.heading':
    'Subventions gouvernementales auxquelles vous pouvez être admissible',
  'onboardingNewGrants.grants.note':
    '*La limite à vie de 12 800 $ par enfant est sujette à des variations en fonction des critères d’éligibilité et de la province de résidence. Les montants réels des subventions peuvent différer.',
  'onboardingNewGrants.grants.upTo': 'Jusqu’à',
  'onboardingNewGrants.grants.perLifetimePerChild': 'par vie et par enfanta',
  'onboardingNewGrants.grants.perYearPerChild': 'par année par enfant',
  'onboardingNewGrants.grants.perChild': 'par enfant',
  'onboardingNewGrants.grants.perYearPerRESP': 'par année par REEE*',
  'onboardingNewGrants.grants.CESG':
    'Subvention canadienne pour l’épargne-études (SCEE)',
  'onboardingNewGrants.grants.CESG.link':
    'https://www.canada.ca/fr/services/prestations/education/epargne-etudes/epargne-etudes.html',
  'onboardingNewGrants.grants.CLB': "Bon d'études canadien (BEC)",
  'onboardingNewGrants.grants.CLB.link':
    'https://www.canada.ca/fr/agence-revenu/services/impot/particuliers/sujets/regime-enregistre-epargne-etudes-reee/programmes-canadiens-epargne-etudes-pcee/etudes-canadien.html',
  'onboardingNewGrants.grants.ACESG':
    'Subvention canadienne pour l’épargne-études supplémentaire (SCEES)',
  'onboardingNewGrants.grants.ACESG.link':
    'https://www.canada.ca/fr/services/prestations/education/epargne-etudes/epargne-etudes/montant.html',
  'onboardingNewGrants.grants.BCTESG':
    "Subvention pour l'épargne-études et l'épargne-formation de la Colombie-Britannique (SEEEFCB)",
  'onboardingNewGrants.grants.BCTESG.link':
    'https://www2.gov.bc.ca/gov/content/education-training/k-12/support/scholarships/bc-training-and-education-savings-grant',
  'onboardingNewGrants.grants.QESI':
    "Incitatif québécois à l'épargne-études (IQEE)",
  'onboardingNewGrants.grants.QESI.link':
    'https://www.revenuquebec.ca/fr/citoyens/credits-dimpot/incitatif-quebecois-a-lepargne-etudes/',
  'onboardingSINSection.title': 'NAS',
  'onboardingSINSection.title-plural': 'NAS',
  'onboardingSIN.primary.headline':
    'Votre numéro d’assurance sociale est requis pour ouvrir un REEE auprès de l’ARC et demander des subventions',
  'digitalAccessSIN.alt': 'Icône de notification',
  'digitalAccessSIN.headline':
    'Confirmez votre numéro d’assurance sociale (NAS)',
  'digitalAccessSIN.description':
    'Votre NAS est requis pour confirmer votre pièce d’identité aux fins de l’impôt',
  'digitalAccessSIN.note':
    'Votre NAS (numéro d’assurance sociale) est protégé et crypté de façon sécurisée.',
  'onboardingSIN.SINLabel': 'Quel est votre numéro d’assurance sociale (NAS)?',
  'Onboarding.onboardingSubscriberSIN.V2.headline':
    'L’Agence du revenu du Canada (ARC) exige votre numéro d’assurance sociale (NAS) pour ouvrir un REEE et obtenir des subventions gouvernementales',
  'CosubOnboarding.onboardingSubscriberSIN.V2.headline':
    'Nous avons besoin de votre numéro d’assurance sociale (NAS) pour vous ajouter à ce REEE à titre de cotitulaire et pour satisfaire aux exigences de l’Agence du revenu du Canada (ARC).',
  'onboardingSubscriberSIN.V2.input.label': 'Votre numéro d’assurance sociale',
  'onboardingChildDetails.addAnotherChild': 'Ajouter un autre enfant',
  'onboardingChildsDetails.infoTitle':
    'Vous avez déjà rempli les profils d’enfants suivants :',
  'onboardingChildsDetails.sameAddress':
    'Tous les enfants bénéficiaires de ce régime vivent avec moi.',
  'onboardingChildsDetails.sameAddress.singleBene':
    'L’enfant bénéficiaire de ce régime vit avec moi.',
  'onboardingChildsDetails.V2.headlineFirst': 'Premier enfant',
  'onboardingChildsDetails.V2.headlineSecond': 'Deuxième enfant',
  'onboardingChildsDetails.V2.headlineThird': 'Troisième enfant',
  'onboardingChildsDetails.V2.headlineFourth': 'Quatrième enfant',
  'onboardingChildsDetails.V2.genderInfo':
    'Veuillez vous assurer que le sexe choisi correspond aux renseignements sur le NAS du bénéficiaire.',
  'onboardingChildsDetails.relationship.headline':
    'Quel est votre lien de parenté?',
  'onboardingChildsDetails.relationship.headline.singleBene':
    'Quelle est votre relation?',
  'onboardingChildsDetails.relationship.description':
    'Si vous ajoutez plusieurs enfants, votre lien de parenté avec eux doit être le même. Si votre lien de parenté avec un ou plusieurs des enfants est différent, vous devrez ouvrir un régime distinct pour ces enfants.',
  'onboardingChildRelationshipDropdown.label': 'Relation',
  'onboardingChildsDetails.selectRelationshipError':
    'Veuillez sélectionner la relation.',
  'deleteChildDialog.title':
    'Êtes-vous sûr de vouloir supprimer le profil de cet enfant?',
  'deleteChildDialog.description':
    'Ce profil sera supprimé immédiatement. Vous ne pouvez pas annuler cette mesure.',
  'newOnboardingMoneyQuestion.Header': 'Un régime fait pour vous',
  'newOnboardingMoneyQuestion.info':
    'Nous pouvons vous proposer différents REEE et nous devons vous poser quelques questions en lien avec vos revenus pour déterminer celui qui vous convient le mieux. C’est une pratique courante de tous les fournisseurs de services de placement au Canada.',
  'onboardingThirdParty.label': 'Tiers contributeur',
  'onboardingThirdParty.headline': 'Aurez-vous un contributeur tiers?',
  'onboardingThirdParty.description':
    "S'il y a quelqu'un d'autre que vous souhaitez contribuer à ce compte, nous devrons prendre rendez-vous avec vous pour obtenir ses coordonnées.",
  'onboardingThirdParty.bookAppointmentTitle': 'Veuillez prendre rendez-vous',
  'onboardingThirdParty.bookAppointmentDescription1':
    "Raisons pour lesquelles avec un contributeur tiers devraient prendre rendez-vous, s'il vous plaît",
  'onboardingThirdParty.bookAppointmentDescription2': 'Nous contacter',
  'onboardingThirdParty.bookAppointmentDescription3':
    'directement pour le soutien.',
  'onbaordingInvestingExperience.standalonekyc.riskProfileHeader':
    'Profil de risque',
  'onbaordingInvestingExperience.standalonekyc.infoPopupHeader':
    'Qu’est-ce qu’un profil de risque ?',
  'onbaordingInvestingExperience.standalonekyc.infoPopupContent':
    'La tolérance au risque (la volonté du client d’accepter le risque) et la capacité de prendre des risques (la capacité du client à supporter une perte financière potentielle) sont des considérations distinctes qui, ensemble, constituent le profil de risque global. Le profil de risque d’un client reflète le plus faible des deux.',
  'onboardingRiskProfile.standalonekyc.familyPlan': 'Régime familial',
  'onboardingRiskProfile.standalonekyc.individualPlan': 'Régime individuel',
  'onbaordingRiskProfile.standalonekyc.separator': 'pour',
  'onbaordingRiskProfile.standalonekyc.confirmButton':
    'Confirmer les informations',
  'addPlanIDVGateway.intro':
    'Nous devons simplement vérifier votre identité avant que vous puissiez ouvrir un nouveau régime. Cette vérification est exigée par nos organismes de réglementation et le Centre d’analyse des opérations et déclarations financières du Canada (CANAFE) puisqu’elle n’a pas été effectuée lors de l’inscription.',
  'addPlanIDVGateway.time':
    'Elle ne prend que deux minutes et vous n’aurez à la faire qu’une fois.',
  'addPlanIDV.verficiation.fail.title': 'Échec de la vérification',
  'addPlanIDV.verficiation.fail.body':
    'La vérification de votre identité a échoué. Veuillez réessayer ou communiquer avec nous au ',
  'addPlanIDV.verficiation.fail.body.phone': '1-800-363-7877.',
  'onboardingIDVGateway.title': 'Préparez vos documents',
  'addPlanIDVGateway.documents': 'Ayez en main l’un des documents suivants :',
  'onboardingIDVGateway.missingId.addBene':
    'Nous devons simplement vérifier votre identité avant que vous puissiez ajouter un enfant à ce régime. Cette vérification est exigée par nos organismes de réglementation et le Centre d’analyse des opérations et déclarations financières du Canada (CANAFE) puisqu’elle n’a pas été effectuée lors de l’inscription.',
  'onboardingIDVGateway.missingId.minutes':
    'Elle ne prend que deux minutes et vous n’aurez à la faire qu’une fois.',
  'onboardingIDVGateway.missingId.listTitle':
    'Ayez en main l’un des documents suivants :',
  'onboardingIDVGateway.note':
    'Vous n’avez pas tout en main?  Nous veillerons à sauver vos progrès.',
  'onboardingIDVGateway.list.title':
    'Fournissez l’un des documents suivants aux fins de la vérification de votre identité :',
  'onboardingIDVGateway.list.1.text': 'Permis de conduire ',
  'onboardingIDVGateway.list.2.text': 'Passeport',
  'onboardingIDVGateway.list.3.text': 'Carte de résident permanent',
  'onboardingIDVGateway.list.contactUs':
    'Vous avez des problèmes? Communiquez avec notre représentant pour obtenir de l’aide. Nous n’avons pas à nous inquiéter de tout avoir en main. Nous vous saurons gré de vos progrès.',
  'onboardingHouseholdNetWorth.old.headline1':
    'Tell us about your assets and liabilities',
  'estimatedAmount.error': 'Saisissez un montant.',
  'onboardingHouseholdNetWorth.old.header1': 'Quel est le total de vos actifs?',
  'onboardingHouseholdNetWorth.old.header2': 'Quel est votre passif total?',
  'onboardingAlmostThere.headline': 'Vous y êtes presque!',
  'onboardingAlmostThere.text':
    'Quelques questions supplémentaires pour nous aider à déterminer votre score de risque.',
  beneLastNameRequiredError:
    "Le nom sur leur certificat de naissance ou leur numéro d'assurance sociale.",
  middleNameOptional: 'Deuxième prénom (optionnel)',
  beneFirstNameRequiredError:
    "Le nom sur leur certificat de naissance ou leur numéro d'assurance sociale.",
  SINPersonalDuplicatedError: 'Enregistrements du NAS en double trouvés.',
  'mobileNumber.V2.message.1':
    'Ce numéro de téléphone cellulaire est-il le bon?',
  'mobileNumber.V2.message.2':
    'Nous enverrons un message texte avec un code à ce numéro à des fins de sécurité et de vérification de la connexion.',
  ensureBeneSameRelationship:
    'La relation sélectionnée pour chaque enfant doit être la même. Si la relation avec l’enfant est différente, vous devrez ouvrir un régime distinct pour lui.',
  askMeLater: 'Demandez-moi plus tard',
  invalidStreetNameLength: 'Veuillez saisir 40 caractères au maximum.',
  invalidCityLength: 'Veuillez saisir 30 caractères au maximum.',
  'signOut.alt': 'Sign out Icon',
  'editInPlaceRadioCardsSelect.submitBtnLabel': 'Mise à jour',
  'editInPlaceRadioCardsSelect.editBtnLabel': 'Modifier',
  'bookAppointmentReason.noMatchingRecord':
    "Le client converti a tenté d'obtenir un accès numérique, mais aucun enregistrement correspondant n'a été trouvé.",
  'bookAppointmentReason.idLastname':
    "Le nom de famille sur la pièce d'identité ne correspond pas.",
  'bookAppointmentReason.idDob':
    'La date de naissance sur la pièce d’identité ne correspond pas.',
  'bookAppointmentReason.nonCanadianResident':
    "Retrait du PSE;L'étudiant est un non-résident.",
  'addACosub.alreadyExistError':
    'Un cosouscripteur figure déjà au dossier. Vous ne pouvez ajouter qu’un cosouscripteur à votre régime.',
  'navigation.transferRESP': 'Transférer un REEE',
  'navigation.sendAGift': 'Cadeau REEE',
  'makeContribution.missingProduct.noProductDescription':
    'Vous devrez ajouter facilement un compte REA pour contribuer les fonds.',
  makeAContribution: 'Apporter une contribution',
  'amount.colon': 'Montant :',
  estimatedAmount: 'Montant estimé',
  'missingProduct.noProductHeader': "Vous n'avez pas de produit REA.",
  'missingProduct.noProduct': 'Pas de produit REA',
  addMoney: "Ajouter de l'argent",
  'planTransferAlert.header': 'Transfert de régime en cours',
  'planTransferAlert.info':
    'Votre régime est en cours de transfert. Pendant le transfert, vous ne pourrez pas cotiser à votre ancien régime. Une fois le transfert terminé, votre ancien régime sera fermé.',
  'planTransferAlert.ErrorIcon.alt': "Icône d'erreur",
  'contributionSuccess.exclusiveOffers': 'Des offres exclusives',
  'contributionSuccess.continueOffers': 'Continuons avec l’offre.',
  promoCode: 'Code promo',
  promoCodeOrReferralCode: 'Code promotionnel ou code de référence',
  'promoInput.placeholder': 'Facultatif',
  'promoInput.characterLimits': 'Veuillez saisir 20 caractères ou moins.',
  'promoInputWfg.success': 'Code du conseiller de WFG utilisé!',
  'addABeneficiary.selectPlan.info.alt': "Icône d'informations",
  'addABeneficiary.selectPlan.info.descriptionOne':
    'Les régimes individuels peuvent seulement compter un enfant. Pour ajouter un bénéficiaire à un régime familial comptant quatre enfants ou plus, veuillez nous appeler au ',
  'addABeneficiary.selectPlan.info.descriptionTwo': '.',
  'addABeneficiary.selectPlan.info.descriptionPhone': '1-800-363-7377',
  'addABeneficiary.redirectError.header':
    'Nous sommes désolés, nous ne sommes pas en mesure d’ajouter un autre enfant à ce régime.',
  'addABeneficiary.redirectError.fifthBene.description.first':
    'Pour ajouter un enfant, veuillez communiquer avec nous au ',
  'addABeneficiary.redirectError.fifthBene.description.phone': '1-800-363-7377',
  'addABeneficiary.redirectError.fifthBene.description.second':
    ' ou ouvrir un régime familial ou individuel supplémentaire.',
  'addABeneficiary.redirectError.indDescription1.first':
    'Selon les lignes directrices de l’Agence du revenu du Canada (ARC) et d’Emploi et développement social Canada (EDSC), votre REEE individuel peut seulement compter un bénéficiaire.',
  'addABeneficiary.redirectError.indDescription1.second':
    'Ouvrez un nouveau régime pour commencer à épargner pour le compte de votre nouveau bénéficiaire.',
  'addABeneficiary.redirectError.CTA': 'Ouvrir un nouveau régime',
  'cannotContinue.indFifthBene.header':
    'Désolé, vous ne pouvez pas ajouter un nouveau bénéficiaire à ce régime',
  'cannotContinue.indFifthBene.items.header':
    'Il est impossible d’ajouter un bénéficiaire à ce régime pour l’une des raisons suivantes :',
  'cannotContinue.indFifthBene.item.one':
    'Votre REEE individuel ne peut compter qu’un seul bénéficiaire;',
  'cannotContinue.indFifthBene.item.two':
    'Votre REEE familial compte déjà quatre bénéficiaires, le nombre maximal pouvant être ajouté par voie numérique. Veuillez communiquer avec nous pour ajouter d’autres bénéficiaires.',
  'cannotContinue.indFifthBene.description1':
    'Si vous voulez ajouter plus d’un bénéficiaire, songez à ouvrir un nouveau régime familial ou un autre régime individuel.',
  'cannotContinue.indFifthBene.description2':
    'Avant de commencer à épargner pour votre nouveau bénéficiaire, vous devrez répondre à quelques questions simples. Commençons ci-dessous.',
  'cannotContinue.indFifthBene.description3': 'Temps estimé 5-10 minutes',
  'cannotContinue.indFifthBene.CTA': 'Ouvrir un nouveau régime',
  'cannotContinue.existingCoSub.header':
    'Désolé, votre régime actuel a déjà un co-souscripteur',
  'cannotContinue.existingCoSub.description':
    'Veuillez noter que vous ne pouvez ajouter qu’un cosouscripteur à chaque régime.',
  'cannotContinueNoVerification.additionalInfoDescription1':
    'Nous avons besoin de renseignements supplémentaires.',
  'cannotContinue.pendingApplicationHeader':
    'Vous avez actuellement une demande en attente',
  'cannotContinue.pendingApplicationDescription':
    'Ce processus peut prendre quelques jours ouvrables. Vous recevrez un courriel une fois votre demande approuvée. Ensuite, vous pourrez ajouter un autre REEE.',
  'cannotContinue.goToDashboard': 'Consulter le tableau de bord',
  'onboardingBookAppointment.bookAppointment': 'Réservez un rendez-vous',
  'onboardingBookAppointment.moreInfo': 'Vous avez des questions?',
  'onboardingBookAppointment.getInTouch': 'Entrer en contact ',
  'onboardingBookAppointment.customerServiceTeam': 'avec notre équipe.',
  'cannotContinue.previousResponse.header':
    "Désolé, d'après votre réponse précédente, vous ne pouvez pas continuer par voie numérique.",
  'cannotContinue.previousResponse.description':
    'Veuillez communiquer avec nous au 1-800-363-7377 ou en ligne pour poursuivre.',
  'cannotContinue.withdrawalHeader':
    'Désolé, nous ne parvenons pas à envoyer votre demande de retrait',
  'cannotContinue.withdrawalAdditionalInfoDescription1':
    'Vous pouvez mettre à jour vos informations bancaires en accédant à votre compte Embark à tout moment.',
  'cannotContinue.withdrawalSubHeader':
    'Notre équipe est là pour vous aider !  Pour continuer, ',
  'cannotContinue.withdrawalDescription1': 'Remplissez le ',
  'cannotContinue.withdrawalDescription1.Link': 'Formulaire de retrait',
  'cannotContinue.withdrawalDescription1.Link.Document': `${__STUDENT_SERVICES_URL__}/documents/Formulaire-de-retrait-pour-les-etudes Embark (1).pdf`,
  'cannotContinue.withdrawalDescription2':
    "Envoyez votre formulaire de retrait complété et votre vérification d'inscription par courriel à ",
  'cannotContinue.withdrawalDescription2.Email': 'withdrawals@embark.ca',
  'cannotContinue.withdrawalAdditionalInfoDescription2':
    'Lundi au jeudi : de 9h00 à 20h00 HNE',
  'cannotContinue.withdrawalAdditionalInfoDescription3':
    'Vendredi : 9h00 à 18h00 HNE',
  'cannotContinue.termsNotSigned':
    'Désolé, cette demande de service ne peut pas être soumise',
  'cannotContinue.descriptionTermsNotSigned':
    "Cette demande de service ne peut pas être soumise car le client n'a pas encore signé les conditions générales de son régime.",
  'cannotContinue.nonCanadian.header':
    'Désolé, vous ne pouvez pas continuer par voie numérique.',
  'cannotContinue.nonCanadian.additionalInfoDescription1': '',
  'cannotContinue.nonCanadian.additionalInfoDescription2':
    ' étant un non-résident, il nous faut plus d’information supplémentaire pour ce retrait.',
  'cannotContinue.nonCanadian.additionalInfoDescription3':
    'Ne vous inquiétez pas, nos agents sont là pour vous aider. Veuillez communiquer avec nous au 1-800-363-7377 ou en ligne pour poursuivre.',
  'onboardingRiskProfile.descriptionHeaderAllCode':
    ' pour ce régime étudiant Embark',
  'onboardingRiskProfile.descriptionHeaderPlanChange':
    ' et s’aligne au régime étudiant Embark',
  'onboardingRiskProfile.descriptionHeaderLowCode':
    ' pour ce régime conservateur Sélect Embark',
  'onboardingRiskProfile.descriptionHeaderEnd':
    ' et s’aligne sur le régime conservateur Sélect Embark',
  'onboardingRiskProfile.lowProfileSettings':
    'Avec des frais identiques, le régime conservateur Sélect Embark procure les mêmes avantages numériques que le régime étudiant Embark, mais il adopte une approche de placement plus prudente, adapté à votre profil de risque faible.',
  'onboardingRiskProfile.NotlowProfileSettings1':
    'Avec des frais identiques, le régime étudiant Embark procure les mêmes avantages numériques que le Régime conservateur Sélect Embark, mais il adopte une approche de placement évolutive où les placements sont adaptés à l’âge et à la date d’obtention du diplôme de chaque enfant. Ce régime comporte un risque un peu plus élevé et donc des revenus escomptés plus élevés, ce qui correspond à votre profil de risque ',
  'onboardingRiskProfile.NotlowProfileSettings2': '.',
  'onboardingRiskProfile.lowProfileNote1': 'Cliquez sur ',
  'onboardingRiskProfile.lowProfileNote2': '« Continuer »',
  'onboardingRiskProfile.lowProfileNote3': ' pour en savoir plus',
  'onboardingRiskProfile.redo.btn': 'Refaire le questionnaire',
  'onboardingRiskProfile.noticeHeader':
    'Avis concernant le régime conservateur Sélect Embark',
  'onboardingRiskProfile.noticeItem1':
    'Le régime conservateur Sélect Embark adopte une approche de placement plus prudente',
  'onboardingRiskProfile.noticeItem2':
    'L’épargne sera placée dans une combinaison d’actifs fixes (25 % en actions et 75 % en titres à revenu fixe) jusqu’à l’année des 18 ans de l’enfant',
  'onboardingRiskProfile.noticeItem3':
    'Une fois que l’enfant atteint 18 ans, vos placements seront transférés dans un fonds Fin des études qui est axé sur la préservation des épargnes',
  'onboardingRiskProfile.noticeItem4.part1':
    'Pour plus d’informations, veuillez consulter le ',
  'onboardingRiskProfile.noticeItem4.part2':
    'prospectus du Régime conservateur Sélect Embark',
  'onboardingRiskProfile.noticeItem4.part3':
    ' ou réservez un rendez-vous pour parler à un spécialiste en épargne-études',
  'onboardingRiskProfile.noticeItem5.part1':
    'Pour continuer avec le régime conservateur Sélect Embark, cliquez sur ',
  'onboardingRiskProfile.noticeItem5.part2': '« J’accepte »',
  'onboardingRiskProfile.noticeItem5.part3':
    ' ou refusez et refaites votre questionnaire',
  'onboardingRiskProfile.noticeAcceptButton': 'J’accepte',
  'exclusiveOffers.apollo.title': 'Protégez votre logement avec Apollo',
  'exclusiveOffers.apollo.message':
    'Offre exclusive pour l’assurance locataire',
  'exclusiveOffers.apollo.url': 'https://info.apollocover.com/embark',
  'exclusiveOffers.apollo.alt': 'apollo',
  'exclusiveOffers.csl.title':
    'Des logements intelligents pour la vie étudiante',
  'exclusiveOffers.csl.message':
    'Espaces propres et sécuritaires pour étudiants — clés en main',
  'exclusiveOffers.csl.url': 'https://www.canadianstudentliving.com/embark',
  'exclusiveOffers.csl.alt': 'La vie étudiante au Canada',
  'exclusiveOffers.neoFinancial.title': 'Neo Financial',
  'exclusiveOffers.neoFinancial.message':
    'Recevez 25 $ en cadeau en utilisant une carte de crédit approuvée par Neo.',
  'exclusiveOffers.neoFinancial.url': 'https://www.neofinancial.com/',
  'exclusiveOffers.neoFinancial.alt': 'neofinancial',
  'exclusiveOffers.willful.title': 'Willful',
  'exclusiveOffers.willful.message':
    'Profitez d’un rabais de 20 % sur votre testament légal.',
  'exclusiveOffers.willful.url': 'https://try.willful.co/embark',
  'exclusiveOffers.willful.alt': 'willful',
  'exclusiveOffers.willful2.title':
    'Rédigez un testament en quelques minutes avec Willful.',
  'exclusiveOffers.willful2.message':
    'Profitez d’un rabais de 20 % sur votre testament légal.',
  'exclusiveOffers.willful2.url': 'https://try.willful.co/embark/',
  'exclusiveOffers.willful2.alt': 'willful',
  'exclusiveOffers.policyMe.title': 'AssureMoi',
  'exclusiveOffers.policyMe.message':
    "Obtenez vos deux premiers mois d'assurance vie ou d'assurance maladie grave gratuitement.",
  'exclusiveOffers.policyMe.url':
    'https://policyme.pxf.io/c/5711270/2138596/15713',
  'exclusiveOffers.policyMe.alt': 'AssureMoi',
  'exclusiveOffers.policyMe2.title': 'L’assurance vie, simplifiée.',
  'exclusiveOffers.policyMe2.message':
    'Obtenez les deux premiers mois gratuits avec Embark. Souscrivez en ligne en 20 minutes.',
  'exclusiveOffers.policyMe2.url':
    'https://policyme.pxf.io/c/5711270/2138596/15713',
  'exclusiveOffers.policyMe2.alt': 'AssureMoi',
  'exclusiveOffers.youthfully.title': 'Youthfully',
  'exclusiveOffers.youthfully.message':
    'Recevez un rabais de 10 % sur les services d’encadrement individuel',
  'exclusiveOffers.youthfully.url':
    'https://www.youthfully.com/embark/?via=embark',
  'exclusiveOffers.youthfully.alt': 'Youthfully',
  'exclusiveOffers.apollo2.title': 'Protégez votre logement avec Apollo',
  'exclusiveOffers.apollo2.message':
    'Offre exclusive pour l’assurance locataire',
  'exclusiveOffers.apollo2.url': 'https://info.apollocover.com/embark',
  'exclusiveOffers.apollo2.alt': 'apollo',
  'educationSavings.remindCoSubDialog.title':
    'Invitez votre titulaire de compte conjoint à activer son compte numérique',
  'educationSavings.remindCoSubDialog.whyThisMatters':
    'Pourquoi c’est important :',
  'educationSavings.remindCoSubDialog.whyThisMattersBody':
    'Pour que votre titulaire de compte conjoint puisse avoir un accès complet à Embark, il doit s’inscrire. Nous lui enverrons un courriel pour l’aider à s’inscrire à nos services.',
  'educationSavings.remindCoSubDialog.whyThisMattersNote1': 'Remarque : ',
  'educationSavings.remindCoSubDialog.whyThisMattersNote2':
    'Le titulaire de compte conjoint doit être un époux ou un conjoint de fait.',
  'educationSavings.remindCoSubDialog.whatYouNeedToDo': 'Mesures à prendre :',
  'educationSavings.remindCoSubDialog.whatYouNeedToDoStep1':
    'Saisissez son adresse courriel pour lui envoyer un rappel.',
  'educationSavings.remindCoSubDialog.whatYouNeedToDoStep2':
    'Il recevra un courriel avec des instructions pour terminer la création de son compte.',
  invite: 'Inviter',
  'accountSummary.backHome': 'Retour à la page d’accueil',
  'accuntSummary.respTitle': 'Le REEE de ',
  'accountSummary.arrowBack': 'flèche en arrière',
  'accountSummary.coSubReminderBanner.title': 'Invitation à l’accès numérique',
  'accountSummary.coSubReminderBanner.body1': 'Envoyez une invitation à ',
  'accountSummary.coSubReminderBanner.body2':
    ' pour obtenir un accès numérique. Cela lui permettra de consulter son régime et de profiter d’offres exclusives.',
  'giftBanner.content.one': 'Nouveau! Embark cadeau.',
  'giftBanner.content.two':
    'Vous pouvez désormais partager facilement votre lien unique avec votre famille et vos amis.',
  'giftBanner.linkLabel': 'Créer un lien-cadeau',
  'refer.moneyBag.alt': "Sac d'argent",
  'refer.content.four': 'Code de référence: ',
  'refer.content.copyCode': 'Copier le code',
  'refer.linkCopied': 'Lien copié!',
  'refer.step1.mobile':
    'Invitez vos amis et votre famille à ouvrir un REEE Embark en partageant votre lien ou votre code unique.',
  'refer.step3.one': 'Vous et votre ami gagnerez chacun ',
  'refer.step3.three': ' lorsqu’ils souscriront à un plan! *',
  'refer.referAFriend': 'Embark Référez un ami',
  'sendAGift.entry.headline': 'Créez un lien pour les cadeaux',
  'sendAGift.entry.body':
    'La famille et les amis peuvent maintenant verser de l’argent dans le REEE de votre enfant.',
  'sendAGift.entry.steps.title': '3 étapes simples',
  'sendAGift.entry.steps.stepOneHeader': 'Étape 1 : Créer un lien cadeau',
  'sendAGift.entry.steps.stepOneBody':
    "Créer un lien cadeau unique pour chaque enfant. N'oubliez pas de la personnaliser en y ajoutant une photo!",
  'sendAGift.entry.steps.stepTwoHeader':
    'Étape 2 : Partagez le lien-cadeau de votre enfant avec votre famille et vos amis',
  'sendAGift.entry.steps.stepTwoBody':
    'Se prépare z-vous à répandre la joie! Partagez votre lien cadeau avec vos proches et vos amis. Vous pouvez envoyer le lien à autant de personnes que vous le voulez.',
  'sendAGift.entry.steps.stepThreeHeader':
    'Étape 3 : Soyez avisé lorsque vous recevez un don REEE Embark',
  'sendAGift.entry.steps.stepThreeBody':
    'Vous recevrez un avis lorsqu’un don REEE Embark est envoyé. Les cadeaux sont automatiquement déposés dans votre REEE.',
  'sendAGift.entry.tip':
    'Il faudra jusqu’à 7 jours ouvrables pour que le don apparaisse dans le REEE.',
  'sendAGift.entry.button': 'Créer un lien vers un cadeau',
  'sendAGift.beneficiaries.label': 'Sélectionnez un enfant',
  'sendAGift.beneficiaries.listHeader': 'Enfants',
  'sendAGift.beneficiaries.header': 'Qui reçoit le cadeau?',
  'sendAGift.beneficiaries.body':
    "Sélectionnez un enfant pour recevoir le cadeau. Le cadeau qu'ils reçoivent peut aussi être admissible à un maximum de 20 % en subventions gouvernementales!",
  'beneficiaries.addPhoto': 'Ajouter une photo',
  'sendAGift.plans.label': 'Sélectionner un plan',
  'sendAGift.plans.listHeader': 'Plans actuels',
  'sendAGift.plans.header': 'Où voulez-vous que l’argent aille?',
  'sendAGift.plans.body':
    'Si votre plan a plusieurs enfants, vous pouvez choisir qui recevra l’argent.',
  'sendAGift.beneficiaryProfilePermission':
    'Permettre le partage de l’image de l’enfant.',
  'sendAGift.terms.body': 'En choisissant de continuer, vous acceptez les ',
  'sendAGift.terms.link': 'conditions suivantes.',
  'sendAGift.terms.icon.alt': 'redirect icon',
  'sendAGift.footer.lineOne': 'Embarquer. Tous droits réservés.',
  'sendAGift.footer.lineTwo':
    'Embark est une marque de commerce d’Embark Student Corp',
  'sendAGift.skip': 'Sauter cette étape',
  'sendAGift.beneEmail.label': 'Notification de cadeau',
  'sendAGift.beneEmail.header':
    'Souhaitez-vous que votre enfant reçoive un avis?',
  'sendAGift.beneEmail.body':
    'Si votre enfant a une adresse courriel, nous pouvons l’aviser lorsqu’il reçoit un cadeau. Vous serez également avisé lorsque votre enfant recevra un cadeau.',
  'sendAGift.beneEmail.emailHeader': 'Courriel de l’enfant',
  'sendAGift.share.header.one': 'Le lien-cadeau du REEE Embark de ',
  'sendAGift.share.header.two': 'est prêt!',
  'sendAGift.share.mobile.bodyOne': 'Partagez les liens de',
  'sendAGift.share.mobile.bodyTwo':
    ' avec sa famille et ses amis aussi souvent que vous le souhaitez.',
  'sendAGift.share.copy': 'Copie',
  'sendAGift.share.share': 'Partager',
  'sendAGift.share.copied': 'Copié !',
  'sendAGift.share.button': 'Terminé',
  'sendAGift.input.label': 'Lien vers partager',
  'sendAGift.error.selectBeneOption':
    'Veuillez choisir une option pour continuer.',
  'sendAGift.error.selectPlanOption':
    'Veuillez choisir une option pour continuer.',
  'accountSummary.billPaymentCard.headline.text1':
    'Contribuer directement aux services ',
  'accountSummary.billPaymentCard.headline.text2': 'bancaires en ligne',
  'accountSummary.billPaymentCard.button': 'En savoir plus',
  'accountSummary.billPaymentDialog.text1':
    'Ajoutez Embark à titre de bénéficiaire aux termes ',
  'accountSummary.billPaymentDialog.text2': 'du paiement de factures ',
  'accountSummary.billPaymentDialog.text3':
    'pour effectuer des cotisations directes à votre REEE.',
  'accountSummary.billPaymentDialog.item1.text1':
    'Dans vos services bancaires en ligne, sélectionnez «',
  'accountSummary.billPaymentDialog.item1.text2': 'Ajouter un bénéficiaire',
  'accountSummary.billPaymentDialog.item1.text3':
    '» sous Paiement de factures.',
  'accountSummary.billPaymentDialog.item2.text1': 'Rechercher le preneur «',
  'accountSummary.billPaymentDialog.item2.text2': 'Embark Student Corp.',
  'accountSummary.billPaymentDialog.item2.text3': '».',
  'accountSummary.billPaymentDialog.item3.text1':
    'Entrez votre numéro de plan ',
  'accountSummary.billPaymentDialog.item3.text2':
    ' sous le numéro de compte et sauvegarder.',
  'accountSummary.billPaymentDialog.text4':
    'Actuellement disponible à l’adresse suivante:',
  'accountSummary.billPaymentDialog.text5': 'et plus encore...',
  'accountSummary.billPaymentDialog.text6':
    '*Cette fonctionnalité n’est pas offerte aux utilisateurs de la TD et de la Banque CIBC.',
  'accountSummary.billPaymentDialog.tooltip': 'Copier dans le presse-papiers',
  'planTransfer.title.part1':
    'Transférez votre REEE actuel à Embark et recevez une prime de ',
  'planTransfer.title.part2': '',
  'planTransfer.terms.part1': 'Voir ',
  'planTransfer.terms.part2': ' pour obtenir plus d’information.',
  'planTransfer.terms.link': 'conditions générales',
  'planTransfer.termsIcon.alt': 'Icône de redirection',
  'planTransfer.button': 'Transférer',
  'planTransfer.icon.alt': 'Icône de transfert de régime',
  'accountSummary.totalSavings.oldPlanText':
    'Non disponible pour les cotisations. Veuillez cotiser à votre nouveau régime.',
  'accountSummary.totalSavings.viewNewPlanBtn': 'Voir le nouveau régime',
  'accountSummary.newPlanLabel': 'Nouveau régime',
  'accountSummary.embarkConservativePlan.header':
    'Quels avantages en matière de placement le régime conservateur Sélect Embark présente-t-il?',
  'accountSummary.embarkConservativePlan.description.paraOne':
    'Votre REEE comprend les cotisations que vous faites au fil des ans, les subventions gouvernementales et les gains que vous réalisez grâce à la croissance composée quant à vos cotisations et vos subventions.',
  'accountSummary.embarkConservativePlan.description.paraTwo':
    'Dans le cadre du régime conservateur Embark Select, vos cotisations, vos subventions et vos revenus ont une répartition d’actifs ciblée fixe (25 % en actions et 75 % en titres à revenu fixe) jusqu’à l’année où l’enfant atteint 18 ans. À ce moment, vos placements seront transférés dans un compte Fin des études avec une pondération supérieure de titres à revenu fixe afin de préserver vos épargnes.',
  'accountPendingRequests.title': 'Transactions en suspens',
  'accountPendingRequest.type.withdrawal': 'Retrait',
  'accountPendingRequest.alertIcon': "Icône d'alerte",
  'accountPendingRequest.attentionRequired': 'Attention requise',
  'accountPendingRequest.requestCancelled': 'Demande annulée',
  'accountPendingRequest.cancelIcon': 'Icône Annuler',
  'educationGoalCustomize.headline.text': 'Fixer un objectif éducatif pour ',
  'educationGoalCustomize.projectedCostYear': "Coût projeté de l'école en ",
  'savedProgramMatch.year': 'an',
  'savedProgramMatch.careerLabel': 'Carrière en herbe',
  'savedProgramMatch.careerDefault': 'Aucune carrière choisie',
  'savedProgramMatch.careerIconAlt': 'Casquette scolaire',
  'savedProgramMatch.schoolLabel': 'Ecole',
  'savedProgramMatch.schoolDefault': 'Aucune école',
  'savedProgramMatch.programLabel': 'Programme',
  'savedProgramMatch.programDefault': 'Aucun programme sélectionné',
  'savedProgramMatch.link.details': 'Afficher les détails',
  'savedProgramMatch.link.findSchool': 'Trouver une école',
  'bankAccountSelect.verification.message': 'Vérification requise',
  'bankAccountSelect.transferRrsp':
    'Transfert vers un REER d’une autre institution financière',
  'onboardingReview.review.reminderCard.text':
    'Vous avez programmé un rappel pour revenir à votre demande le',
  'onboardingReview.review.IconAlt': 'Icône de cloche',
  'onboardingReview.grants': 'Subventions gouvernementales demandées :',
  'onboardingReviewRESPSection.title.lowProfile':
    'Régime conservateur Sélect Embark',
  'onboardingReviewSubscriberSection.V2.title': 'Renseignements personnels',
  'onboardingReviewPersonalInformation.title': 'Confirmation de l’identité',
  'onboardingReviewBeneficiarySection.icon.alt':
    'Renseignements sur la carte du bénéficiaire',
  'onboardingReviewBeneficiarySection.beneInfoCard.part1':
    'Ce régime est seulement pour ',
  'onboardingReviewBeneficiarySection.beneInfoCard.part2':
    ' pour l’instant, puisque nous n’avons pas encore reçu le NAS de votre ou de vos autres enfants. Vous pouvez facilement les inclure plus tard en sélectionnant « Enregistrer un autre enfant » dans le tableau de bord.',
  'onboardingReview.addPromoReferralCode':
    'Ajouter un code promotionnel ou un code de référence',
  'onboardingSuccess.description':
    'Préparons votre nouveau REEE pour l’épargne.',
  'onboardingSuccess.description.new':
    'Commençons par épargner, par parcourir votre tableau de bord, par lier un compte bancaire ou par verser une cotisation.',
  'onboardingSuccess.startSaving.CTA': 'Commencer à épargner',
  'onboardingSuccess.continueWithOffer': 'Continuons avec l’offre.',
  'onboardingSuccess.transfer': 'Transférez un REEE existent',
  'onboardingSuccess.transfer.description1':
    'Transférez votre REEE actuel à Embark et recevez une prime de ',
  'onboardingSuccess.transfer.description2': '',
  'onboardingSuccess.transfer.conditions':
    '*Les conditions générales s’appliquent',
  'onboardingSuccess.transfer.conditions.url':
    'https://www.embark.ca/fr/conditions-generales-de-prime-de-transfert-entrant-et-de-depot',
  'onboardingSuccess.footer.part1':
    'En passant, vous pouvez ajouter une personne-ressource de confiance à ce régime.  Appelez-nous au ',
  'onboardingSuccess.footer.part2': ' pour en savoir plus.',
  'onboardingSuccess.footer.phoneNumber': '1-800-363-7377',
  'onboardingUnderReview.heading': 'Nous avons reçu votre candidature!',
  'onboardingUnderReview.description':
    'Nous sommes en train d’examiner votre demande, ce qui peut prendre quelques jours ouvrables. Vous recevrez un courriel une fois qu’il aura été approuvé.',
  'onboardingUnderReview.offers.header': 'Des offres exclusives ',
  'onboardingUnderReview.footer.part1':
    'En passant, vous pouvez ajouter une personne-ressource de confiance à ce régime.  Appelez-nous au ',
  'onboardingUnderReview.footer.part2': ' pour en savoir plus.',
  'onboardingUnderReview.footer.phoneNumber': '1-800-363-7377',
  'onboardingPendingApplication.description.one':
    'Nous avons enregistré tous vos renseignements, mais le REEE n’a pas encore été ouvert.',
  'onboardingPendingApplication.description.two':
    'Revenez lorsque vous aurez rassemblé tous les renseignements nécessaires pour terminer le processus.',
  'digitalAccessSuccess.img.alt': "Icône de réussite de l'accès numérique",
  'digitalAccessSuccess.heading':
    'Vos régimes ont été transférés à votre compte Embark',
  'digitalAccessSuccess.message':
    'Veuillez consulter votre page d’accueil pour prendre connaissance des détails du régime et apporter toute modification nécessaire à votre profil de risque.',
  'digitalAccessBookAppointment.heading': 'Vous avez rencontré un problème?',
  'digitalAccessBookAppointment.message':
    'Veuillez vérifier vos informations et recommencer le processus d’activation numérique.',
  'digitalAccessBookAppointment.existingCustomer':
    'Vous êtes déjà un client d’Embark?',
  'digitalAccessCannotContinue.heading':
    'Quelque chose a mal tourné et vous êtes incapable de poursuivre',
  'digitalAccessCannotContinue.issueTitle':
    'Vous pourriez avoir ce problème pour l’une des raisons suivantes :',
  'digitalAccessCannotContinue.issue1':
    'Les renseignements fournis sont inexacts ou ne peuvent être trouvés dans notre système;',
  'digitalAccessCannotContinue.issue2': 'Vous n’avez pas souscrit à un régime;',
  'digitalAccessCannotContinue.issue3':
    'Notre système connaît des difficultés techniques',
  'digitalAccessCannotContinue.homepage': "Page d'accueil",
  'onboardingSuccess.dashboard.message':
    'Votre REEE Embark est ouvert! Consultez votre tableau de bord, obtenez des conseils de carrière personnalisés et profitez d’offres spéciales à votre intention.',
  'onboardingSuccess.V2.offers.header': 'Des offres exclusives',
  'onbaordingSuccess.offers.header': 'Des offres exclusives pour vous',
  'onbaordingSuccess.offers.neoFinancial.title': 'Neo Financial',
  'onbaordingSuccess.offers.neoFinancial.message':
    'Recevez 25 $ en cadeau en utilisant une carte de crédit approuvée par Neo.',
  'onbaordingSuccess.offers.neoFinancial.url': 'https://www.neofinancial.com/',
  'onbaordingSuccess.offers.neoFinancial.alt': 'neofinancial',
  'onbaordingSuccess.offers.willful.title': 'Willful',
  'onbaordingSuccess.offers.willful.message':
    'Profitez d’un rabais de 20 % sur votre testament légal.',
  'onbaordingSuccess.offers.willful.url': 'https://try.willful.co/embark',
  'onbaordingSuccess.offers.willful.alt': 'willful',
  'onbaordingSuccess.offers.policyMe.title': 'PolicyMe',
  'onbaordingSuccess.offers.policyMe.message':
    "Obtenez vos deux premiers mois d'assuranc e vie ou d'assuranc e maladie grave gratuitement.",
  'onbaordingSuccess.offers.policyMe.url': 'https://www.policyme.com/',
  'onbaordingSuccess.offers.policyMe.alt': 'policyMe',
  'onbaordingSuccess.card.message':
    'D’ailleurs, vous pouvez ajouter une personne de confiance à ce régime. Appelez-nous au 1-800-363-7377 pour en savoir plus.',
  'onbaordingSuccess.card.alt': 'Bookmark Icon',
  'digitalAccessSuccess.homepage': "Page d'accueil",
  'beneficiary.messageContent':
    'Veuillez noter que les enfants ajoutés à un régime familial doivent être des frères et sœurs de sang ou par adoption des bénéficiaires actuels du régime.',
  'email.optional': 'Courriel (facultatif)',
  'manageAccount.transferIn': 'Transférer un REEE',
  'manageAccount.transferIn.alt': 'Transférer un REEE de compte',
  'addPlanMembers.child.addChild': 'Ajouter un enfant',
  'addBeneficiary.success.description': 'Épargnons pour leurs études.',
  'digitalAccessPersonalInfo.addressFields.title': 'Adresse de résidence',
  'AIPWithdrawal.whichAccount': 'Vers quel compte?',
  'AIPWithdrawal.planSelection.stepperHeader': 'Sélectionner un régime',
  'AIPWithdrawal.unavailable': 'Retrait à titre de PRA non disponible',
  'AIPWithdrawal.body':
    'Il semble que vous ne puissiez pas effectuer de retrait à titre de PRA pour l’instant. Il se peut que certaines conditions ne soient pas remplies. Voici quelques raisons possibles :',
  'AIPWithdrawal.description1':
    'Vous avez encore des cotisations dans le régime.',
  'AIPWithdrawal.description2':
    'Une demande de retrait à titre de PRA a déjà été soumise.',
  'AIPWithdrawal.description3':
    'Les enfants bénéficiaires sont âgés de moins de 21 ans.',
  'AIPWithdrawal.makeWithdrawal': 'Effectuer un retrait à titre de PRA',
  'AIPWithdrawal.makeWithdrawalTitle':
    'Voici quelques informations importantes à connaître avant d’effectuer un retrait à titre de PRA :',
  'AIPWithdrawal.makeWithdrawalDescription1.part1':
    'Avant de pouvoir effectuer un retrait à titre de PRA, vous devez ',
  'AIPWithdrawal.makeWithdrawalDescription1.part2':
    'd’abord aviser un représentant d’Embark que vous prévoyez d’effectuer un retrait à des fins autres que les études postsecondaires. ',
  'AIPWithdrawal.makeWithdrawalDescription1.part3':
    'Veuillez communiquer avec nous à l’adresse contact@embark.ca. ',
  'AIPWithdrawal.makeWithdrawalDescription1.part4':
    'Si cette étape est ignorée, votre retrait à titre de PRA sera refusé.',
  'AIPWithdrawal.makeWithdrawalDescription2.part1':
    'Tous les retraits à titre de PRA sont considérés comme ',
  'AIPWithdrawal.makeWithdrawalDescription2.part2': 'des revenus imposables.',
  'AIPWithdrawal.makeWithdrawalDescription3.part1':
    'Vous pouvez choisir de transférer les fonds dans ',
  'AIPWithdrawal.makeWithdrawalDescription3.part2':
    'votre compte bancaire personnel ou dans un REER (régime enregistré d’épargne-retraite) ',
  'AIPWithdrawal.makeWithdrawalDescription3.part3':
    'd’une autre institution financière. En transférant les fonds dans un REER, vous pourriez ',
  'AIPWithdrawal.makeWithdrawalDescription3.part4': 'réduire l’impôt ',
  'AIPWithdrawal.makeWithdrawalDescription3.part5': 'sur le retrait.',
  'AIPWithdrawal.makeWithdrawalDescription4.part1':
    'Aucune autre personne ne peut soumettre de demande de retrait à titre de PRA en votre nom. Si un titulaire de compte conjoint veut également soumettre une demande de retrait à titre de PRA, cette personne devra ',
  'AIPWithdrawal.makeWithdrawalDescription4.part2':
    'ouvrir une session et remplir sa propre demande',
  'AIPWithdrawal.makeWithdrawalDescription4.part3': '.',
  'AIPWithdrawal.makeWithdrawalDescription5.part1':
    'Une fois le retrait à titre de PRA terminé, ',
  'AIPWithdrawal.makeWithdrawalDescription5.part2':
    'votre REEE sera fermé en février de l’année suivante. ',
  'AIPWithdrawal.makeWithdrawalDescription5.part3':
    'Toutes les subventions restantes seront remboursées au gouvernement et les fonds non utilisés seront perdus.',
  'AIPWithdrawal.makeWithdrawalDescription6.part1':
    'Si votre enfant bénéficiaire décide de ne pas suivre des études postsecondaires, envisagez ',
  'AIPWithdrawal.makeWithdrawalDescription6.part2':
    'd’inscrire un nouveau bénéficiaire ',
  'AIPWithdrawal.makeWithdrawalDescription6.part2.link':
    'https://www.embark.ca/fr/retirer-des-fonds',
  'AIPWithdrawal.makeWithdrawalDescription6.part3': 'au régime.',
  'AIPWithdrawal.amountError': 'Veuillez entrer un montant.',
  'AIPWithdrawal.RRSPDeductionLimit.title':
    'Maximum déductible au titre des REER',
  'AIPWithdrawal.RRSPDeductionLimit.desc':
    'Pour transférer le revenu accumulé sur votre REEE à votre REER, nous devons confirmer que vos droits de cotisation au REER sont suffisants. Veuillez consulter votre avis de cotisation et saisir votre maximum déductible au titre des REER ci-dessous.',
  'AIPWithdrawal.RRSPDeductionLimit.linkText':
    'Où puis-je trouver mon maximum déductible?',
  'AIPWithdrawal.RRSPDeductionLimit.link':
    'https://www.canada.ca/fr/agence-revenu/services/impot/particuliers/sujets/reer-regimes-connexes/cotiser-a-reer-a-rpac-a/connaitre-maximum-deductible-votre-reer-rpac.html',
  'AIPWithdrawal.RRSPWithdrawalUnavailable':
    'Transfert vers un REER non disponible',
  'AIPWithdrawal.RRSPWithdrawalUnavailable.desc':
    'Vos droits de cotisation au REER ne sont pas suffisants pour effectuer ce transfert. Vous pouvez revenir en arrière et soumettre une demande de retrait intégral à titre de PRA vers votre compte bancaire.',
  'AIPWithdrawal.success.message1':
    'Vous avez envoyé avec succès votre demande de retrait à titre de PRA de ',
  'AIPWithdrawal.success.message2':
    ' Veuillez prévoir un délai de 5 à 7 jours pour le traitement de votre retrait.',
  'AIPWithdrawal.jointAccount.question': 'Quel montant voulez-vous retirer?',
  'AIPWithdrawal.jointAccount.info':
    'Votre titulaire de compte conjoint doit soumettre sa propre demande de retrait à titre de PRA en se connectant à son compte.',
  'AIPWithdrawalTransferDetails.stepperHeader': 'Détails sur le REER',
  'AIPWithdrawalTransferDetails.enterAddressLabel':
    "Saisir l'adresse manuellement",
  'AIPWithdrawal.aip': 'Solde du revenu accumulé',
  'AIPWithdrawalBalance.paragraph1.1':
    'Pour effectuer ce retrait à titre de PRA, vous devrez retirer de votre régime l’intégralité du revenu accumulé, soit',
  'AIPWithdrawalBalance.paragraph1.2':
    '. Dans les cas où des souscripteurs conjoints participent au régime, le montant total peut être retiré par l’un des souscripteurs ou par les deux.',
  'AIPWithdrawalBalance.paragraph2.1':
    'Après le retrait, toutes les subventions accumulées, d’un montant de',
  'AIPWithdrawalBalance.paragraph2.2':
    ', seront remboursées au gouvernement. Vous trouverez ci-dessous une ventilation détaillée.',
  'AIPWithdrawal.review.text1':
    'L’impôt sur le revenu régulier et l’impôt provincial seront déduits à la fin du traitement de votre retrait à titre de PRA.',
  'AIPWithdrawal.review.text2':
    'Le montant définitif que vous recevrez pourrait varier en fonction des fluctuations du marché.',
  'AIPWithdrawal.review.text3':
    'Une fois le retrait à titre de PRA traité, un relevé d’impôt sera émis. Le compte REEE sera fermé à la fin du mois de février de l’année suivante.',
  'PSEEnrolmentVerification.EAPLimit.note.first':
    'Conformément à la réglementation gouvernementale, un étudiant inscrit à un programme à temps partiel peut retirer ',
  'PSEEnrolmentVerification.EAPLimit.note.amount': '4 000 $',
  'PSEEnrolmentVerification.EAPLimit.note.last':
    ' des subventions et revenus par période de 13 semaines. Si le montant que vous demandez excède cette limite, vous nous autorisez à déduire le solde de vos cotisations résiduelles, le cas échéant.',
  'PSEEnrolmentVerification.EAPLimit.alt': "Icône d'informations de retrai",
  'PSEEnrolmentVerification.areTheyCanadianResident':
    'Sont-ils des résidents canadiens aux fins de l’impôt?',
  'PSEEnrolmentVerification.areTheyCanadianResident.helperText1':
    'Déterminer leur ',
  'PSEEnrolmentVerification.areTheyCanadianResident.helperText2':
    'statut de résident',
  'PSEEnrolmentVerification.areTheyCanadianResident.link':
    'https://www.canada.ca/fr/agence-revenu/services/impot/impot-international-non-residents/renseignements-ont-deplaces/determination-votre-statut-residence.html',
  selectAnotherAccount: 'Sélectionner un autre compte',
  pleaseEnterPercentage: 'Veuillez indiquer le pourcentage.',
  pleaseEnterCorrectPercentage: 'Veuillez entrer un numéro de 1 à 100.',
  'vouchedIDV.digitalAccess.crossDeviceTitle':
    "Vérifions votre pièce d'identité",
  'vouchedIDV.alertBanner':
    'Toutes vos données sont sécurisées et chiffrées. Nous utilisons ces renseignements uniquement pour confirmer votre identité.',
  'idVerificationExpired.message':
    'Sorry, we could not verify your identity because your ID has expired. Please try again with a valid ID.',
  'idVerificationStop.message': 'Veuillez réessayer plus tard.',
  'educationProjection.years': 'ans',
  'planTransferSummary.title': 'Résumé du transfert',
  'enrolmentSummary.gender': 'Sexe',
  'Onboarding.primary.SIN': 'Votre numéro d’assurance sociale',
  'enrolmentSummary.sourceOfIncome': 'Source de revenus',
  'enrolmentSummary.managementRebateSelection':
    'Ce client transfère-t-il un ou plusieurs régimes PremFlex ou RFUE?',
  'enrolmentSummary.managementRebateSelection.Yes': 'Oui',
  'enrolmentSummary.managementRebateSelection.No': 'Non',
  'enrolmentSummary.managementRebatePlan': 'Quel(s) régime(s) transfère-t-il?',
  'enrolmentSummary.managementRebatePlan.FFP': 'Régime PremFlex',
  'enrolmentSummary.managementRebatePlan.FSSP': 'Régime RFUE',
  'enrolmentSummary.managementRebatePlan.Both':
    'Régimes combinés RFUE et PremFlex',
  'enrolmentSummary.sessionID': 'ID de Session',
  'enrolmentSummary.grantsGovernmentApplied':
    'Subventions gouvernementales demandées :',
  'faceRating.headline': "J'ai trouvé ces informations utiles.",
  'faceRating.stronglyDisagree': 'Strongly Disagree',
  'faceRating.disagree': 'Disagree',
  'faceRating.neutral': 'Neutral',
  'faceRating.agree': 'Agree',
  'faceRating.stronglyAgree': 'Strongly Agree',
  'schoolCostCard.costOfSchool': "Coût de l'école",
  'schoolCostCard.noCalculatedCost': 'Aucun coût calculé',
  'termsConditions.eaa.link.family': `${__STUDENT_SERVICES_URL__}/documents/Embark_Student_Family_Plan_EAA_&_Acknowledgements_&_Prospectus_FR_DIGITAL.pdf`,
  'termsConditions.eaa.link.individual': `${__STUDENT_SERVICES_URL__}/documents/Embark_Student_Individual_Plan_EAA_&_Acknowledgements_&_Prospectus_FR_DIGITAL.pdf`,
  'termsConditions.eaa.link.conservativeIndividual': `${__STUDENT_SERVICES_URL__}/documents/Embark_Student_Conservative_Individual_Plan_EAA_&_Acknowledgements_&_Prospectus_FR_DIGITAL.pdf`,
  'termsConditions.eaa.link.conservativeFamily': `${__STUDENT_SERVICES_URL__}/documents/Embark_Student_Conservative_Family_Plan_EAA_&_Acknowledgements_&_Prospectus_FR_DIGITAL.pdf`,
  'termsConditions.eaa.link.glidePathIndividual': `${__STUDENT_SERVICES_URL__}/documents/Embark_Student_GlidePath_Individual_Plan_EAA_&_Acknowledgements_&_Prospectus_FR_DIGITAL.pdf`,
  'termsConditions.eaa.link.glidePathFamily': `${__STUDENT_SERVICES_URL__}/documents/Embark_Student_GlidePath_Family_Plan_EAA_&_Acknowledgements_&_Prospectus_FR_DIGITAL.pdf`,
  'termsConditions.customerReferralDisclosure':
    'Divulgation de référence client',
  'termsConditions.customerReferralDisclosure.link.lighthouse': `${__STUDENT_SERVICES_URL__}/documents/Embark_Customer_Referral_Disclosure_Lighthouse_fr.pdf`,
  'termsConditions.customerReferralDisclosure.link.fintel': `${__STUDENT_SERVICES_URL__}/documents/Embark_Customer_Referral_Disclosure_Fintel_en.pdf`,
  'fileUpload.maxFileSizeError1.button':
    'Veuillez téléverser un fichier de taille valide. Taille maximale du fichier : 5 Mo.',
  'fileUpload.fileTypeError.button':
    'Le format de fichier sélectionné n’est pas pris en charge. Veuillez téléverser un fichier au format PDF, PNG ou JPG.',
  'documents.enrolmentSummary': 'Résumé de l’inscription',
  'documents.filterDescription':
    'Trouvez rapidement le document dont vous avez besoin grâce aux filtres.',
  'documents.noDocumentsTitle': 'Il semble que vous n’avez aucun document',
  'documents.noDocumentsDescription':
    'Vos documents seront accessibles ici après avoir ajouté un régime, effectué un retrait ou reçu votre prochain relevé trimestriel.',
  'documents.noActivityDescription': 'Aucune activité pour le mois.',
  filter: 'Filtres',
  noMatchesFound: 'Aucun résultat trouvé',
  tryAdjustingYourFilters: 'Essayez d’ajuster vos filtres.',
  clearFilter: 'Effacer le filtre',
  loadMore: 'Afficher plus',
  download: 'Télécharger',
  'profile.riskProfile': 'Profil de risque',
  'digitalAccessPersonalInfo.DateOfBirth': 'Date de naissance',
  'investmentProfile.standaloneKYC.employmentStatus':
    'Quelle est votre situation d’emploi?',
  'standalonekyc.riskprofile.confirmButton': 'Confirmer les informations',
  'standalonekyc.riskprofile.timeHorizonDialogTitle':
    'Souhaitez-vous mettre votre réponse à jour?',
  'standalonekyc.riskprofile.timeHorizonDialogMessage':
    'Il semble que vous ayez changé d’idée par rapport à votre sélection précédente. Si vous effectuez la mise à jour maintenant, vous ne pourrez plus continuer par voie numérique. Veuillez communiquer avec nous au 1-800-363-7377 ou en ligne pour poursuivre.',
  'standalonekyc.riskprofile.postSecondaryDialogTitle':
    'Souhaitez-vous mettre votre réponse à jour?',
  'standalonekyc.riskprofile.postSecondaryDialogMessage':
    'Il semble que vous ayez changé d’idée par rapport à votre sélection précédente. Si vous effectuez la mise à jour maintenant, vous ne pourrez plus continuer par voie numérique. Veuillez communiquer avec nous au 1-800-363-7377 ou en ligne pour poursuivre.',
  'standalonekyc.RiskProfile.toConservative.noticeHeader':
    'Avis de transfert dans le régime conservateur Sélect Embark',
  'standalonekyc.RiskProfile.toConservative.noticeItem1':
    'Le régime conservateur Sélect Embark adopte une approche de placement plus prudente',
  'standalonekyc.RiskProfile.toConservative.noticeItem2':
    'L’épargne sera placée dans une combinaison d’actifs fixes (25 % en actions et 75 % en titres à revenu fixe) jusqu’à l’année des 18 ans de l’enfant',
  'standalonekyc.RiskProfile.toConservative.noticeItem3':
    'Une fois que l’enfant atteint 18 ans, vos placements seront transférés dans un fonds Fin des études qui est axé sur la préservation des épargnes',
  'standalonekyc.RiskProfile.toConservative.noticeItem4.part1':
    'Pour plus d’informations, veuillez consulter le ',
  'standalonekyc.RiskProfile.toConservative.noticeItem4.part2':
    'prospectus du Régime conservateur Sélect Embark',
  'standalonekyc.RiskProfile.toConservative.noticeItem5':
    'En continuant, vous consentez au transfert de vos actifs du régime conservateur Sélect Embark au régime étudiant Embark',
  'standalonekyc.RiskProfile.toConservative.noticeItem6.part1':
    'Pour continuer avec le régime conservateur Sélect Embark, cliquez sur ',
  'standalonekyc.RiskProfile.toConservative.noticeItem6.part2': '“J’accepte”',
  'standalonekyc.RiskProfile.toConservative.noticeItem6.part3':
    ' ou refusez et refaites votre questionnaire',
  'standalonekyc.RiskProfile.toGlidepath.noticeHeader':
    'Avis de transfert dans le régime étudiant Embark',
  'standalonekyc.RiskProfile.toGlidepath.noticeItem1':
    'Le régime étudiant Embark adapte la stratégie de chaque enfant à son âge, qui est axée sur la croissance lorsqu’il est jeune et qui s’ajuste automatiquement pour devenir plus prudente alors qu’il approche de l’obtention de son diplôme afin de préserver son épargne',
  'standalonekyc.RiskProfile.toGlidepath.noticeItem2.part1':
    'Pour plus d’informations sur le régime étudiant Embark, veuillez consulter le ',
  'standalonekyc.RiskProfile.toGlidepath.noticeItem2.part2':
    'prospectus du régime étudiant Embark',
  'standalonekyc.RiskProfile.toGlidepath.noticeItem3':
    'En continuant, vous consentez au transfert de vos actifs du régime conservateur Sélect Embark au régime étudiant Embark.',
  'standalonekyc.RiskProfile.toGlidepath.noticeItem4.part1':
    'Pour continuer avec le régime étudiant Embark, cliquez sur ',
  'standalonekyc.RiskProfile.toGlidepath.noticeItem4.part2': '“J’accepte”',
  'standalonekyc.RiskProfile.toGlidepath.noticeItem4.part3':
    ' ou refusez et refaites votre questionnaire',
  'standalonekyc.RiskProfile.NoticeInfo':
    'Remarque : Le transfert du régime peut prendre de 45 à 60 jours ouvrables.',
  'standalonekyc.RiskProfile.confirmationDialogContinue': 'Oui, continuez',
  'mandatoryKYC.header':
    'Leur situation personnelle et financière est-elle restée la même?',
  'mandatoryKYC.header.quickReview': 'Faisons un bref examen de votre profil',
  'mandatoryKYC.body':
    'Avant de poursuivre, nous devons confirmer les renseignements personnels et financiers. Des modifications apportées aux profils d’investissement ou de risque peuvent nécessiter une réévaluation du régime.',
  'mandatoryKYC.phone.headline': 'Quel est votre numéro de téléphone mobile ?',
  'mandatoryKYC.riskProfile.updateRisk':
    'Mettez à jour votre profil de risque. Cela ne prendra que 5 à 10 minutes.',
  'update.now': 'Mettre à jour',
  goback: 'Retour',
  'mandatoryKYC.confirm.CTA': 'Confirmer les informations',
  'mandatoryKYC.skipNow.CTA': 'Ignorer pour l’instant',
  'termsConditions.callus':
    'D’ailleurs, vous pouvez ajouter une personne de confiance à ce régime. Appelez-nous au 1-800-363-7377 pour en savoir plus.',
  'withdrawal.pendingOrders.header':
    'Vous avez déjà une demande de retrait en cours de traitement pour ce régime',
  'withdrawal.pendingOrders.body':
    ' Vous ne pouvez pas avoir plus d’une demande de retrait à la fois. Veuillez attendre que votre demande précédente soit terminée avant d’en soumettre une autre.',
  'dashboard.button': 'Consulter le tableau de bord',
  invalidDateFormat: 'Veuillez entrer une date valide.',
  'withdrawal.transactions.title': 'Retrait',
  'withdrawal.transactions.stepperIcon.alt': 'Icône pas à pas',
  'withdrawal.transactions.stepper.underReview': 'En cours d’examen',
  'withdrawal.transactions.stepper.approved': 'Demande approuvée',
  'withdrawal.transactions.stepper.cancelled': 'Retrait annulé',
  'withdrawal.transactions.stepper.attentionRequired': 'Attention requise',
  'withdrawal.transactions.stepper.moneySent': 'Argent envoyé',
  'withdrawal.transactions.stepper.inProgress': 'En cours',
  'withdrawal.transactions.withdrawalAmount.header': 'Montant du retrait ',
  'withdrawal.transactions.withdrawalAmount.description1':
    'Les étudiants admissibles à la Subvention canadienne pour l’épargne-études (SCEE) et inscrits à un régime enregistré d’épargne-études peuvent recevoir un maximum de 7 200 $ au titre de la SCEE. Tout montant perçu excédant ce plafond devra être remboursé au gouvernement.',
  'withdrawal.transactions.withdrawalAmount.description2':
    'Toute autre subvention reçue pourrait également devoir être remboursée au gouvernement, selon l’admissibilité de l’étudiant ou de l’étudiante au moment du retrait.',
  'withdrawal.transactions.withdrawalDetails.header': 'Détails supplémentaires',
  'withdrawal.transactions.card.inProgress':
    'Vos fonds devraient être déposés dans votre compte d’ici le : ',
  'withdrawal.transactions.card.underReview':
    'Si d’autres renseignements sont requis, nous communiquerons avec vous par courriel. Veuillez prévoir de 5 à 7 jours ouvrables pour le traitement de votre demande.',
  'withdrawal.transactions.card.approved':
    'Votre demande de retrait a été approuvée. Veuillez prévoir de 2 à 3 jours ouvrables pour le dépôt de vos fonds.',
  'withdrawal.transactions.card.moneySentOverThreshold':
    'Votre demande a été traitée avec succès. Veuillez prévoir de 2 à 3 jours ouvrables pour que les fonds soient déposés dans votre compte.',
  'withdrawal.transactions.card.moneySentUnderThreshold':
    'Vos fonds devraient être déposés dans votre compte d’ici le :',
  'withdrawal.transactions.card.cancelledOverThreshold':
    'Nous avons dû annuler votre demande de retrait en raison d’une demande de votre part ou d’une incapacité à vous joindre pour demander les renseignements supplémentaires requis. Si vous désirez toujours retirer des fonds de votre REEE, veuillez soumettre une nouvelle demande.',
  'withdrawal.transactions.card.cancelledUnderThreshold':
    'Nous avons dû annuler votre demande de retrait en raison d’une demande de votre part ou d’une incapacité à vous joindre pour demander les renseignements supplémentaires requis. Si vous désirez toujours retirer des fonds de votre REEE, veuillez soumettre une nouvelle demande.',
  'withdrawal.transactions.card.attentionRequire':
    'Dans votre boîte de réception, vous devriez recevoir un courriel présentant les prochaines étapes du traitement de votre retrait. Le traitement de vos fonds prendra 5 jours ouvrables à partir du moment où vous aurez fourni une nouvelle confirmation d’inscription. Les demandes de retrait sont annulées si aucune mesure n’est prise dans les 30 jours ouvrables.',
  'withdrawalEnrolmentVerification.header': "Qui va à l'école",
  'withdrawalEnrolmentVerification.beneficiary.label': 'Nom de l’enfant',
  'withdrawalEnrolmentVerification.beneficiaryEmail.label':
    'Adresse courriel de l’enfant',
  'withdrawalEnrolmentVerification.areTheyCanadianResident.checkbox.label':
    'Oui, l’enfant vit toujours à la même adresse.',
  'withdrawalEnrolmentVerification.areTheyCanadianResident.yes.card.label':
    'Veuillez vous assurer que l’adresse de votre enfant est à jour.',
  'withdrawalEnrolmentVerification.areTheyCanadianResident.yes.card.description':
    'L’adresse au Canada pour que nous puissions maintenir l’exactitude de nos dossiers et assurer l’admissibilité continue aux subventions.',
  'withdrawalEnrolmentVerification.areTheyCanadianResident.no.card.label':
    'Limited access to grant funds',
  'withdrawalEnrolmentVerification.areTheyCanadianResident.no.card.description':
    'Les retraits d’un REEE se composent de trois parties : les cotisations, les revenus et les subventions. Si votre enfant vit à l’étranger, il se peut qu’il n’ait pas accès à des subventions telles que la SCEE ou le BEC, et que son revenu soit imposé différemment selon le pays. ',
  'withdrawalEnrolmentVerification.areTheyCanadianResident.no.card.learnMore':
    'En savoir plus',
  'withdrawalEnrolmentVerification.areTheyCanadianResident.address.label':
    'Adresse',
  'withdrawalEnrolmentVerification.areTheyCanadianResident.address.placeholder':
    'Commencez à saisir votre adresse.',
  'withdrawalEnrolmentVerification.areTheyCanadianResident.header':
    'S’agit-il d’un résident canadien?',
  'withdrawalEnrolmentVerification.voe.header':
    'Confirmation de l’admission (CDA)',
  'withdrawalEnrolmentVerification.voe.link.popup': 'Qu’est-ce qu’une CDA?',
  'withdrawalEnrolmentVerification.voe.link.sampleVoe': 'Voir l’exemple de CDA',
  'withdrawalEnrolmentVerification.voe.schoolName.label':
    'Nom de l’établissement',
  'withdrawalEnrolmentVerification.voe.schoolName.error.required':
    "Veuillez entrer le nom de l'école sur le VoE.",
  'withdrawalEnrolmentVerification.voe.schoolName.other.error.required':
    'Veuillez saisir un nom d’établissement pour continuer.',
  'withdrawalEnrolmentVerification.voe.schoolName.other.error.maxLength':
    'Veuillez entrer le nom d’une institution financière — moins de 200 caractères. ',
  'withdrawalEnrolmentVerification.voe.postalCode.helperText':
    'Le code postal sur la CDA',
  'withdrawalEnrolmentVerification.voe.addVerificationSchoolEnrolment':
    'Ajouter une vérification de l’inscription scolaire',
  'withdrawalEnrolmentVerification.voe.fileUpload.error.required':
    'Veuillez télécharger une copie numérique de votre VoE.',
  'withdrawalEnrolmentVerification.enrolmentType.header': "Type d'inscription",
  'withdrawalEnrolmentVerification.enrolmentType.label': "Type d'inscription",
  'withdrawalEnrolmentVerification.enrolmentType.info.partTime.one':
    'Les retraits des subventions et des revenus sont limités à ',
  'withdrawalEnrolmentVerification.enrolmentType.info.partTime.two':
    ' 4 000 $ ',
  'withdrawalEnrolmentVerification.enrolmentType.info.partTime.three':
    'par période de 13 semaines pour les études à temps partiel. Si votre demande dépasse cette limite, nous déduirons le montant excédentaire de votre cotisation. ',
  'withdrawalEnrolmentVerification.enrolmentType.programType.label':
    'Type de programme',
  'withdrawalEnrolmentVerification.enrolmentType.programType.error.required':
    'Please enter the program type.',
  'withdrawalEnrolmentVerification.enrolmentType.programDuration.label':
    'Durée (en années)',
  'withdrawalEnrolmentVerification.enrolmentType.programYear.label':
    'Année du programme',
  'withdrawalEnrolmentVerification.startDate.header': 'Date de début',
  'withdrawalEnrolmentVerification.consecutiveWeeks.header':
    'Dans les 12 derniers mois, votre enfant a-t-il passé 13 semaines consécutives aux études postsecondaires?',
  'withdrawalEapBreakdown.heading': 'Retrait : paiement d’aide aux études',
  'withdrawalEapBreakdown.subheading':
    'Répartition des subventions et du bénéfice',
  'withdrawalEapBreakdown.label.CESG':
    'Subvention canadienne pour l’épargne-études (SCEE) :',
  'withdrawalEapBreakdown.label.CLB': 'Bon d’études canadien (BEC) :',
  'withdrawalEapBreakdown.label.BCTESG':
    'Subvention pour l’épargne études et l’épargne formation de la Colombie-Britannique (SEEEFCB) :',
  'withdrawalEapBreakdown.label.QESI':
    "Incitatif québécois à l'épargne-études (IQEE) :",
  'withdrawalEapBreakdown.label.income': 'Revenu :',
  'withdrawalEapBreakdown.label.total': 'Total :',
  'withdrawalEapBreakdown.description.1':
    'Les étudiants admissibles à la Subvention canadienne pour l’épargne-études (SCEE) et inscrits à un régime enregistré d’épargne-études peuvent recevoir un maximum de 7 200 $ en SCEE. Les étudiants sont limités à ce montant et tout excédent doit être remboursé au gouvernement.',
  'withdrawalEapBreakdown.description.2':
    'Toute autre subvention reçue pourrait également devoir être remboursée au gouvernement, selon l’admissibilité de l’étudiant ou de l’étudiante au moment du retrait.',
  'img.alt.grantsImage':
    'Trois billets de dollars brillants empilés en décalage',
  'img.alt.checklist': 'Liste de contrôle',
  'img.alt.grantsGif':
    'Animation of three shining dollar bills stacked in offset',
  'img.alt.questionList': 'Liste des questions',
  'img.alt.onboardingSuccess': 'Tourbillons et confettis',
  'img.alt.promoIcon': 'sac cadeau',
  'img.alt.icon.educationGraphic': 'Toque de diplômé',
  'withdrawal.transactions.schoolName': 'Nom de l’établissement',
  'withdrawal.transactions.postalCode': 'Code postal de l’établissement',
  'withdrawal.transactions.duration': 'Durée (en années)',
  'withdrawal.transactions.to': 'À',
  'withdrawal.transactions.weeksAttended':
    'Dans les 12 derniers mois, votre enfant a-t-il passé 13 semaines consécutives aux études postsecondaires?',
  'withdrawalApplication.selectAPlan.header': 'Sélectionnez un régime',
  'withdrawalApplication.amount.header': 'Montant du retrait',
  'withdrawalApplication.amount.withdrawalBreakdown': 'Répartition du retrait',
  'withdrawalApplication.amount.howMuchWithdrawal':
    'Quel montant devrais-je retirer?',
  'withdrawalApplication.amount.reallocate': 'Réaffecter',
  'withdrawalApplication.amount.grants': 'Subvention et revenus : ',
  'withdrawalApplication.amount.availableForWithdrawal':
    ' available for withdrawal.',
  'withdrawalApplication.amount.contributions': 'Cotisations : ',
  'withdrawalApplication.amount.grantsNote.body':
    'Par défaut, nous retirons des fonds de vos subventions et revenus avant de les retirer des cotisations. L’option de modification ci-dessus vous permet de réaffecter les fonds.',
  'withdrawalApplication.bank.header':
    'Dans quel compte souhaitez-vous faire le dépôt?',
  'withdrawalApplication.bank.selectionRequired':
    'Veuillez sélectionner un compte pour continuer.',
  'withdrawalApplication.review.header': 'Revoir',
  'withdrawalApplication.reviewDetailsSection.title': 'Détails du retrait',
  'withdrawalApplication.reviewDetailsSection.amount': 'Montant :',
  'withdrawalApplication.reviewDetailsSection.grants':
    'Subvention et revenus : ',
  'withdrawalApplication.reviewDetailsSection.contributions': 'Cotisations : ',
  'withdrawalApplication.reviewDetailsSection.to': 'À :',
  'withdrawalApplication.reviewDetailsSection.note':
    'Veuillez prévoir un délai de 5 à 7 jours pour que le retrait s’affiche à votre compte bancaire. Tout retrait effectué un jour férié ou de fin de semaine sera traité le jour ouvrable suivant.',
  'withdrawalReviewTotalSection.total': 'Total : ',
  'withdrawalReviewPlanSection.title': 'Régime étudiant Embark',
  'withdrawalReviewPlanSection.iconAlt': '',
  'withdrawalReviewPlanSection.from': 'Depuis :',
  'withdrawalReviewPlanSection.familyPlan': 'Régime familial',
  'withdrawalReviewPlanSection.individualPlan': 'Régime individuel',
  'withdrawalReviewProfileSection.title': 'Profil',
  'withdrawalReviewProfileSection.childName': 'Étudiant :',
  'withdrawalReviewProfileSection.canadianResident':
    'Sont-ils résidents canadiens?',
  'withdrawalReviewProfileSection.schoolName': "Nom de l'école :",
  'withdrawalReviewProfileSection.schoolPostalCode': "Code postal de l'école :",
  'withdrawalReviewProfileSection.voe': "Vérification de l'inscription (VoE) :",
  'withdrawalReviewProfileSection.enrolmentType': "Type d'inscription :",
  'withdrawalReviewProfileSection.programType': 'Type de programme :',
  'withdrawalReviewProfileSection.schoolDuration': 'Durée (en années) :',
  'withdrawalReviewProfileSection.programYear': 'Année du programme :',
  'withdrawalReviewProfileSection.startDate': 'Date de début :',
  'withdrawalReviewProfileSection.completedWeeks':
    'Dans les 12 derniers mois, votre enfant a-t-il passé 13 semaines consécutives aux études postsecondaires?',
  'withdrawalApplication.success.headline': 'Retrait en cours!',
  'withdrawalApplication.success.message':
    'Vous avez envoyé avec succès votre demande de retrait de ',
  'withdrawalApplication.success.offers.title': 'Continuons avec l’offre.',
  'withdrawalApplication.howMuchWithdrawaldialog.content.title':
    'Des frais de scolarité au coût des manuels en passant par le loyer et plus encore, les frais associés aux études postsecondaires s’accumulent. Voici ce qu’il faut savoir avant d’effectuer un retrait.',
  'withdrawalApplication.howMuchWithdrawaldialog.body.types':
    'Il existe deux types de fonds dans un REEE : ',
  'withdrawalApplication.howMuchWithdrawaldialog.body.list.eap': 'PAE : ',
  'withdrawalApplication.howMuchWithdrawaldialog.body.list.pse': 'PSE : ',
  'withdrawalApplication.howMuchWithdrawaldialog.body.list.one':
    'Subventions gouvernementales et gains de placement',
  'withdrawalApplication.howMuchWithdrawaldialog.body.list.two':
    ' Vos propres cotisations',
  'withdrawalApplication.howMuchWithdrawaldialog.body.recommend':
    'Nous vous recommandons d’utiliser d’abord vos PAE pour éviter de perdre des subventions inutilisées. (Vous pouvez retirer vos cotisations à tout moment.)',
  'withdrawalApplication.howMuchWithdrawaldialog.body.default':
    'Par défaut, les PAE sont retirés en premier lieu, mais vous pouvez modifier cette configuration si vous le voulez.',
  'withdrawalApplication.howMuchWithdrawaldialog.body.cesg':
    'Limite de la SCEE :',
  'withdrawalApplication.howMuchWithdrawaldialog.body.cesg.content':
    'Les subventions gouvernementales s’élèvent à un plafond de 7 200 $ par enfant. Si vous dépassez la limite, vous devrez rembourser le montant supplémentaire.',
  'withdrawalApplication.howMuchWithdrawaldialog.body.matters':
    'Cette restriction peut s’avérer importante si vous avez : ',
  'withdrawalApplication.howMuchWithdrawaldialog.body.matters.one':
    'Plusieurs REEE',
  'withdrawalApplication.howMuchWithdrawaldialog.body.matters.two':
    'Un régime familial comprenant plus d’un enfant',
  'withdrawalApplication.howMuchWithdrawaldialog.done': 'Terminé',
  'kycCard.info':
    'Les organismes de réglementation canadiens exigent que nous recueillions ces renseignements dans le cadre de nos obligations de connaissance du client. Vos données sont en sécurité et ne seront jamais partagées par Embark.',
  'kycCard.info.alt': 'Icône de notification',
  'VOEInfoDialog.title': 'Qu’est-ce qu’une CDA?',
  'VOEInfoDialog.content.one.body':
    'Une CDA (abréviation du terme « confirmation de l’admission ») est un document fourni par l’établissement qui confirme l’inscription de votre enfant. Vous en aurez besoin pour poursuivre.',
  'VOEInfoDialog.content.two.header': 'Où trouver la CDA?',
  'VOEInfoDialog.content.two.body':
    'La plupart des établissements incluent une CDA dans le profil de l’étudiant. Si ce n’est pas le cas, vous pouvez habituellement en faire la demande auprès du bureau du registraire ou des services aux étudiants.',
  'VOEInfoDialog.content.three.header': 'Pour être acceptée, votre CDA doit :',
  'VOEInfoDialog.content.three.item.one':
    'Avoir été émise par votre établissement et être imprimée sur son papier à en-tête officiel.',
  'VOEInfoDialog.content.three.item.two':
    'Avoir été émise dans les six derniers mois.',
  'VOEInfoDialog.content.four.header': 'Une CDA n’est pas :',
  'VOEInfoDialog.content.four.item.one': 'Une lettre d’acceptation.',
  'VOEInfoDialog.content.four.item.two':
    'Un relevé de notes, une facture de frais de scolarité ou un horaire de cours.',
  'VOEInfoDialog.content.five.header': 'Voir un exemple de CDA :',
  'VOEInfoDialog.content.five.body':
    'Sélectionnez votre établissement dans le menu déroulant et un exemple de CDA valide s’affichera.',
  'VOEInfoDialog.done': 'Terminé',
  'withdrawalOutage.title': 'Mise à jour du système planifiée',
  'withdrawalOutage.message':
    'En raison d’une mise à jour de notre système de retrait, le service n’est pas disponible pour le moment. Vous pourrez effectuer votre retrait à compter du 26 septembre.',
  'withdrawalOutage.alt': 'Icône de panne de retrait',
  'withdrawalOutage.footer.descriptionOne':
    'Si votre demande est urgente, veuillez nous appeler au ',
  'withdrawalOutage.footer.descriptionPhone': '1-800-363-7377',
  'withdrawalOutage.footer.descriptionTwo':
    '. Remarque : les délais d’attente sont plus longs qu’à l’habitude, il est possible que joindre un représentant nécessite un peu plus de temps.',
  'costOfSchoolEntry.headline.text1':
    'Découvrons à combien s’élèvera le coût des études de ',
  'costOfSchoolEntry.headline.text2': 'votre enfant',
  'costOfSchoolEntry.content':
    'En savoir plus sur les frais de scolarité et les autres dépenses connexes.',
  'costOfSchool.start': 'Commencer',
  'costOfSchool.createdBy': 'Créé par ',
  'costOfSchoolEntry.largeCircle.alt': 'grande icône de cercle',
  'costOfSchoolEntry.smallCircle.alt': 'icône de petit cercle',
  'costOfSchoolEntry.diamond.alt': 'icône de diamant',
  'costOfSchoolEntry.mainImg.alt': 'icône de calcul',
  'onboardingRiskProfile.description.conservative':
    'Vous avez une aversion pour le risque et vous préférez vous concentrer sur la protection de votre épargne plutôt que sur la croissance de vos placements.',
  'onboardingRiskProfile.description.moderate':
    'Vous souhaitez équilibrer la croissance de vos placements et la protection de votre épargne. Vous êtes prêt à prendre plus de risques que ceux que présentent les régimes prudents pour obtenir plus de rendements.',
  'onboardingRiskProfile.description.balanced':
    'Vous êtes prêt à accepter un niveau de risque moyen. Vous voulez bénéficier d’une croissance de vos placements à long terme, mais vous comprenez que vous pourriez subir des pertes pendant les replis du marché.',
  'onboardingRiskProfile.description.grow':
    'Vous voulez obtenir des rendements élevés à long terme et, par conséquent, vous êtes prêt à accepter un potentiel plus important de pertes à court terme pendant les replis du marché.',
  'onboardingRiskProfile.description.aggressive':
    'Vous voulez obtenir les rendements les plus élevés à long terme et, par conséquent, vous êtes prêt à accepter un potentiel important de pertes à court terme pendant les replis du marché.',
  'termsConditions.investmentDecision':
    "Je reconnais que je suis (ou que mon titulaire de compte conjoint est) responsable de la décision de placement pour ce compte, et qu'un tiers ne donne pas d'instructions sur les opérations dans mon compte.",
  'portfolioDetails.goToButton': 'Détails du portefeuille',
  'portfolioBalancesDetails.cesg':
    'Subvention canadienne pour l’épargne-études (SCEE)',
  'portfolioBalancesDetails.clb': 'Bon d’études canadien (BEC)',
  'portfolioBalancesDetails.bctesg':
    'Subvention pour l’épargne-études et l’épargne-formation de la Colombie-Britannique (SEEEFCB)',
  'portfolioBalancesDetails.qesi':
    'Incitatif québécois à l’épargne-études (IQEE)',
  'portfolioBalancesDetails.grants': 'Subventions gouvernementales',
  'portfolioBalancesDetails.contributions': 'Cotisations',
  'portfolioBalancesDetails.income': 'Revenus',
  'portfolioDetails.headline': 'Détails du portefeuille',
  'portfolioDetails.titleContent': 'Épargne totale',
  'portfolioDetails.incomeInfoPopupTitle': 'Revenus',
  'portfolioDetails.incomeInfoPopup':
    'Le revenu est le montant gagné au moyen du placement de vos cotisations et des subventions gouvernementales, y compris les dividendes et les intérêts qui sont réinvestis. Cette valeur fluctuera en fonction de la valeur marchande de votre plan (la valeur en dollars de ce que le plan obtiendrait sur un marché financier à un moment précis).',
  'portfolioDetails.chartContributions': 'Cotisations',
  'portfolioDetails.chartGrants': 'Subventions',
  'portfolioDetails.chartIncome': 'Revenus',
  whyDoWeAskThis: 'Why do we ask this?',
  'onboarding.IDVGateway.label': 'Identity verification',
  'onboarding.IDVGateway.headline': 'Prepare your ID and SIN',
  'onboarding.IDVGateway.documents.head':
    'Have one of the following documents ready for ID verification:',
  'onboarding.IDVGateway.documents.DriverLicense': 'Permis de conduire',
  'onboarding.IDVGateway.documents.Passport': 'Passeport',
  'onboarding.IDVGateway.documents.PRCard': 'Carte de résident permanent',
  'onboarding.IDVGateway.SIN.head': 'You’ll need the following documents:',
  'onboarding.IDVGateway.SIN.yourSIN': 'Your Social Insurance Number (SIN)',
  'onboarding.IDVGateway.SIN.yourChildSIN':
    'Your child’s SIN as per CRA requirements',
  'onboarding.IDVGateway.Note':
    'Don’t have everything on hand? We’ll make sure to save your progress.',
  'onboarding.investmentProfile': 'Profil d’investissement',
  'setReminder.title': 'Programmer un rappel',
  'setReminder.body':
    'Si vous ne disposez pas encore de tous les renseignements, pas de problème. Vous pouvez programmer un rappel et terminer la demande plus tard.',
  'setReminder.imgAlt': 'Un rappel',
  'setReminder.CTA': 'Programmer un rappel',
  'cosubscriberRelationship.cantContinue.header':
    'Désolé, vous ne pouvez pas être titulaire d’un compte joint',
  'cosubscriberRelationship.cantContinue.description1':
    'Les titulaires de comptes joints doivent être des époux ou des conjoints de fait.',
  'cosubscriberRelationship.cantContinue.description2':
    'Découvrez nos plans et ouvrez votre propre compte REEE dès maintenant!',
  'cosubscriberRelationship.cantContinue.goToDashboard':
    'Accéder au tableau de bord',
  'reviewSection.reviewAlert':
    'Veuillez examiner et remplir votre profil de placement pour vous assurer que tous les détails sont fournis.',
  'profile.KYC.header.quickReview': 'Faisons un bref examen de votre profil',
  'profile.KYC.body':
    'Avant de poursuivre, nous devons confirmer les renseignements personnels et financiers. Des modifications apportées aux profils d’investissement ou de risque peuvent nécessiter une réévaluation du régime.',
  'setAReminder.header': 'Programmer un rappel',
  'setAReminder.setReminderBody':
    'Nous vous enverrons un courriel à partir duquel vous pourrez revenir à la demande lorsque vous aurez tous les renseignements concernant votre enfant.',
  'setAReminder.editReminderBody':
    'Vous avez programmé un rappel. Vous pouvez le modifier ou l’annuler en tout temps.',
  'setAReminder.CTA': 'Programmer un rappel',
  'setAReminder.apply': 'Appliquer',
  'setAReminder.cancelReminder': 'Annuler le rappel',
  'setAReminder.cancelConfirmDialog.title':
    'Êtes-vous sûr de vouloir annuler votre rappel?',
  'setAReminder.cancelConfirmDialog.confirmLabel': 'Non, je veux continuer',
  'setAReminder.cancelConfirmDialog.cancelLabel': 'Oui, annuler',
  oneWeekReminder: '1 semaine',
  twoWeeksReminder: '2 semaines',
  customReminder: 'Personnalisé',
  'setAReminder.popup.header': 'Un rappel a été programmé',
  'setAReminder.popup.body': 'Souhaitez-vous le modifier?',
  'setAReminder.popup.yesEdit': 'Oui, modifier',
  'setAReminder.popup.noCancel': 'Non, annuler',
  'withdrawalGateway.stepperHeader': 'Retirer des fonds',
  'withdrawalGateway.headline': 'C’est la rentrée!',
  'withdrawalGateway.description':
    'Félicitations pour l’inscription de votre enfant aux études postsecondaires! C’est le moment de retirer des fonds pour payer les frais de scolarité et de logement et les coûts des manuels, des fournitures scolaires, du transport et d’autres indispensables.',
  'withdrawalGateway.footerText.firstPart':
    'Vous voulez faire un retrait pour des dépenses personnelles ou non destinées aux études? Effectuez un retrait à titre de',
  'withdrawalGateway.footerText.link': 'paiement de revenu accumulé (PRA).',
  'withdrawalGateway.footerText.secondPart': '',
  'withdrawalGateway.img.alt': "Icône d'information",
  'withdrawalGateway.popup.header':
    'Qu’est-ce qu’un paiement de revenu accumulé (PRA)?',
  'withdrawalGateway.popup.description.sectionOne':
    'Un PRA vous permet de retirer le revenu accumulé sur votre REEE si votre enfant n’est pas inscrit à un programme d’études postsecondaires et n’a pas l’intention de s’y inscrire d’ici l’échéance du REEE. Il s’agit d’une option à votre disposition si vos bénéficiaires ne fréquentent pas un établissement d’enseignement désigné et que vous souhaitez accéder au revenu de votre REEE.',
  'withdrawalGateway.popup.description.sectionTwo.one':
    'Avant de demander un PRA, envisagez de ',
  'withdrawalGateway.popup.description.sectionTwo.two':
    ' si un autre membre de votre famille a l’intention de continuer ses études.',
  'withdrawalGateway.popup.description.sectionTwo.link':
    'remplacer vos bénéficiaires',
  'withdrawalGateway.popup.description.sectionTwo.linkURL':
    'https://www.embark.ca/fr/retirer-des-fonds',
  'withdrawalGateway.popup.description.sectionThree':
    'Les retraits à titre de PRA sont imposés au taux habituel, auquel s’ajoute un impôt fédéral supplémentaire de 20 %. Si vous transférez le PRA à un REER, vous recevrez un relevé d’impôt de la part d’Embark et de votre fournisseur de REER. Le relevé d’impôt de votre fournisseur de REER aura préséance sur celui d’Embark. Si vous avez besoin de conseils personnalisés, nous vous recommandons de consulter un fiscaliste.',
  'transferIn.tAndC.stepperHeader': 'Transférer un REEE vers un régime Embark',
  'transferIn.details.stepperHeader': 'Détails du transfert',
  'transferIn.estimatedAmount.stepperHeader': 'Montant estimé',
  'transferIn.planSelect.stepperHeader': 'Régime Embark',
  'transferIn.planSelect.stepperHeader.addPlan': 'Créer un régime',
  'transferIn.review.stepperHeader': 'Évaluation',
  'transferIn.tAndC.headline':
    'Voici quelques éléments importants à savoir avant de procéder au transfert :',
  'transferIn.details.headline': 'D’où effectuez-vous le transfert?',
  'transferIn.details.description':
    'Veuillez vous assurer que les enfants sélectionnés pour le régime choisi correspondent à ceux inscrits dans le REEE détenu auprès de votre institution financière actuelle. Consultez votre relevé de compte pour confirmer les renseignements.',
  'transferIn.planSelect.description.addPlan.partOne':
    'Il semble que vous n’avez pas de régime REEE.',
  'transferIn.planSelect.description.addPlan.partTwo':
    'Pour nous transférer votre REEE d’un autre fournisseur, vous devez d’abord ouvrir un REEE Embark. Cela ne prend que quelques minutes, et nous vous guiderons étape par étape.',
  'transferIn.details.institute.label': 'Institution financière',
  'transferIn.details.instituteRequiredError':
    'Choisissez une institution financière.',
  'transferIn.details.financialInstitution.label':
    'Nom d’une institution financière',
  'transferIn.details.institutionNameRequiredError':
    'Indiquez une institution financière.',
  'transferIn.details.institutionNameCharError':
    'Les caractères accentués ne sont pas acceptés dans les champs de saisie des formulaires.',
  'transferIn.details.planNumber.label': 'Numéro du régime',
  'transferIn.details.planNumbarRequiredError':
    'Saisissez un numéro de régime.',
  'transferIn.details.planNumberLengthError': '40 caractères au maximum',
  'transferIn.details.planNumberCharError': 'Numéro de régime invalide.',
  'transferIn.details.addressField.header':
    'Adresse de l’institution financière',
  'transferIn.details.addressField.placeholder':
    'Commencez à saisir votre adresse.',
  'transferIn.details.representative.title': 'Représentant ',
  'transferIn.details.representative.title.optional': '(facultatif)',
  'transferIn.details.representative.description':
    'Fournissez les coordonnées de votre représentant ou conseiller si vous en avez un dans votre institution actuelle.',
  'transferIn.details.representative.name': 'Nom de la personne-ressource',
  'transferIn.details.representative.contactNumber':
    'Numéro de téléphone de la personne-ressource',
  'transferIn.details.representative.email': 'Adresse courriel',
  'transferIn.details.representative.emailError':
    'Indiquez une adresse de courriel enregistrée.',
  'transferIn.tAndC.helper.text1':
    'Nous couvrirons vos frais de transfert jusqu’à concurrence de 150 $ pour chaque régime que vous transférez. La présente offre est assujettie aux',
  'transferIn.tAndC.helper.text1.linkText': 'conditions générales',
  'transferIn.tAndC.helper.text1.link':
    'https://www.embark.ca/fr/conditions-generales-de-prime-de-transfert-entrant-et-de-depot',
  'transferIn.tAndC.helper.text2':
    'Les enfants inscrits à votre régime auprès de votre institution financière actuelle doivent être les mêmes que ceux inscrits à votre REEE auprès d’Embark. Si votre régime comprend un cosouscripteur, celui-ci devra également être présent pour signer.',
  'transferIn.tAndC.helper.text3':
    'Conformément aux exigences de l’Agence du revenu du Canada (ARC), les REEE peuvent demeurer ouverts jusqu’à 35 ans après leur ouverture. Si vous effectuez un transfert depuis un autre fournisseur, la date d’entrée en vigueur initiale du premier régime s’appliquera par la suite à tous les fonds du nouveau régime.',
  'transferIn.tAndC.helper.text4':
    'Selon votre institution financière actuelle, le transfert de vos actifs peut prendre de 60 à 90 jours, voire davantage.',
  'transferIn.estimatedAmount.headline':
    'Quel montant souhaitez-vous transférer?',
  'transferIn.estimatedAmount.text':
    'Cela nous aide à confirmer le montant lors du versement et à effectuer le suivi en cas de souci.',
  'transferIn.estimatedAmount.infoText':
    'Nous paierons les frais de transfert sortant de votre banque pour tout transfert de plus de 5 000 $.',
  'transferIn.estimatedAmount.tAndCLink': 'Conditions générales',
  'transferIn.estimatedAmount.tAndCLink.URL':
    'https://www.embark.ca/fr/conditions-generales-de-prime-de-transfert-entrant-et-de-depot',
  'transferIn.instructions.headline': 'Suivez les étapes ci-dessous :',
  'transferIn.instructions.list.header':
    'Suivez les étapes ci-dessous pour effectuer votre transfert:',
  'transferIn.instructions.list.item1':
    'Téléchargez le formulaire de transfert.',
  'transferIn.instructions.list.item2':
    'Vérifiez vos renseignements et imprimez le formulaire.',
  'transferIn.instructions.list.item3':
    'Signez le formulaire à la main (votre institution actuelle exige une signature physique).',
  'transferIn.instructions.list.item4':
    'Numérisez le formulaire signé et envoyez-le par courriel à ',
  'transferIn.instructions.list.item4.email': 'contact@embark.ca.',
  'transferIn.instructions.list.hasSignature.item2':
    'Vérifiez vos renseignements et signez le document.',
  'transferIn.instructions.list.hasSignature.item3':
    'Sauvegardez le formulaire signé et envoyez-le par courriel à ',
  'transferIn.instructions.content':
    'Vous pouvez toujours retrouver le formulaire dans la section « Documents » de votre profil.',
  'transferIn.instructions.icon.alt': 'Trandfer in info Icon',
  'transferIn.instructions.infoText.note': 'Remarque : ',
  'transferIn.instructions.infoText':
    'Les transferts prennent généralement de 60 à 90 jours pour être complétés. Nous vous tiendrons informé tout au long du processus.',
  'transferIn.downlaodForm.img.alt': "Télécharger l'icône du formulair",
  'transferIn.downlaodForm.headline':
    'Téléchargez le formulaire et passez aux étapes suivantes',
  'transferIn.downlaodForm.description':
    'Une fois le formulaire rempli et retourné, le traitement du transfert prend généralement de 60 à 90 jours.',
  'transferIn.downlaodForm.cta.text': 'Télécharger et continuer',
  'transferIn.planSelect.headline':
    'Vers quel régime Embark effectuez-vous le transfert?',
  'transferIn.planSelect.description':
    'Les enfants inscrits à votre REEE actuel doivent correspondre à ceux du nouveau REEE. Sinon, veuillez ouvrir un nouveau régime.',
  'transferIn.planSelect.addPlan.linkText': 'Ajouter un régime',
  'transferIn.review.headline': 'Détails du transfert',
  'transferIn.review.headline.img.alt': 'Transfer details Icon',
  'transferIn.review.planselection.lable':
    'Vers quel régime Embark effectuez-vous le transfert?',
  'transferIn.review.details.lable': 'D’où effectuez-vous le transfert?',
  'transferIn.review.address.lable': 'Adresse de l’institution financière',
  'transferIn.review.representative.lable':
    'Renseignements sur le représentant',
  'transferIn.review.estimatedAmount.lable': 'Montant estimé',
  'transferIn.transferInStatus.title': 'Transfert de REEE',
  'transferIn.transferInStatus.stepperIcon.alt': 'Icône pas à pas',
  'transferIn.transferInStatus.stepper.underReview': 'En cours d’examen',
  'transferIn.transferInStatus.stepper.cancelled': 'Annulé',
  'transferIn.transferInStatus.stepper.attentionRequired': 'Attention requise',
  'transferIn.transferInStatus.stepper.actionRequired': 'Mesure à prendre',
  'transferIn.transferInStatus.stepper.complete': 'Terminé',
  'transferIn.transferInStatus.stepper.inProgress': 'En cours',
  'transferIn.transferInStatus.stepper.requestCancelled': 'Demande annulée',
  'transferIn.transferInStatus.transferInDetails.header': 'Détails',
  'transferIn.transferInStatus.transferInDetails.amount': 'Montant estimé',
  'transferIn.transferInStatus.transferInDetails.planTo':
    'Vers quel régime Embark effectuez-vous le transfert?',
  'transferIn.transferInStatus.transferInDetails.institution':
    'Institution financière',
  'transferIn.transferInStatus.transferInDetails.planFrom': 'Numéro du régime',
  'transferIn.transferInStatus.transferInDetails.address': 'Adresse',
  'transferIn.transferInStatus.transferInDetails.download': 'Télécharger',
  'transferIn.transferInStatus.transferInDetails.representative':
    'Renseignements sur le représentant',
  'transferIn.transferInStatus.transferInDetails.eSign.header':
    'Signature requise',
  'transferIn.transferInStatus.transferInDetails.physicalSign.header':
    'Signature physique requise',
  'transferIn.transferInStatus.transferInDetails.eSign.details':
    'Nous n’avons pas reçu votre formulaire de transfert signé. Veuillez lire le formulaire ci-joint, le signer et l’envoyer par courriel à ',
  'transferIn.transferInStatus.transferInDetails.physicalSign.details':
    'Votre institution actuelle exige que vous signiez ce document à la main. Veuillez passer en revue le formulaire ci-joint, le signer et l’envoyer par courriel à ',
  'transferIn.transferInStatus.transferInDetails.inProgress.details':
    'Les transferts prennent généralement de 60 à 90 jours pour être complétés. Nous vous tiendrons informé tout au long du processus.',
  'newDashboard.selectPlan.header': 'Quel régime vous convient le mieux?',
  'newDashboard.selectPlan.subheader':
    'Chez Embark, nous facilitons l’épargne-études de votre ou de vos enfants.',
  'newDashboard.selectPlan.family.header': 'Régime familial',
  'newDashboard.selectPlan.family.subheader1': 'Épargne partagée',
  'newDashboard.selectPlan.family.body1':
    'Vos enfants peuvent partager leurs cotisations, leurs subventions et leurs revenus, jusqu’à concurrence de 7 200 $ de la Subvention canadienne pour l’épargne-études (SCEE).',
  'newDashboard.selectPlan.family.subheader2':
    'Pour les parents ou les grands-parents',
  'newDashboard.selectPlan.family.body2':
    'Idéal pour les parents ou les grands-parents qui épargnent pour leurs enfants ou leurs petits-enfants (les enfants inclus dans le régime doivent être des frères et sœurs par le sang ou l’adoption).',
  'newDashboard.selectPlan.family.subheader3':
    'Ajoutez facilement des frères et sœurs.',
  'newDashboard.selectPlan.family.body3':
    'Ajoutez ou changez des frères et sœurs à mesure que votre famille grandit.',
  'newDashboard.selectPlan.cta': 'Commençons ensemble',
  'newDashboard.selectPlan.individual.header': 'Régime individuel',
  'newDashboard.selectPlan.individual.subheader1':
    'Fonctionnalité principale :',
  'newDashboard.selectPlan.individual.body1':
    'Il n’est pas nécessaire d’avoir un lien de parenté direct avec l’enfant.',
  'newDashboard.selectPlan.individual.body2':
    'Idéal pour les tantes, les oncles ou d’autres personnes non apparentées.',
  'newDashboard.selectPlan.list.header':
    'Tous les régimes comprennent ce qui suit :',
  'newDashboard.selectPlan.list.item1':
    'Aucuns frais initiaux ni frais cachés;',
  'newDashboard.selectPlan.list.item2':
    'Des frais de gestion très concurrentiels;',
  'newDashboard.selectPlan.list.item3':
    'Une répartition d’actifs personnalisée selon l’âge de chaque enfant;',
  'newDashboard.selectPlan.list.item4':
    'Un accès à toutes les subventions gouvernementales pertinentes pouvant atteindre 7 200 $*;',
  'newDashboard.selectPlan.list.item5':
    'Des partenaires de confiance qui détiennent et gèrent tous vos fonds.',
  'aipFormsLabels.ipAddress': 'Adresse IP',
  'expectingDueDate.title': 'Indiquez la date prévue de naissance',
  'expectingDueDate.body.p1':
    'Votre REEE avance! Lorsque votre enfant arrivera (bonjour, futur universitaire), envoyez-nous simplement son NAS, et nous verseront une ',
  'expectingDueDate.body.p2': 'première cotisation de ',
  'expectingDueDate.body.p3':
    ' Ajoutez la date prévue de naissance, et nous vous enverrons un rappel amical au moment opportun.',
  'expectingDueDate.fieldsLabel': 'Date prévue de naissance',
  'expectingDueDate.primaryCta': 'Préciser la date prévue de naissance',
  'expectingDueDate.secondaryCta': 'Explorer mon tableau de bord',
  'expectingDueDate.alert.p1': 'Date prévue de naissance sauvegardée : ',
  'expectingDueDate.alert.p2': ' Vous pouvez la modifier en tout temps.',
  'expectingDueDate.monthError': 'Saisissez un mois.',
  'expectingDueDate.yearError': 'Saisissez une année.',
  whatsYourSourceOfIncome: 'Quelle est votre source de revenus?',
  sourceOfIncome: 'Source de revenus',
  canadaChildBenefit: 'Allocation canadienne pour enfants (ACE)',
  savings: 'Épargne',
  socialAssistanceAllowance: 'Aide/prestations sociales',
  maternityPaternityLeave: 'Congé de maternité/paternité',
  familySupport: 'Aide aux familles',
  otherPleaseDescribe: 'Autre (veuillez décrire)',
  pleaseEnterYourSourceOfIncome: 'Veuillez entrer votre source de revenus.',
  sourceOfIncomeMaxLength:
    'La source de revenus ne peut pas dépasser 30 caractères.',
  onlyAlphanumericIsAllowed: "N'utilisez que des caractères alphanumériques",
  'settings.profile.address': 'Adresse:',
  electronicDeliveryTaxDocuments:
    'Livraison électronique des documents fiscaux',
  investmentProfile: 'Profil d’investissement'
};
